export const SwaggerKSASpec = {
 "openapi": "3.0.0",
  "info": {
    "title": "PepsiCo CEP KSA API",
    "description": "PepsiCo Consumer Engagement Platform KSA API",
    "version": "0.0.4",
    "contact": {
      "name": "PepsiCo CEP API"
    }
  },
  "servers": [
    {
      "url": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/api/v2"
    }
  ],
  "paths": {
    "/account": {
      "get": {
        "tags": [
          "Account"
        ],
        "summary": "Account Details",
        "description": "Account Details",
        "parameters": [
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "metadata": {
                        "__comment": "Info about the JSON File.",
                        "itemKey": "customers",
                        "totalItems": 6
                    },
                    "customers": {
                        "id": 8680,
                        "externalId": null,
                        "isActive": null,
                        "creditBlock": null,
                        "creditLimitAmount": null,
                        "userId": "rohit.bhatt.contractor@pepsico.com",
                        "role": "Customer",
                        "memberType": "",
                        "firstName": "Rohit",
                        "lastName": "Bhatt",
                        "username": null,
                        "profileImgUrl": null,
                        "dob": "05/01/1994",
                        "deviceToken": "e79c2b66222a956ce04625b22e3cad3a63e91f34b1a21213a458fadb2b459385",
                        "loginExpiryDate": null,
                        "maid": "8907TYU5",
                        "deviceType": "Android",
                        "email": "rohit.bhatt.contractor@pepsico.com",
                        "phone": "8171820974",
                        "gender": "M",
                        "emailVerifyStatus": "Not Verified",
                        "mobileVerifyStatus": "Verified",
                        "alternateNumber": null,
                        "contact": {
                            "default": true,
                            "isStore": false,
                            "name": null,
                            "permissions": null,
                            "profileStatus": null,
                            "addresses": [
                                {
                                    "name": null,
                                    "isdefault": true,
                                    "position": 0,
                                    "type": null,
                                    "buildingNumber": null,
                                    "addressLine1": null,
                                    "addressLine2": null,
                                    "province": null,
                                    "city": "Riyadh Al Khabra",
                                    "district": null,
                                    "state": null,
                                    "country": null,
                                    "postalCode": "51961",
                                    "taxAreaCode": null,
                                    "phoneNumber": null
                                }
                            ]
                        },
                        "conatact": {
                            "points": null,
                            "lifetimePoints": null
                        },
                        "termsAccepted": [],
                        "preferences": {
                            "accessType": null,
                            "businessType": null,
                            "executionType": null,
                            "smsPermission": "NewOrder;OrderStatusChanged;OrderCancelled",
                            "whatsappPermission": null,
                            "emailPermission": "OrderShipped;OrderStatusChanged;OrderCancelled",
                            "pushNotificationPermission": "OrderCancelled",
                            "cookiePermission": null,
                            "obtainPermission": null
                        },
                        "completeProfileBonusPoints": "50",
                        "IsCompleteProfle": false
                    }
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      },
      "post": {
        "tags": ["Account"],
        "summary": "Account Registration Update",
        "description": "Create or update account data.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": false, "schema": {"type": "string"}}
        ],
        "requestBody": {"required": true, "content": {"application/json": {"schema": {"type": "object"}}}},
        "responses": {"200": {"description": "OK"}}
      },
      "put": {
        "tags": [
          "Account"
        ],
        "summary": "Account Update",
        "description": "Account Update",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "object",
                "properties": {
                  "id": {
                    "type": "object"
                  }
                }
              },
              "example": {
                "firstName": "Rohit",
                "lastName": "Bhatt",
                "dob": "01/05/1994",
                "maid":"8907TYU5",
                "gender":"M",
                "notificationSettings": {
                  "SMS": [
                    "NewOrder",
                    "OrderStatusChanged",
                    "OrderCancelled"
                  ],
                  "Email": [
                    "OrderShipped",
                    "OrderStatusChanged",
                    "OrderCancelled"
                  ],
                   "PushNotification": [
                       "OrderCancelled"
                  ]
                },
                 "termsAccepted": [
                  "Term1",
                  "Term2"
                ],
              "customAddress":
              {
              "isdefault": true,
              "position": 0,
              "city": "Riyadh Al Khabra",
              "postalCode": "51961"
              } 
              }
            }
          }
        },
        "parameters": [
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "metadata": {
                        "__comment": "Info about the JSON File.",
                        "itemKey": "customers",
                        "totalItems": 6
                    },
                    "customers": {
                        "id": 8680,
                        "externalId": null,
                        "isActive": null,
                        "creditBlock": null,
                        "creditLimitAmount": null,
                        "userId": "rohit.bhatt.contractor@pepsico.com",
                        "role": "Customer",
                        "memberType": "",
                        "firstName": "Rohit",
                        "lastName": "Bhatt",
                        "username": null,
                        "profileImgUrl": null,
                        "dob": "05/01/1994",
                        "deviceToken": "e79c2b66222a956ce04625b22e3cad3a63e91f34b1a21213a458fadb2b459385",
                        "loginExpiryDate": null,
                        "maid": "8907TYU5",
                        "deviceType": "Android",
                        "email": "rohit.bhatt.contractor@pepsico.com",
                        "phone": "8171820974",
                        "gender": "M",
                        "emailVerifyStatus": "Not Verified",
                        "mobileVerifyStatus": "Verified",
                        "alternateNumber": null,
                        "contact": {
                            "default": true,
                            "isStore": false,
                            "name": null,
                            "permissions": null,
                            "profileStatus": null,
                            "addresses": [
                                {
                                    "name": null,
                                    "isdefault": true,
                                    "position": 0,
                                    "type": null,
                                    "buildingNumber": null,
                                    "addressLine1": null,
                                    "addressLine2": null,
                                    "province": null,
                                    "city": "Riyadh Al Khabra",
                                    "district": null,
                                    "state": null,
                                    "country": null,
                                    "postalCode": "51961",
                                    "taxAreaCode": null,
                                    "phoneNumber": null
                                }
                            ]
                        },
                        "conatact": {
                            "points": null,
                            "lifetimePoints": null
                        },
                        "termsAccepted": [],
                        "preferences": {
                            "accessType": null,
                            "businessType": null,
                            "executionType": null,
                            "smsPermission": "NewOrder;OrderStatusChanged;OrderCancelled",
                            "whatsappPermission": null,
                            "emailPermission": "OrderShipped;OrderStatusChanged;OrderCancelled",
                            "pushNotificationPermission": "OrderCancelled",
                            "cookiePermission": null,
                            "obtainPermission": null
                        },
                        "completeProfileBonusPoints": "50",
                        "IsCompleteProfle": false
                    }
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/auth": {
        "post": {
            "tags": [
              "Account"
            ],
            "summary": "Account Sign Up",
            "description": "Sign Up for new Account",
            "requestBody": {
              "content": {
                "application/json": {
                  "schema": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "object"
                      }
                    }
                  },
                  "example": {
                    "profile": {
                      "userId": "8171820974",
                      "firstName": "",
                      "lastName": "",
                      "role": "Customer",
                      "dob": "",
                      "deviceToken": "e79c2b66222a956ce04625b22e3cad3a63e91f34b1a21213a458fadb2b459385",
                      "deviceType": "Android",
                      "mobilePhone":"8171820974"
                    },
                    "addresses": [
                      {
                        "default": true,
                        "isStore": false,
                        "billingType": "soldTo",
                        "postalCode": "51961",
                        "city": "Riyadh Al Khabra"
                      }
                    ]
                  }
                }
              }
            },
            "parameters": [
              {
                "name": "SiteId",
                "in": "header",
                "required": true,
                "description": "SiteId",
                "schema": {
                  "type": "number",
                  "default": 10
                }
              },
              {
                "name": "okta-accesstoken",
                "in": "header",
                "required": true,
                "description": "okta-accesstoken",
                "schema": {
                  "type": "string",
                  "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
                }
              }
            ],
            "responses": {
              "200": {
                "description": "OK",
                "content": {
                  "application/json": {
                    "example": {
                        "success": true,
                        "msg": "User registered Successfully."
                    }
                  }
                }
              },
              "400": {
                "description": "Bad Request",
                "content": {
                  "*/*": {
                    "schema": {
                      "$ref": "#/components/schemas/ErrorMessage"
                    }
                  }
                }
              },
              "415": {
                "description": "Unsupported Media Type",
                "content": {
                  "*/*": {
                    "schema": {
                      "$ref": "#/components/schemas/ErrorMessage"
                    }
                  }
                }
              },
              "500": {
                "description": "Internal Server Error",
                "content": {
                  "*/*": {
                    "schema": {
                      "$ref": "#/components/schemas/Problem"
                    }
                  }
                }
              }
            }
          },
        "delete": {
          "tags": ["Authentication"],
          "summary": "Delete Account",
          "description": "Delete the authenticated account.",
          "parameters": [
            {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
            {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}
          ],
          "responses": {"200": {"description": "OK"}}
        }
    },
    "/auth/validateEmailMobile": {
        "post": {
            "tags": [
              "Account"
            ],
            "summary": "Validate Mobile/Email",
            "description": "Validate Mobile/Email of Account",
            "requestBody": {
              "content": {
                "application/json": {
                  "schema": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "object"
                      }
                    }
                  },
                  "example": {
                    "userId": "rohit.bhatt.contractor@pepsico.com",
                    "mobile": "8171820974",
                    "userType":"Both"
                    }
                }
              }
            },
            "parameters": [
              {
                "name": "SiteId",
                "in": "header",
                "required": true,
                "description": "SiteId",
                "schema": {
                  "type": "number",
                  "default": 10
                }
              },
              {
                "name": "okta-accesstoken",
                "in": "header",
                "required": true,
                "description": "okta-accesstoken",
                "schema": {
                  "type": "string",
                  "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
                }
              }
            ],
            "responses": {
              "200": {
                "description": "OK",
                "content": {
                  "application/json": {
                    "example": {
                        "success": true,
                        "msg": "Customer is already exists with same email/mobile"
                    }
                  }
                }
              },
              "400": {
                "description": "Bad Request",
                "content": {
                  "*/*": {
                    "schema": {
                      "$ref": "#/components/schemas/ErrorMessage"
                    }
                  }
                }
              },
              "415": {
                "description": "Unsupported Media Type",
                "content": {
                  "*/*": {
                    "schema": {
                      "$ref": "#/components/schemas/ErrorMessage"
                    }
                  }
                }
              },
              "500": {
                "description": "Internal Server Error",
                "content": {
                  "*/*": {
                    "schema": {
                      "$ref": "#/components/schemas/Problem"
                    }
                  }
                }
              }
            }
          }
    },
    "/updatemobile": {
        "put": {
            "tags": [
              "Account"
            ],
            "summary": "Update Mobile",
            "description": "Update Mobile of Account",
            "requestBody": {
              "content": {
                "application/json": {
                  "schema": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "object"
                      }
                    }
                  },
                  "example": {
                    "phone": "8171820974",
                    "reasonToSwich":"I lost my phone test."
                }
                }
              }
            },
            "parameters": [
              {
                "name": "SiteId",
                "in": "header",
                "required": true,
                "description": "SiteId",
                "schema": {
                  "type": "number",
                  "default": 10
                }
              },
              {
                "name": "okta-accesstoken",
                "in": "header",
                "required": true,
                "description": "okta-accesstoken",
                "schema": {
                  "type": "string",
                  "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
                }
              }
            ],
            "responses": {
              "200": {
                "description": "OK",
                "content": {
                  "application/json": {
                    "example": {
                        "success": true,
                        "msg": "User mobile number update successfully."
                    }
                  }
                }
              },
              "400": {
                "description": "Bad Request",
                "content": {
                  "*/*": {
                    "schema": {
                      "$ref": "#/components/schemas/ErrorMessage"
                    }
                  }
                }
              },
              "415": {
                "description": "Unsupported Media Type",
                "content": {
                  "*/*": {
                    "schema": {
                      "$ref": "#/components/schemas/ErrorMessage"
                    }
                  }
                }
              },
              "500": {
                "description": "Internal Server Error",
                "content": {
                  "*/*": {
                    "schema": {
                      "$ref": "#/components/schemas/Problem"
                    }
                  }
                }
              }
            }
          }
    },
    "/auth/resendOtp": {
        "post": {
            "tags": [
              "Account"
            ],
            "summary": "Resend OTP",
            "description": "Re-send OTP on Email/Mobile",
            "requestBody": {
              "content": {
                "application/json": {
                  "schema": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "object"
                      }
                    }
                  },
                  "example": {
                    "otpType":"Email",
                    "userId":"rohit.bhatt.contractor@pepsico.com"
                    }
                }
              }
            },
            "parameters": [
              {
                "name": "SiteId",
                "in": "header",
                "required": true,
                "description": "SiteId",
                "schema": {
                  "type": "number",
                  "default": 10
                }
              },
              {
                "name": "okta-accesstoken",
                "in": "header",
                "required": true,
                "description": "okta-accesstoken",
                "schema": {
                  "type": "string",
                  "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
                }
              }
            ],
            "responses": {
              "200": {
                "description": "OK",
                "content": {
                  "application/json": {
                    "example": {
                        "success": true,
                        "msg": "Verification code sent on rohit.bhatt.contractor@pepsico.com"
                    }
                  }
                }
              },
              "400": {
                "description": "Bad Request",
                "content": {
                  "*/*": {
                    "schema": {
                      "$ref": "#/components/schemas/ErrorMessage"
                    }
                  }
                }
              },
              "415": {
                "description": "Unsupported Media Type",
                "content": {
                  "*/*": {
                    "schema": {
                      "$ref": "#/components/schemas/ErrorMessage"
                    }
                  }
                }
              },
              "500": {
                "description": "Internal Server Error",
                "content": {
                  "*/*": {
                    "schema": {
                      "$ref": "#/components/schemas/Problem"
                    }
                  }
                }
              }
            }
          }
    },
    "/contact": {
        "post": {
            "tags": [
                "Contact"
            ],
            "summary": "Contact Submission",
            "description": "Submit contact us request",
            "requestBody": {
                "content": {
                    "application/json": {
                        "schema": {
                            "type": "object",
                            "properties": {
                                "id": {
                                    "type": "string",
                                    "format": "int64"
                                }
                            }
                        },
                        "example": {
                          "inquiryId": "7448",
                          "type":"My QR code isn't working",
                          "subject":"Facing issue",
                          "message":"Kindly help me."
                        }
                    }
                }
            },
            "parameters": [
                {
                    "name": "SiteId",
                    "in": "header",
                    "required": true,
                    "description": "SiteId",
                    "schema": {
                        "type": "number",
                        "default": 10
                    }
                },
                {
                    "name": "okta-accesstoken",
                    "in": "header",
                    "required": true,
                    "description": "okta-accesstoken",
                    "schema": {
                        "type": "string",
                        "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
                    }
                }
            ],
            "responses": {
                "200": {
                    "description": "OK",
                    "content": {
                        "application/json": {
                            "example": {
                              "success": false,
                              "msg": "(Line 573) Expected response code \"250\" but got code \"554\", with message \"554 5.2.2 Mailbox full. Visit https://aka.ms/mailboxfull for more information.; STOREDRV.Submission.Exception:QuotaExceededException.MapiExceptionShutoffQuotaExceeded; Failed to process message due to a permanent exception with message [BeginDiagnosticData]The process failed to get the correct properties. 0.35250:57010000, 1.36674:06000000, 1.61250:00000000, 1.45378:02000000, 1.44866:0B000000, 1.36674:09000000, 1.61250:00000000, 1.45378:11000000, 1.44866:00010000, 1.36674:08000000, 1.61250:00000000, 1.45378:14000000, 1.44866:00100000, 16.55847:91000000, 17.43559:00000000C0030000000000000000000000000000, 20.52176:140FE1961700001097120000, 20.50032:140FE1968717F01FFE000000, 0.53414:07000000, 0.35180:02013866, 255.23226:0A000000, 255.27962:06000000, 255.17082:DD040000, 0.24929:13000000, 4.21921:DD040000, 255.27962:FA000000, 255.1494:1C000000, 0.38698:05000780, 1.41134:86000000, 7.36354:010000000000010B86000000, 0.34102:86000000, 5.29818:0000000031393630373130392D303366652D346166392D386131362D31383730653163386363376400000000, 5.55446:00000000333A300030384D42, 7.29828:228801C00D000000352D6564, 7.29832:000000800C0000002D636336, 4.45884:DD040000, 4.29880:DD040000, 4.59420:DD040000, 7.49544:010000000000010B39303332, 8.45434:09716019FE03F94A8A161870E1C8CC7D54204672, 1.46798:04000000, 5.10786:0000000031352E32302E353835372E3032333A424E37505230384D42353230343A35316561636161352D656466332D343061392D626534302D6363363434333762326663363A3131393132383A2E4E4554204672616D65776F726B20342E382E393033322E3000104F000000, 7.51330:DB9BF89753D1DA084F000000, 0.39570:0F010480, 1.64146:06000000, 1.33010:06000000, 2.54258:DD040000, 1.33010:06000000, 2.54258:DD040000, 255.1750:8E000000, 255.27962:09000000, 255.17082:B9040000, 0.22369:93000000, 4.21921:B9040000, 255.27962:08000000, 0.26881:9C000000, 255.21817:B9040000, 0.60978:8F000000, 0.36402:A1000000, 4.38450:DD040000, 0.47602:94000000, 4.63986:DD040000, 0.22945:03006E67, 4.31137:DD040000, 0.26529:AB000000, 4.29953:DD040000, 0.32768:03000336, 4.33024:DD040000[EndDiagnosticData] [Hostname=BN7PR08MB5204.namprd08.prod.outlook.com]\"."
                          }
                        }
                    }
                },
                "400": {
                    "description": "Bad Request",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "415": {
                    "description": "Unsupported Media Type",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "500": {
                    "description": "Internal Server Error",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/Problem"
                            }
                        }
                    }
                }
            }
        }
    },
    "/contact/inquiries": {
        "get": {
            "tags": [
                "Contact"
            ],
            "summary": "Contact Inquiries",
            "description": "Returns a list of contact inquiry types",
            "parameters": [
                {
                    "name": "SiteId",
                    "in": "header",
                    "required": true,
                    "description": "SiteId",
                    "schema": {
                        "type": "number",
                        "default": 10
                    }
                },
                {
                    "name": "okta-accesstoken",
                    "in": "header",
                    "required": true,
                    "description": "okta-accesstoken",
                    "schema": {
                        "type": "string",
                        "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
                    }
                }
            ],
            "responses": {
                "200": {
                    "description": "OK",
                    "content": {
                        "application/json": {
                            "example": {
                              "totalCount": 5,
                              "data": [
                                  {
                                      "id": 7450,
                                      "title": {
                                          "en": "I can't redeem my rewards",
                                          "ar_SA": "لا يمكنني استرداد مكافآتي"
                                      }
                                  },
                                  {
                                      "id": 7448,
                                      "title": {
                                          "en": "I have a problem with my account",
                                          "ar_SA": "لدي مشكلة مع حسابي"
                                      }
                                  },
                                  {
                                      "id": 7453,
                                      "title": {
                                          "en": "I need some support using the app",
                                          "ar_SA": "أحتاج إلى بعض الدعم باستخدام التطبيق"
                                      }
                                  },
                                  {
                                      "id": 7452,
                                      "title": {
                                          "en": "I want to share feedback on my app experience",
                                          "ar_SA": "أرغب في مشاركة التعليقات حول تجربة التطبيق الخاصة بي"
                                      }
                                  },
                                  {
                                      "id": 7454,
                                      "title": {
                                          "en": "Other issues",
                                          "ar_SA": "حالات أخرى"
                                      }
                                  }
                              ]
                          }
                        }
                    }
                },
                "400": {
                    "description": "Bad Request",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "415": {
                    "description": "Unsupported Media Type",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "500": {
                    "description": "Internal Server Error",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/Problem"
                            }
                        }
                    }
                }
            }
        }
    },
    "/features": {
      "get": {
        "tags": [
          "Content"
        ],
        "summary": "Features",
        "description": "Global Setting Data",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": false,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "x-api-key",
            "in": "header",
            "required": true,
            "description": "x-api-key",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 1,
                    "data": {
                        "VerifyPepProdcutDayWiseCount": 3,
                        "VerifyPepProdcutWeekWiseCount": 15,
                        "VerifyPepProdcutMonthWiseCount": 60,
                        "VerifyTotalDoneScanMonthWise": 11,
                        "VerifyTotalDoneScanWeekWise": 9,
                        "VerifyTotalDoneScanDayWise": 0,
                        "forRequestingRatingsEnabled": true,
                        "forRequestingRatingsUserShouldBeOlderThanNoOfDays": 3,
                        "forRequestingRatingsMinAppLaunchCount": 5,
                        "forRequestingRatingsReshowAfterDays": 90,
                        "voucherSourceForRating": [
                          "challengeReward",
                          "spinReward",
                          "pointsRedemption"
                        ]
                    },
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/brand": {
        "get": {
          "tags": [
            "Brand"
          ],
          "summary": "Brand List",
          "description": "Brand List Data",
          "parameters": [
            {
              "name": "okta-accesstoken",
              "in": "header",
              "required": true,
              "description": "okta-accesstoken(Required)",
              "schema": {
                "type": "string",
                "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
              }
            },
            {
              "name": "SiteId",
              "in": "header",
              "required": true,
              "description": "SiteId",
              "schema": {
                "type": "number",
                "default": 10
              }
            },
            {
              "name": "limit",
              "in": "query",
              "required": false,
              "description": "limit",
              "schema": {
                "type": "number",
                "default": 20,
                "maximum": 100
              }
            },
            {
              "name": "offset",
              "in": "query",
              "required": false,
              "description": "offset",
              "schema": {
                "type": "number",
                "default": 0
              }
            },
            {
              "name": "orderKey",
              "in": "query",
              "required": false,
              "description": "orderKey",
              "schema": {
                "type": "string",
                "default": "title"
              }
            },
            {
              "name": "order",
              "in": "query",
              "required": false,
              "description": "order",
              "schema": {
                "type": "string",
                "default": "asc"
              }
            }
          ],
          "responses": {
            "200": {
              "description": "OK",
              "content": {
                "application/json": {
                  "example": {
                    "totalCount": 6,
                    "data": [
                        {
                            "id": 7603,
                            "category": "Beverages",
                            "name": {
                                "en": "MOUNTAIN DEW",
                                "ar_SA": "ندى الجبل"
                            },
                            "image": "http://localhost:82/_default_upload_bucket/mountain-dew.jpeg"
                        },
                        {
                            "id": 7822,
                            "category": "Beverages",
                            "name": {
                                "en": "7 UP/Seven Up",
                                "ar_SA": "سفن اب"
                            },
                            "image": "http://localhost:82/_default_upload_bucket/7up.png"
                        },
                        {
                            "id": 7823,
                            "category": "Snacks",
                            "name": {
                                "en": "Lays",
                                "ar_SA": "ليز"
                            },
                            "image": "http://localhost:82/_default_upload_bucket/lays_2.jpg"
                        },
                        {
                            "id": 8487,
                            "category": "Snacks",
                            "name": {
                                "en": "Kurkure",
                                "ar_SA": "ليز"
                            },
                            "image": "http://localhost:82/Brand%20Images/BrandImage-1672145140153.jpg"
                        },
                        {
                            "id": 8488,
                            "category": "Beverages",
                            "name": {
                                "en": "Pepsi",
                                "ar_SA": "سفن اب"
                            },
                            "image": "http://localhost:82/Brand%20Images/BrandImage-1672145140287.jpg"
                        },
                        {
                            "id": 8489,
                            "category": "Snacks",
                            "name": {
                                "en": "Chetoes",
                                "ar_SA": "ليز"
                            },
                            "image": "http://localhost:82/Brand%20Images/BrandImage-1672145273442.png"
                        }
                    ],
                    "success": true
                }
                }
              }
            },
            "400": {
              "description": "Bad Request",
              "content": {
                "*/*": {
                  "schema": {
                    "$ref": "#/components/schemas/ErrorMessage"
                  }
                }
              }
            },
            "415": {
              "description": "Unsupported Media Type",
              "content": {
                "*/*": {
                  "schema": {
                    "$ref": "#/components/schemas/ErrorMessage"
                  }
                }
              }
            },
            "500": {
              "description": "Internal Server Error",
              "content": {
                "*/*": {
                  "schema": {
                    "$ref": "#/components/schemas/Problem"
                  }
                }
              }
            }
          }
        }
      },
    "/content": {
      "get": {
        "tags": [
          "Content"
        ],
        "summary": "Content List",
        "description": "Content List",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": false,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "x-api-key",
            "in": "header",
            "required": true,
            "description": "x-api-key",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          },
          {
            "name": "tags",
            "in": "query",
            "required": false,
            "description": "tags",
            "schema": {
              "type": "object",
              "default": [
                "TAG1",
                "TAG2"
              ]
            }
          },
          {
            "name": "id",
            "in": "query",
            "required": false,
            "description": "ID of Content",
            "schema": {
              "type": "string",
              "default": null
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 2,
                    "data": [
                        {
                            "id": "privacy-policy",
                            "images": [],
                            "videos": [],
                            "title": {
                                "en": "Privacy Policy",
                                "ar_SA": "سياسة الخصوصية"
                            },
                            "excerpt": {
                                "en": null,
                                "ar_SA": null
                            },
                            "content": {
                                "en": "<p><strong>Heading 1</strong></p><p>Lorem ipsum dolor sit amet, consetetur sadip scing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accu sam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p><p><strong>Heading 2</strong></p><p>Lorem ipsum dolor sit amet, consetetur sadip scing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accu sam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p><p>&nbsp;</p>",
                                "ar_SA": "<h5><strong>عنوان 1</strong></h5><p>وعند موافقه العميل المبدئيه على التصميم يتم ازالة هذا النص من التصميم ويتم وضع النصوص النهائية المطلوبة للتصميم ويقول البعض ان وضع النصوص التجريبية بالتصميم قد تشغل المشاهد عن وضع الكثير من الملاحظات او الانتقادات للتصميم الاساسي.</p><p>وخلافاَ للاعتقاد السائد فإن لوريم إيبسوم ليس نصاَ عشوائياً، بل إن له جذور في الأدب اللاتيني الكلاسيكي منذ العام 45 قبل الميلاد. من كتاب \"حول أقاصي الخير والشر\"</p><h5><strong>عنوان</strong> <strong>2</strong></h5><p>وعند موافقه العميل المبدئيه على التصميم يتم ازالة هذا النص من التصميم ويتم وضع النصوص النهائية المطلوبة للتصميم ويقول البعض ان وضع النصوص التجريبية بالتصميم قد تشغل المشاهد عن وضع الكثير من الملاحظات او الانتقادات للتصميم الاساسي.</p><p>وخلافاَ للاعتقاد السائد فإن لوريم إيبسوم ليس نصاَ عشوائياً، بل إن له جذور في الأدب اللاتيني الكلاسيكي منذ العام 45 قبل الميلاد. من كتاب \"حول أقاصي الخير والشر\"</p>"
                            },
                            "parameters": [],
                            "StartDate": "2022-09-26 06:48:53",
                            "EndDate": "9999-12-30 18:30:00",
                            "created": "2022-09-26 06:48:52",
                            "modified": "2022-11-03 08:26:17",
                            "displayOrder": null,
                            "url": null,
                            "siteId": 10,
                            "is_public": true,
                            "version_number": 1,
                            "activity": [],
                            "reward": [],
                            "points": 0,
                            "promotionID": null,
                            "tags": []
                        },
                        {
                            "id": "terms-and-conditions",
                            "images": [],
                            "videos": [],
                            "title": {
                                "en": "Terms and Conditions",
                                "ar_SA": "الأحكام والشروط"
                            },
                            "excerpt": {
                                "en": null,
                                "ar_SA": null
                            },
                            "content": {
                                "en": "<p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.<br />Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.<br />Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.</p><p>&nbsp;</p>",
                                "ar_SA": "<p>وعند موافقه العميل المبدئيه على التصميم يتم ازالة هذا النص من التصميم ويتم وضع النصوص النهائية المطلوبة للتصميم ويقول البعض ان وضع النصوص التجريبية بالتصميم قد تشغل المشاهد عن وضع الكثير من الملاحظات او الانتقادات للتصميم الاساسي.</p><p>وخلافاَ للاعتقاد السائد فإن لوريم إيبسوم ليس نصاَ عشوائياً، بل إن له جذور في الأدب اللاتيني الكلاسيكي منذ العام 45 قبل الميلاد. من كتاب \"حول أقاصي الخير والشر\"<br />\u000bوعند موافقه العميل المبدئيه على التصميم يتم ازالة هذا النص من التصميم ويتم وضع النصوص النهائية المطلوبة للتصميم ويقول البعض ان وضع النصوص التجريبية بالتصميم قد تشغل المشاهد عن وضع الكثير من الملاحظات او الانتقادات للتصميم الاساسي.</p><p>وخلافاَ للاعتقاد السائد فإن لوريم إيبسوم ليس نصاَ عشوائياً، بل إن له جذور في الأدب اللاتيني الكلاسيكي منذ العام 45 قبل الميلاد. من كتاب \"حول أقاصي الخير والشر\"</p><p>وعند موافقه العميل المبدئيه على التصميم يتم ازالة هذا النص من التصميم ويتم وضع النصوص النهائية المطلوبة للتصميم ويقول البعض ان وضع النصوص التجريبية بالتصميم قد تشغل المشاهد عن وضع الكثير من الملاحظات او الانتقادات للتصميم الاساسي.</p><p>وخلافاَ للاعتقاد السائد فإن لوريم إيبسوم ليس نصاَ عشوائياً، بل إن له جذور في الأدب اللاتيني الكلاسيكي منذ العام 45 قبل الميلاد. من كتاب \"حول أقاصي الخير والشر\"</p>"
                            },
                            "parameters": [],
                            "StartDate": "2022-10-21 15:12:08",
                            "EndDate": "2023-05-31 15:12:00",
                            "created": "2022-10-21 15:12:08",
                            "modified": "2022-11-03 08:25:44",
                            "displayOrder": null,
                            "url": null,
                            "siteId": 10,
                            "is_public": true,
                            "version_number": 1,
                            "activity": [],
                            "reward": [],
                            "points": 0,
                            "promotionID": null,
                            "tags": []
                        }
                    ]
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
     "/content/privacy-policy": {
      "get": {
        "tags": [
          "Content"
        ],
        "summary": "Privacy Policy",
        "description": "Privacy Policy",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": false,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "x-api-key",
            "in": "header",
            "required": true,
            "description": "x-api-key",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          },
          {
            "name": "tags",
            "in": "query",
            "required": false,
            "description": "tags",
            "schema": {
              "type": "object",
              "default": [
                "TAG1",
                "TAG2"
              ]
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                  "totalCount": 1,
                  "data": [
                      {
                          "id": "privacy-policy",
                          "images": [],
                          "videos": [],
                          "title": {
                              "en": "Privacy Policy",
                              "ar_SA": "سياسة الخصوصية"
                          },
                          "excerpt": {
                              "en": null,
                              "ar_SA": null
                          },
                          "content": {
                              "en": "<p><strong>Heading 1</strong></p><p>Lorem ipsum dolor sit amet, consetetur sadip scing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accu sam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p><p><strong>Heading 2</strong></p><p>Lorem ipsum dolor sit amet, consetetur sadip scing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accu sam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p><p>&nbsp;</p>",
                              "ar_SA": "<h5><strong>عنوان 1</strong></h5><p>وعند موافقه العميل المبدئيه على التصميم يتم ازالة هذا النص من التصميم ويتم وضع النصوص النهائية المطلوبة للتصميم ويقول البعض ان وضع النصوص التجريبية بالتصميم قد تشغل المشاهد عن وضع الكثير من الملاحظات او الانتقادات للتصميم الاساسي.</p><p>وخلافاَ للاعتقاد السائد فإن لوريم إيبسوم ليس نصاَ عشوائياً، بل إن له جذور في الأدب اللاتيني الكلاسيكي منذ العام 45 قبل الميلاد. من كتاب \"حول أقاصي الخير والشر\"</p><h5><strong>عنوان</strong> <strong>2</strong></h5><p>وعند موافقه العميل المبدئيه على التصميم يتم ازالة هذا النص من التصميم ويتم وضع النصوص النهائية المطلوبة للتصميم ويقول البعض ان وضع النصوص التجريبية بالتصميم قد تشغل المشاهد عن وضع الكثير من الملاحظات او الانتقادات للتصميم الاساسي.</p><p>وخلافاَ للاعتقاد السائد فإن لوريم إيبسوم ليس نصاَ عشوائياً، بل إن له جذور في الأدب اللاتيني الكلاسيكي منذ العام 45 قبل الميلاد. من كتاب \"حول أقاصي الخير والشر\"</p>"
                          },
                          "parameters": [],
                          "StartDate": "2022-09-26 06:48:53",
                          "EndDate": "9999-12-30 18:30:00",
                          "created": "2022-09-26 06:48:52",
                          "modified": "2022-11-03 08:26:17",
                          "displayOrder": null,
                          "url": null,
                          "siteId": 10,
                          "is_public": true,
                          "version_number": 1,
                          "activity": [],
                          "reward": [],
                          "points": 0,
                          "promotionID": null,
                          "tags": []
                      }
                  ]
              }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/content/terms-and-conditions": {
      "get": {
        "tags": [
          "Content"
        ],
        "summary": "Terms and Conditions",
        "description": "Terms and Conditions",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": false,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "x-api-key",
            "in": "header",
            "required": true,
            "description": "x-api-key",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          },
          {
            "name": "tags",
            "in": "query",
            "required": false,
            "description": "tags",
            "schema": {
              "type": "object",
              "default": [
                "TAG1",
                "TAG2"
              ]
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 1,
                    "data": [
                        {
                            "id": "terms-and-conditions",
                            "images": [],
                            "videos": [],
                            "title": {
                                "en": "Terms and Conditions",
                                "ar_SA": "الأحكام والشروط"
                            },
                            "excerpt": {
                                "en": null,
                                "ar_SA": null
                            },
                            "content": {
                                "en": "<p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.<br />Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.<br />Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.</p><p>&nbsp;</p>",
                                "ar_SA": "<p>وعند موافقه العميل المبدئيه على التصميم يتم ازالة هذا النص من التصميم ويتم وضع النصوص النهائية المطلوبة للتصميم ويقول البعض ان وضع النصوص التجريبية بالتصميم قد تشغل المشاهد عن وضع الكثير من الملاحظات او الانتقادات للتصميم الاساسي.</p><p>وخلافاَ للاعتقاد السائد فإن لوريم إيبسوم ليس نصاَ عشوائياً، بل إن له جذور في الأدب اللاتيني الكلاسيكي منذ العام 45 قبل الميلاد. من كتاب \"حول أقاصي الخير والشر\"<br />\u000bوعند موافقه العميل المبدئيه على التصميم يتم ازالة هذا النص من التصميم ويتم وضع النصوص النهائية المطلوبة للتصميم ويقول البعض ان وضع النصوص التجريبية بالتصميم قد تشغل المشاهد عن وضع الكثير من الملاحظات او الانتقادات للتصميم الاساسي.</p><p>وخلافاَ للاعتقاد السائد فإن لوريم إيبسوم ليس نصاَ عشوائياً، بل إن له جذور في الأدب اللاتيني الكلاسيكي منذ العام 45 قبل الميلاد. من كتاب \"حول أقاصي الخير والشر\"</p><p>وعند موافقه العميل المبدئيه على التصميم يتم ازالة هذا النص من التصميم ويتم وضع النصوص النهائية المطلوبة للتصميم ويقول البعض ان وضع النصوص التجريبية بالتصميم قد تشغل المشاهد عن وضع الكثير من الملاحظات او الانتقادات للتصميم الاساسي.</p><p>وخلافاَ للاعتقاد السائد فإن لوريم إيبسوم ليس نصاَ عشوائياً، بل إن له جذور في الأدب اللاتيني الكلاسيكي منذ العام 45 قبل الميلاد. من كتاب \"حول أقاصي الخير والشر\"</p>"
                            },
                            "parameters": [],
                            "StartDate": "2022-10-21 15:12:08",
                            "EndDate": "2023-05-31 15:12:00",
                            "created": "2022-10-21 15:12:08",
                            "modified": "2022-11-03 08:25:44",
                            "displayOrder": null,
                            "url": null,
                            "siteId": 10,
                            "is_public": true,
                            "version_number": 1,
                            "activity": [],
                            "reward": [],
                            "points": 0,
                            "promotionID": null,
                            "tags": []
                        }
                    ]
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/content/translation": {
      "get": {
        "tags": [
          "Content"
        ],
        "summary": "Translation",
        "description": "Translation",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": false,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "x-api-key",
            "in": "header",
            "required": true,
            "description": "x-api-key",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          },
          {
            "name": "tags",
            "in": "query",
            "required": false,
            "description": "tags",
            "schema": {
              "type": "object",
              "default": [
                "TAG1",
                "TAG2"
              ]
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                  "example": {
                      "message": "No data found!"
                  }
                }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/faqs": {
      "get": {
        "tags": [
          "Content"
        ],
        "summary": "FAQ List",
        "description": "FAQ List",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": false,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "x-api-key",
            "in": "header",
            "required": true,
            "description": "x-api-key",
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          },
          {
            "name": "tags",
            "in": "query",
            "required": false,
            "description": "tags",
            "schema": {
              "type": "object",
              "default": [
                "TAG1",
                "TAG2"
              ]
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 1,
                    "data": [
                        {
                            "id": 7430,
                            "title": {
                                "en": "How to use KSA App?",
                                "ar_SA": "How to use KSA App?"
                            },
                            "description": {
                                "en": "<p>How to use KSA App?</p>\n",
                                "ar_SA": "<p>How to use KSA App?</p>\n"
                            },
                            "image": "",
                            "siteId": "10",
                            "isPublic": true,
                            "created": "2022-10-28 12:00:23",
                            "modified": "2022-11-02 09:22:11",
                            "tags": [],
                            "section": [
                                {
                                    "title": {
                                        "en": "General",
                                        "ar_SA": "General"
                                    },
                                    "faqs": [
                                        {
                                            "question": {
                                                "en": "What is question1?"
                                            },
                                            "answer": {
                                                "en": "<p>Answer fort&nbsp; question1</p>\n"
                                            },
                                            "image": ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/loyalty/rewards/category": {
      "get": {
        "tags": [
          "Rewards"
        ],
        "summary": "Reward Category List",
        "description": "Reward Category List",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 4,
                    "data": [
                        {
                            "title": {
                                "en": "Fast Food",
                                "ar_SA": "وجبات سريعة"
                            },
                            "disclaimerTitle": {
                                "en": "Food & Drinks",
                                "ar_SA": "أطعمة ومشروبات"
                            },
                            "description": {
                                "en": "Food & Drinks",
                                "ar_SA": "أطعمة ومشروبات"
                            },
                            "ShowonHomePage": "",
                            "TotalPublishedReward": "2",
                            "TotalClaimedReward": "2",
                            "id": 7394
                        },
                        {
                            "title": {
                                "en": "Activity",
                                "ar_SA": "نشاط"
                            },
                            "disclaimerTitle": {
                                "en": "Activity",
                                "ar_SA": "نشاط"
                            },
                            "description": {
                                "en": "Activity",
                                "ar_SA": "نشاط"
                            },
                            "ShowonHomePage": "",
                            "TotalPublishedReward": "2",
                            "TotalClaimedReward": "1",
                            "id": 7395
                        },
                        {
                            "title": {
                                "en": "Entertainment",
                                "ar_SA": "وسائل الترفيه"
                            },
                            "disclaimerTitle": {
                                "en": "Entertainment",
                                "ar_SA": "وسائل الترفيه"
                            },
                            "description": {
                                "en": "Entertainment",
                                "ar_SA": "وسائل الترفيه"
                            },
                            "ShowonHomePage": "",
                            "TotalPublishedReward": "1",
                            "TotalClaimedReward": "1",
                            "id": 7494
                        },
                        {
                            "title": {
                                "en": "Shopping & Fashion",
                                "ar_SA": "التسوق والموضة"
                            },
                            "disclaimerTitle": {
                                "en": "Shopping & Fashion",
                                "ar_SA": "التسوق والموضة"
                            },
                            "description": {
                                "en": "Shopping & Fashion",
                                "ar_SA": "التسوق والموضة"
                            },
                            "ShowonHomePage": "",
                            "TotalPublishedReward": "2",
                            "TotalClaimedReward": "1",
                            "id": 7495
                        }
                    ],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/loyalty/reward/offers": {
      "get": {
        "tags": [
          "Rewards"
        ],
        "summary": "Reward/Offers List",
        "description": "Reward/Offers List",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "type",
            "in": "query",
            "required": false,
            "description": "type",
            "schema": {
              "type": "string",
              "default": "all"
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          },
          {
            "name": "orderKey",
            "in": "query",
            "required": false,
            "description": "orderKey",
            "schema": {
              "type": "string",
              "default": "o_CreationDate"
            }
          },
          {
            "name": "order",
            "in": "query",
            "required": false,
            "description": "order",
            "schema": {
              "type": "string",
              "default": "asc"
            }
          },
          {
            "name": "category_id",
            "in": "query",
            "required": false,
            "description": "category_id",
            "schema": {
              "type": "object",
              "default": [
                "6792"
              ]
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 5,
                    "data": [
                        {
                            "title": {
                                "en": "Offer2",
                                "ar_SA": "عرض 2"
                            },
                            "content": {
                                "en": "<p>SAR 80 Discount on The Secret Room</p>\n",
                                "ar_SA": "<p>خصم&nbsp;٨٠ ريال على الغرفة السرية</p>\n"
                            },
                            "terms": {
                                "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                            },
                            "disclaimer": {
                                "en": null,
                                "ar_SA": null
                            },
                            "buttonText": {
                                "en": "Redeem",
                                "ar_SA": "يسترد"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "categoryPrimaryText": {
                                "en": "REDEEM",
                                "ar_SA": "يسترد"
                            },
                            "categorySecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 7487,
                            "type": "Reward",
                            "redemptionType": "ExternalRedemption",
                            "points": 50,
                            "offerId": "SEB123",
                            "rewardId": 7486,
                            "categories": [
                                {
                                    "id": 7395,
                                    "title": {
                                        "en": "Activity",
                                        "ar_SA": "نشاط"
                                    }
                                }
                            ],
                            "branches": [
                                {
                                    "name": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "address": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "longitude": -74.00491476059,
                                    "latitude": 40.712622133006
                                }
                            ],
                            "value": "50AED",
                            "buttonUrl": null,
                            "voucherPin": null,
                            "expirationDate": 1670006700,
                            "displayStartDate": 1667933100,
                            "categoryPrimaryTextColor": "#ffffff",
                            "categoryPrimaryBackgroundColor": "#00aff2",
                            "categorySecondaryTextColor": "#00aff2",
                            "categorySecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "backgroundImage": "",
                            "image": "",
                            "partner": {
                                "partnerId": "St345vp",
                                "partnerName": "Steers"
                            },
                            "totalView": 4
                        },
                        {
                            "title": {
                                "en": "Go4Fun",
                                "ar_SA": "انطلق فورًا"
                            },
                            "content": {
                                "en": "<p>1 twister sandwich with any medium meal at KFC!</p>\n",
                                "ar_SA": "<p>1 ساندويتش تويستر مع أي وجبة متوسطة في كنتاكي!</p>\n"
                            },
                            "terms": {
                                "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                            },
                            "disclaimer": {
                                "en": null,
                                "ar_SA": null
                            },
                            "buttonText": {
                                "en": "Redeem",
                                "ar_SA": "يسترد"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "categoryPrimaryText": {
                                "en": "REDEEM",
                                "ar_SA": "يسترد"
                            },
                            "categorySecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 7497,
                            "type": "Reward",
                            "redemptionType": "ExternalRedemption",
                            "points": 60,
                            "offerId": "ST50",
                            "rewardId": 7496,
                            "categories": [
                                {
                                    "id": 7394,
                                    "title": {
                                        "en": "Fast Food",
                                        "ar_SA": "وجبات سريعة"
                                    }
                                }
                            ],
                            "branches": [
                                {
                                    "name": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "address": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "longitude": -74.00491476059,
                                    "latitude": 40.712622133006
                                }
                            ],
                            "value": "60AED",
                            "buttonUrl": null,
                            "voucherPin": null,
                            "expirationDate": 1670352300,
                            "displayStartDate": 1668019500,
                            "categoryPrimaryTextColor": "#ffffff",
                            "categoryPrimaryBackgroundColor": "#00aff2",
                            "categorySecondaryTextColor": "#00aff2",
                            "categorySecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "backgroundImage": "",
                            "image": "",
                            "partner": {
                                "partnerId": "St345vp",
                                "partnerName": "Steers"
                            },
                            "totalView": 3
                        },
                        {
                            "title": {
                                "en": "Offer 5",
                                "ar_SA": "العرض 5"
                            },
                            "content": {
                                "en": "<p>One-month FREE subscription to Anghami Plus</p>\n",
                                "ar_SA": null
                            },
                            "terms": {
                                "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                            },
                            "disclaimer": {
                                "en": null,
                                "ar_SA": null
                            },
                            "buttonText": {
                                "en": "REDEEM",
                                "ar_SA": "Redeem"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "categoryPrimaryText": {
                                "en": "REDEEM",
                                "ar_SA": "يسترد"
                            },
                            "categorySecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 7520,
                            "type": "Reward",
                            "redemptionType": "ExternalRedemption",
                            "points": 40,
                            "offerId": "SPR5",
                            "rewardId": 7519,
                            "categories": [
                                {
                                    "id": 7495,
                                    "title": {
                                        "en": "Shopping & Fashion",
                                        "ar_SA": "التسوق والموضة"
                                    }
                                }
                            ],
                            "branches": [
                                {
                                    "name": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "address": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "longitude": -74.00491476059,
                                    "latitude": 40.712622133006
                                }
                            ],
                            "value": "70AED",
                            "buttonUrl": null,
                            "voucherPin": null,
                            "expirationDate": 1670006700,
                            "displayStartDate": 1668019500,
                            "categoryPrimaryTextColor": "#ffffff",
                            "categoryPrimaryBackgroundColor": "#00aff2",
                            "categorySecondaryTextColor": "#00aff2",
                            "categorySecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "backgroundImage": "",
                            "image": "",
                            "partner": {
                                "partnerId": "St345vp",
                                "partnerName": "Steers"
                            },
                            "totalView": 4
                        },
                        {
                            "title": {
                                "en": "Offer 6",
                                "ar_SA": "العرض 6"
                            },
                            "content": {
                                "en": "<p>R50 Burger King Voucher?</p>\n",
                                "ar_SA": "<p>قسيمة R50 برجر كنج؟</p>\n"
                            },
                            "terms": {
                                "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                            },
                            "disclaimer": {
                                "en": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been.",
                                "ar_SA": "لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم."
                            },
                            "buttonText": {
                                "en": "Redeem",
                                "ar_SA": "يسترد"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "categoryPrimaryText": {
                                "en": "REDEEM",
                                "ar_SA": "يسترد"
                            },
                            "categorySecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 7534,
                            "type": "Reward",
                            "redemptionType": "ExternalRedemption",
                            "points": 50,
                            "offerId": "ST50",
                            "rewardId": 7533,
                            "categories": [
                                {
                                    "id": 7495,
                                    "title": {
                                        "en": "Shopping & Fashion",
                                        "ar_SA": "التسوق والموضة"
                                    }
                                }
                            ],
                            "branches": [
                                {
                                    "name": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "address": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "longitude": -74.00491476059,
                                    "latitude": 40.712622133006
                                }
                            ],
                            "value": "50",
                            "buttonUrl": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/",
                            "voucherPin": "VPMOLOKGEXGM",
                            "expirationDate": 1670352300,
                            "displayStartDate": 1668538800,
                            "categoryPrimaryTextColor": "#ffffff",
                            "categoryPrimaryBackgroundColor": "#00aff2",
                            "categorySecondaryTextColor": "#00aff2",
                            "categorySecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "backgroundImage": "",
                            "image": "",
                            "partner": {
                                "partnerId": "De237df",
                                "partnerName": "Debonairs Pizza"
                            },
                            "totalView": 101
                        },
                        {
                            "title": {
                                "en": "Offer 7",
                                "ar_SA": "العرض 7"
                            },
                            "content": {
                                "en": "<p>R50 Nando's Voucher</p>\n",
                                "ar_SA": "<p>قسيمة R50 ناندو</p>\n"
                            },
                            "terms": {
                                "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                            },
                            "disclaimer": {
                                "en": null,
                                "ar_SA": null
                            },
                            "buttonText": {
                                "en": "Redeem",
                                "ar_SA": "Redeem"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "categoryPrimaryText": {
                                "en": "REDEEM",
                                "ar_SA": "يسترد"
                            },
                            "categorySecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 7536,
                            "type": "Reward",
                            "redemptionType": "ExternalRedemption",
                            "points": 50,
                            "offerId": "NA50",
                            "rewardId": 7535,
                            "categories": [
                                {
                                    "id": 7494,
                                    "title": {
                                        "en": "Entertainment",
                                        "ar_SA": "وسائل الترفيه"
                                    }
                                }
                            ],
                            "branches": [
                                {
                                    "name": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "address": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "longitude": -74.00491476059,
                                    "latitude": 40.712622133006
                                }
                            ],
                            "value": "50",
                            "buttonUrl": null,
                            "voucherPin": null,
                            "expirationDate": 1670266800,
                            "displayStartDate": 1668539700,
                            "categoryPrimaryTextColor": "#ffffff",
                            "categoryPrimaryBackgroundColor": "#00aff2",
                            "categorySecondaryTextColor": "#00aff2",
                            "categorySecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "backgroundImage": "",
                            "image": "",
                            "partner": {
                                "partnerId": "De237df",
                                "partnerName": "Debonairs Pizza"
                            },
                            "totalView": 100
                        }
                    ],
                    "expiryData": [
                        1670006700,
                        1670352300,
                        1670006700,
                        1670352300,
                        1670266800
                    ],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "loyalty/reward/offer/view": {
      "get": {
        "tags": [
          "Rewards"
        ],
        "summary": "Reward/Offers Detail",
        "description": "Reward/Offers Detail",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "offerId",
            "in": "query",
            "required": false,
            "description": "offerId",
            "schema": {
              "type": "number",
              "default": 7520
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 1,
                    "data": [
                        {
                            "title": {
                                "en": "Offer 5",
                                "ar_SA": "العرض 5"
                            },
                            "content": {
                                "en": "<p>One-month FREE subscription to Anghami Plus</p>\n",
                                "ar_SA": null
                            },
                            "terms": {
                                "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                            },
                            "disclaimer": {
                                "en": null,
                                "ar_SA": null
                            },
                            "buttonText": {
                                "en": "REDEEM",
                                "ar_SA": "Redeem"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "categoryPrimaryText": {
                                "en": "REDEEM",
                                "ar_SA": "يسترد"
                            },
                            "categorySecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 7520,
                            "type": "Reward",
                            "redemptionType": "ExternalRedemption",
                            "points": 40,
                            "offerId": "SPR5",
                            "rewardId": 7519,
                            "categories": [
                                {
                                    "id": 7495,
                                    "title": {
                                        "en": "Shopping & Fashion",
                                        "ar_SA": "التسوق والموضة"
                                    }
                                }
                            ],
                            "branches": [
                                {
                                    "name": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "address": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "longitude": -74.00491476059,
                                    "latitude": 40.712622133006
                                }
                            ],
                            "value": "70AED",
                            "buttonUrl": null,
                            "voucherPin": null,
                            "expirationDate": 1670006700,
                            "displayStartDate": 1668019500,
                            "categoryPrimaryTextColor": "#ffffff",
                            "categoryPrimaryBackgroundColor": "#00aff2",
                            "categorySecondaryTextColor": "#00aff2",
                            "categorySecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "backgroundImage": "",
                            "image": "",
                            "partner": {
                                "partnerId": "St345vp",
                                "partnerName": "Steers"
                            },
                            "totalView": 4
                        }
                    ],
                    "expiryData": [
                        1670006700
                    ],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/loyalty/offers/endingsoon": {
      "get": {
        "tags": [
          "Rewards"
        ],
        "summary": "Endingsoon Reward List",
        "description": "Endingsoon Reward List",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 1,
                    "data": [
                        {
                            "title": {
                                "en": "Offer001",
                                "ar_SA": "Offer001"
                            },
                            "type": "Reward",
                            "buttonText": {
                                "en": "Redeem",
                                "ar_SA": "Redeem"
                            },
                            "expirationDate": 1667154600,
                            "point": "25",
                            "category": [
                                {
                                    "id": 6792,
                                    "title": {
                                        "en": "Food & Drinks",
                                        "ar_SA": "Food & Drinks"
                                    }
                                },
                                {
                                    "id": 6795,
                                    "title": {
                                        "en": "Entertainment",
                                        "ar_SA": "Entertainment"
                                    }
                                }
                            ],
                            "content": {
                                "en": "<p>Offer001</p>\n",
                                "ar_SA": null
                            }
                        }
                    ],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/redeem-reward": {
        "post": {
            "tags": [
                "Rewards"
            ],
            "summary": "Redeem Reward",
            "description": "Redeem Reward",
            "requestBody": {
                "content": {
                    "application/json": {
                        "schema": {
                            "type": "object",
                            "properties": {
                                "id": {
                                    "type": "string",
                                    "format": "int64"
                                }
                            }
                        },
                        "example": {
                            "rewardId":7533,
                            "customerId" : "27832306191",
                            "partnerId" : "St345vp",
                            "offerId" : "ST50",
                            "ExpiresOn":"2022-11-24 11:01"
                        }
                    }
                }
            },
            "parameters": [
                {
                    "name": "SiteId",
                    "in": "header",
                    "required": true,
                    "description": "SiteId",
                    "schema": {
                        "type": "number",
                        "default": 10
                    }
                },
                {
                    "name": "okta-accesstoken",
                    "in": "header",
                    "required": true,
                    "description": "okta-accesstoken",
                    "schema": {
                        "type": "string",
                        "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
                    }
                }
            ],
            "responses": {
                "200": {
                    "description": "OK",
                    "content": {
                        "application/json": {
                            "example": {
                                "success": true,
                                "message": "Reward already claimed",
                                "rewardType": "Reward",
                                "rewardId": 7533,
                                "redemptionType": "ExternalRedemption",
                                "buttonUrl": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/",
                                "coupons": [
                                    {
                                        "couponCode": "ST50",
                                        "claimed": "2022-11-25 11:54:45",
                                        "burned": true,
                                        "url": null
                                    }
                                ],
                                "voucherPin": "VPMOLOKGEXGM",
                                "rewardEngUserRewId": 7559
                            }
                        }
                    }
                },
                "400": {
                    "description": "Bad Request",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "415": {
                    "description": "Unsupported Media Type",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "500": {
                    "description": "Internal Server Error",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/Problem"
                            }
                        }
                    }
                }
            }
        }
    },
    "/burn-user-reward": {
        "post": {
            "tags": [
                "Rewards"
            ],
            "summary": "Burn User Reward",
            "description": "Burn User Reward",
            "requestBody": {
                "content": {
                    "application/json": {
                        "schema": {
                            "type": "object",
                            "properties": {
                                "id": {
                                    "type": "string",
                                    "format": "int64"
                                }
                            }
                        },
                        "example": {
                            "rewardId":7605
                        }
                    }
                }
            },
            "parameters": [
                {
                    "name": "SiteId",
                    "in": "header",
                    "required": true,
                    "description": "SiteId",
                    "schema": {
                        "type": "number",
                        "default": 10
                    }
                },
                {
                    "name": "okta-accesstoken",
                    "in": "header",
                    "required": true,
                    "description": "okta-accesstoken",
                    "schema": {
                        "type": "string",
                        "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
                    }
                }
            ],
            "responses": {
                "200": {
                    "description": "OK",
                    "content": {
                        "application/json": {
                            "example":{
                                "message": "Record not found in voucher purchase api.",
                                "success": false
                            } 
                        }
                    }
                },
                "400": {
                    "description": "Bad Request",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "415": {
                    "description": "Unsupported Media Type",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "500": {
                    "description": "Internal Server Error",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/Problem"
                            }
                        }
                    }
                }
            }
        }
    },
    "/myreward": {
      "get": {
        "tags": [
          "Rewards"
        ],
        "summary": "My Reward List",
        "description": "My Reward List",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          },
          {
            "name": "orderKey",
            "in": "query",
            "required": false,
            "description": "orderKey",
            "schema": {
              "type": "string",
              "default": "o_CreationDate"
            }
          },
          {
            "name": "order",
            "in": "query",
            "required": false,
            "description": "order",
            "schema": {
              "type": "string",
              "default": "asc"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 5,
                    "data": [
                        {
                            "title": {
                                "en": "Offer 6",
                                "ar_SA": "العرض 6"
                            },
                            "rewardId": 7533,
                            "rewardType": "Reward",
                            "redemptionType": "ExternalRedemption",
                            "offerValue": "50",
                            "offerId": "ST50",
                            "points": 50,
                            "quantity": 0,
                            "totalCoupon": 0,
                            "content": {
                                "en": "<p>R50 Burger King Voucher?</p>\n",
                                "ar_SA": "<p>قسيمة R50 برجر كنج؟</p>\n"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "termsAndCondtions": {
                                "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                            },
                            "buttonText": {
                                "en": "Redeem",
                                "ar_SA": "يسترد"
                            },
                            "disclaimer": {
                                "en": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been.",
                                "ar_SA": "لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. لقد كان لوريم إيبسوم."
                            },
                            "buttonUrl": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/",
                            "displayStartDate": 1668538800,
                            "displayEndDate": 1670007600,
                            "expirationDate": 1670352300,
                            "firstTimeUser": null,
                            "voucherPin": "VPMOLOKGEXGM",
                            "hideWhenClaimed": false,
                            "displayOrder": 6,
                            "expirationAmount": 5,
                            "expirationUnit": "days",
                            "rewardEmailSubject": {
                                "en": null,
                                "ar_SA": null
                            },
                            "rewardEmailContent": {
                                "en": null,
                                "ar_SA": null
                            },
                            "couponCodeInEmail": false,
                            "claimURLInEmail": false,
                            "siteId": "10",
                            "maxUser": 1,
                            "redeemed": 2,
                            "claimed": 2,
                            "status": "AVAILABLE",
                            "partner": {
                                "partnerId": "De237df",
                                "partnerName": "Debonairs Pizza"
                            },
                            "categories": [
                                {
                                    "id": 7495,
                                    "title": {
                                        "en": "Shopping & Fashion",
                                        "ar_SA": "التسوق والموضة"
                                    }
                                }
                            ],
                            "branches": [
                                {
                                    "name": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "address": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "longitude": -74.00491476059,
                                    "latitude": 40.712622133006
                                }
                            ]
                        },
                        {
                            "title": {
                                "en": "Offer 7",
                                "ar_SA": "العرض 7"
                            },
                            "rewardId": 7535,
                            "rewardType": "Reward",
                            "redemptionType": "ExternalRedemption",
                            "offerValue": "50",
                            "offerId": "NA50",
                            "points": 50,
                            "quantity": 0,
                            "totalCoupon": 0,
                            "content": {
                                "en": "<p>R50 Nando's Voucher</p>\n",
                                "ar_SA": "<p>قسيمة R50 ناندو</p>\n"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "termsAndCondtions": {
                                "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                            },
                            "buttonText": {
                                "en": "Redeem",
                                "ar_SA": "Redeem"
                            },
                            "disclaimer": {
                                "en": null,
                                "ar_SA": null
                            },
                            "buttonUrl": null,
                            "displayStartDate": 1668539700,
                            "displayEndDate": 1669749300,
                            "expirationDate": 1670266800,
                            "firstTimeUser": null,
                            "voucherPin": null,
                            "hideWhenClaimed": false,
                            "displayOrder": 7,
                            "expirationAmount": 5,
                            "expirationUnit": "days",
                            "rewardEmailSubject": {
                                "en": null,
                                "ar_SA": null
                            },
                            "rewardEmailContent": {
                                "en": null,
                                "ar_SA": null
                            },
                            "couponCodeInEmail": false,
                            "claimURLInEmail": false,
                            "siteId": "10",
                            "maxUser": 1,
                            "redeemed": 0,
                            "claimed": 1,
                            "status": "AVAILABLE",
                            "partner": {
                                "partnerId": "De237df",
                                "partnerName": "Debonairs Pizza"
                            },
                            "categories": [
                                {
                                    "id": 7494,
                                    "title": {
                                        "en": "Entertainment",
                                        "ar_SA": "وسائل الترفيه"
                                    }
                                }
                            ],
                            "branches": [
                                {
                                    "name": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "address": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "longitude": -74.00491476059,
                                    "latitude": 40.712622133006
                                }
                            ]
                        },
                        {
                            "title": {
                                "en": "Go4Fun",
                                "ar_SA": "انطلق فورًا"
                            },
                            "rewardId": 7496,
                            "rewardType": "Reward",
                            "redemptionType": "ExternalRedemption",
                            "offerValue": "60AED",
                            "offerId": "ST50",
                            "points": 60,
                            "quantity": 0,
                            "totalCoupon": 0,
                            "content": {
                                "en": "<p>1 twister sandwich with any medium meal at KFC!</p>\n",
                                "ar_SA": "<p>1 ساندويتش تويستر مع أي وجبة متوسطة في كنتاكي!</p>\n"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "termsAndCondtions": {
                                "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                            },
                            "buttonText": {
                                "en": "Redeem",
                                "ar_SA": "يسترد"
                            },
                            "disclaimer": {
                                "en": null,
                                "ar_SA": null
                            },
                            "buttonUrl": null,
                            "displayStartDate": 1668019500,
                            "displayEndDate": 1670006700,
                            "expirationDate": 1670352300,
                            "firstTimeUser": null,
                            "voucherPin": null,
                            "hideWhenClaimed": false,
                            "displayOrder": 3,
                            "expirationAmount": 5,
                            "expirationUnit": "days",
                            "rewardEmailSubject": {
                                "en": null,
                                "ar_SA": null
                            },
                            "rewardEmailContent": {
                                "en": null,
                                "ar_SA": null
                            },
                            "couponCodeInEmail": false,
                            "claimURLInEmail": false,
                            "siteId": "10",
                            "maxUser": 1,
                            "redeemed": 0,
                            "claimed": 1,
                            "status": "AVAILABLE",
                            "partner": {
                                "partnerId": "St345vp",
                                "partnerName": "Steers"
                            },
                            "categories": [
                                {
                                    "id": 7394,
                                    "title": {
                                        "en": "Fast Food",
                                        "ar_SA": "وجبات سريعة"
                                    }
                                }
                            ],
                            "branches": [
                                {
                                    "name": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "address": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "longitude": -74.00491476059,
                                    "latitude": 40.712622133006
                                }
                            ]
                        },
                        {
                            "title": {
                                "en": "Offer1",
                                "ar_SA": "Offer1"
                            },
                            "rewardId": 7397,
                            "rewardType": "Gifting",
                            "redemptionType": "ExternalRedemption",
                            "offerValue": "15AED",
                            "offerId": "Offer1",
                            "points": 15,
                            "quantity": 0,
                            "totalCoupon": 0,
                            "content": {
                                "en": "<p>Half an hour for free trampolining at Go4Fun!</p>\n",
                                "ar_SA": "<p>نصف ساعة للحصول على ترامبولين مجاني في Go4Fun!</p>\n"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "termsAndCondtions": {
                                "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                            },
                            "buttonText": {
                                "en": "Redeem",
                                "ar_SA": "يسترد"
                            },
                            "disclaimer": {
                                "en": null,
                                "ar_SA": null
                            },
                            "buttonUrl": null,
                            "displayStartDate": 1667932200,
                            "displayEndDate": 1669314600,
                            "expirationDate": 1669746600,
                            "firstTimeUser": null,
                            "voucherPin": null,
                            "hideWhenClaimed": false,
                            "displayOrder": 0,
                            "expirationAmount": 5,
                            "expirationUnit": "days",
                            "rewardEmailSubject": {
                                "en": null,
                                "ar_SA": null
                            },
                            "rewardEmailContent": {
                                "en": null,
                                "ar_SA": null
                            },
                            "couponCodeInEmail": false,
                            "claimURLInEmail": false,
                            "siteId": "10",
                            "maxUser": 1,
                            "redeemed": 0,
                            "claimed": 1,
                            "status": "AVAILABLE",
                            "partner": {
                                "partnerId": "St345vp",
                                "partnerName": "Steers"
                            },
                            "categories": [
                                {
                                    "id": 7394,
                                    "title": {
                                        "en": "Fast Food",
                                        "ar_SA": "وجبات سريعة"
                                    }
                                }
                            ],
                            "branches": [
                                {
                                    "name": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "address": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "longitude": -74.00491476059,
                                    "latitude": 40.712622133006
                                }
                            ]
                        },
                        {
                            "title": {
                                "en": "Offer2",
                                "ar_SA": "عرض 2"
                            },
                            "rewardId": 7486,
                            "rewardType": "Reward",
                            "redemptionType": "ExternalRedemption",
                            "offerValue": "50AED",
                            "offerId": "SEB123",
                            "points": 50,
                            "quantity": 0,
                            "totalCoupon": 0,
                            "content": {
                                "en": "<p>SAR 80 Discount on The Secret Room</p>\n",
                                "ar_SA": "<p>خصم&nbsp;٨٠ ريال على الغرفة السرية</p>\n"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "termsAndCondtions": {
                                "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                            },
                            "buttonText": {
                                "en": "Redeem",
                                "ar_SA": "يسترد"
                            },
                            "disclaimer": {
                                "en": null,
                                "ar_SA": null
                            },
                            "buttonUrl": null,
                            "displayStartDate": 1667933100,
                            "displayEndDate": 1670006700,
                            "expirationDate": 1670006700,
                            "firstTimeUser": null,
                            "voucherPin": null,
                            "hideWhenClaimed": false,
                            "displayOrder": 0,
                            "expirationAmount": 5,
                            "expirationUnit": "days",
                            "rewardEmailSubject": {
                                "en": null,
                                "ar_SA": null
                            },
                            "rewardEmailContent": {
                                "en": null,
                                "ar_SA": null
                            },
                            "couponCodeInEmail": false,
                            "claimURLInEmail": false,
                            "siteId": "10",
                            "maxUser": 1,
                            "redeemed": 0,
                            "claimed": 1,
                            "status": "AVAILABLE",
                            "partner": {
                                "partnerId": "St345vp",
                                "partnerName": "Steers"
                            },
                            "categories": [
                                {
                                    "id": 7395,
                                    "title": {
                                        "en": "Activity",
                                        "ar_SA": "نشاط"
                                    }
                                }
                            ],
                            "branches": [
                                {
                                    "name": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "address": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "longitude": -74.00491476059,
                                    "latitude": 40.712622133006
                                }
                            ]
                        }
                    ],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/challenge": {
      "get": {
        "tags": [
          "Challenges"
        ],
        "summary": "Challenge List",
        "description": "Challenge List",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "type",
            "in": "query",
            "required": false,
            "description": "type",
            "schema": {
              "type": "string",
              "default": "all"
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          },
          {
            "name": "orderKey",
            "in": "query",
            "required": false,
            "description": "orderKey",
            "schema": {
              "type": "string",
              "default": "o_CreationDate"
            }
          },
          {
            "name": "order",
            "in": "query",
            "required": false,
            "description": "order",
            "schema": {
              "type": "string",
              "default": "asc"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 28,
                    "data": [
                        {
                            "title": {
                                "en": "Win Free Movie Tickets",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "description": {
                                "en": "<p>Music Concert Tickets!</p>\n",
                                "ar_SA": "<p>شارك في استبيان Pepsi واربح تذاكر السينما</p>\n"
                            },
                            "detailDescription": {
                                "en": "<p>Answer this simple survey &amp; get free Movie tickets. Offer valid till Ticket stock lasts. Hurry Up! Claim your ticket now!</p>\n\n<p>&nbsp;</p>\n\n<p>Reward: Movie Ticket</p>\n",
                                "ar_SA": "<p>أجب عن هذا الاستبيان البسيط واحصل على تذاكر أفلام مجانية. العرض ساري حتى نفاذ مخزون التذاكر. عجلوا! اطلب تذكرتك الآن!</p>\n"
                            },
                            "subType": {
                                "en": "Play Now",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeInfoText": {
                                "en": "Play Now",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeEndsInText": {
                                "en": "Ends In",
                                "ar_SA": "ينتهي في"
                            },
                            "termCondition": {
                                "en": "<p>Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions</p>\n",
                                "ar_SA": "<p>الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية</p>\n"
                            },
                            "challengePrimaryText": {
                                "en": "Play & Win",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeSecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 8397,
                            "type": "Survey",
                            "maxUsers": null,
                            "totalParticipants": 0,
                            "displayOrder": null,
                            "rewardType": "Reward",
                            "points": 0,
                            "displayStartDate": 1670353200,
                            "displayEndDate": 1678566600,
                            "expirationDate": 1678566600,
                            "expirationDateFilter": 1678566600.008351,
                            "status": "Active",
                            "challengePrimaryTextColor": "#ffffff",
                            "challengePrimaryBackgroundColor": "#00aff2",
                            "challengeSecondaryTextColor": "#00aff2",
                            "challengeSecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/pmusic.JPG",
                            "backgroundImage": "",
                            "video": "",
                            "reward": {
                                "id": 8065,
                                "rewardId": 8064,
                                "offerId": "VOX195E86",
                                "title": {
                                    "en": "VOX195E86",
                                    "ar_SA": "VOX195E86"
                                },
                                "rewardType": "Gifting",
                                "redemptionType": "ExternalRedemption",
                                "couponValue": "35",
                                "quantity": 0,
                                "totCoupon": 0,
                                "points": 35,
                                "disclaimer": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "categories": [
                                    {
                                        "id": 7494,
                                        "title": {
                                            "en": "Entertainment",
                                            "ar_SA": "وسائل الترفيه"
                                        }
                                    }
                                ],
                                "partner": {
                                    "partnerId": "VOX534725",
                                    "partnerName": "VOX CINEMA "
                                },
                                "branches": [],
                                "content": {
                                    "en": "FREE Standard Cinema Ticket ",
                                    "ar_SA": "تذكرة سينما مجانية "
                                },
                                "detailDescription": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "termsAndCondtions": {
                                    "en": "• Please visit www.Voxcinemas.com/en-ae for your nearest cinema.\r\nReward Terms and Conditions:\r\nCustomer to present the voucher code at VOX Cinemas Admission counter with standard ticket experience. •Movie rating and age restrictions must be adhered to at the time of voucher/ticket purchase. •Rewards are valid for 30 days after receipt. •Booking need to be made in person and at venue. •The outside food is not permitted. •The offers cannot be used in conjunction with any other special promotions, offers, discounts, employee rewards programs, other special offerings . •All standard terms and conditions for cinema admission apply. •New safety measures www.reelcinemas.com/en-ae",
                                    "ar_SA": "المكافآت صالحة لمدة 30 يوما بعد الاستلام.\r\n• يجب إجراء الحجز شخصيا وفي المكان.\r\n• الطعام الخارجي غير مسموح به.\r\n• لا يمكن استخدام العروض بالتزامن مع أي عروض ترويجية خاصة أخرى أو عروض أو خصومات أو برامج مكافآت الموظفين أو عروض خاصة أخرى.\r\n• تطبق جميع الشروط والأحكام القياسية للقبول في السينما. \r\n• تدابير السلامة الجديدة www.reelcinemas.com/en-ae"
                                },
                                "buttonText": {
                                    "en": "Redeem",
                                    "ar_SA": "Redeem"
                                },
                                "voucherPin": null,
                                "buttonUrl": null,
                                "displayStartDate": 1670507648,
                                "displayEndDate": 1673099648,
                                "expirationDate": 1673099648,
                                "firstTimeUser": null,
                                "hideWhenClaimed": true,
                                "displayOrder": null,
                                "rewardEmailSubject": null,
                                "rewardEmailContent": null,
                                "emailRewardCode": false,
                                "emailRewardURL": false
                            },
                            "draw": null,
                            "wallpaper": null,
                            "survey": {
                                "id": 7972,
                                "isAnswerable": "No",
                                "title": {
                                    "en": "Win Free Movie Tickets",
                                    "ar_SA": "اربح تذاكر أفلام مجانية"
                                },
                                "displayStartDate": 1670351400,
                                "displayEndDate": 1674937800,
                                "questions": [
                                    {
                                        "questionId": 1,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "When do you consume snacks",
                                            "ar_SA": "متى تستهلك الوجبات الخفيفة"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Watching Movies ",
                                                "House Parties",
                                                "With Family",
                                                "Evening snacks time"
                                            ],
                                            "ar_SA": [
                                                "مشاهدة الأفلام",
                                                "حفلات البيت",
                                                "مع العائلة",
                                                "وقت الوجبات الخفيفة في المساء"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "Watching Movies ",
                                                "House Parties",
                                                "With Family",
                                                "Evening snacks time"
                                            ],
                                            "ar_SA": [
                                                "مشاهدة الأفلام",
                                                "حفلات البيت",
                                                "مع العائلة",
                                                "وقت الوجبات الخفيفة في المساء"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": {
                                            "en": [
                                                "No",
                                                "No",
                                                "No",
                                                "No"
                                            ],
                                            "ar_SA": [
                                                "No",
                                                "No",
                                                "No",
                                                "No"
                                            ]
                                        }
                                    }
                                ]
                            },
                            "challengeStatus": "incomplete",
                            "challengeAddedDate": null
                        },
                        {
                            "title": {
                                "en": "Win Free Movie Tickets",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "description": {
                                "en": "<p>Music Concert Tickets!</p>\n",
                                "ar_SA": "<p>شارك في استبيان Pepsi واربح تذاكر السينما</p>\n"
                            },
                            "detailDescription": {
                                "en": "<p>Answer this simple survey &amp; get free Movie tickets. Offer valid till Ticket stock lasts. Hurry Up! Claim your ticket now!</p>\n\n<p>&nbsp;</p>\n\n<p>Reward: Movie Ticket</p>\n",
                                "ar_SA": "<p>أجب عن هذا الاستبيان البسيط واحصل على تذاكر أفلام مجانية. العرض ساري حتى نفاذ مخزون التذاكر. عجلوا! اطلب تذكرتك الآن!</p>\n"
                            },
                            "subType": {
                                "en": "Play Now",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeInfoText": {
                                "en": "Play Now",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeEndsInText": {
                                "en": "Ends In",
                                "ar_SA": "ينتهي في"
                            },
                            "termCondition": {
                                "en": "<p>Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions</p>\n",
                                "ar_SA": "<p>الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية</p>\n"
                            },
                            "challengePrimaryText": {
                                "en": "Play & Win",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeSecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 8396,
                            "type": "Survey",
                            "maxUsers": null,
                            "totalParticipants": 0,
                            "displayOrder": null,
                            "rewardType": "Reward",
                            "points": 0,
                            "displayStartDate": 1670353200,
                            "displayEndDate": 1678566600,
                            "expirationDate": 1678566600,
                            "expirationDateFilter": 1678566600.052258,
                            "status": "Active",
                            "challengePrimaryTextColor": "#ffffff",
                            "challengePrimaryBackgroundColor": "#00aff2",
                            "challengeSecondaryTextColor": "#00aff2",
                            "challengeSecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/pepsi%20music.JPG",
                            "backgroundImage": "",
                            "video": "",
                            "reward": {
                                "id": 8065,
                                "rewardId": 8064,
                                "offerId": "VOX195E86",
                                "title": {
                                    "en": "VOX195E86",
                                    "ar_SA": "VOX195E86"
                                },
                                "rewardType": "Gifting",
                                "redemptionType": "ExternalRedemption",
                                "couponValue": "35",
                                "quantity": 0,
                                "totCoupon": 0,
                                "points": 35,
                                "disclaimer": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "categories": [
                                    {
                                        "id": 7494,
                                        "title": {
                                            "en": "Entertainment",
                                            "ar_SA": "وسائل الترفيه"
                                        }
                                    }
                                ],
                                "partner": {
                                    "partnerId": "VOX534725",
                                    "partnerName": "VOX CINEMA "
                                },
                                "branches": [],
                                "content": {
                                    "en": "FREE Standard Cinema Ticket ",
                                    "ar_SA": "تذكرة سينما مجانية "
                                },
                                "detailDescription": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "termsAndCondtions": {
                                    "en": "• Please visit www.Voxcinemas.com/en-ae for your nearest cinema.\r\nReward Terms and Conditions:\r\nCustomer to present the voucher code at VOX Cinemas Admission counter with standard ticket experience. •Movie rating and age restrictions must be adhered to at the time of voucher/ticket purchase. •Rewards are valid for 30 days after receipt. •Booking need to be made in person and at venue. •The outside food is not permitted. •The offers cannot be used in conjunction with any other special promotions, offers, discounts, employee rewards programs, other special offerings . •All standard terms and conditions for cinema admission apply. •New safety measures www.reelcinemas.com/en-ae",
                                    "ar_SA": "المكافآت صالحة لمدة 30 يوما بعد الاستلام.\r\n• يجب إجراء الحجز شخصيا وفي المكان.\r\n• الطعام الخارجي غير مسموح به.\r\n• لا يمكن استخدام العروض بالتزامن مع أي عروض ترويجية خاصة أخرى أو عروض أو خصومات أو برامج مكافآت الموظفين أو عروض خاصة أخرى.\r\n• تطبق جميع الشروط والأحكام القياسية للقبول في السينما. \r\n• تدابير السلامة الجديدة www.reelcinemas.com/en-ae"
                                },
                                "buttonText": {
                                    "en": "Redeem",
                                    "ar_SA": "Redeem"
                                },
                                "voucherPin": null,
                                "buttonUrl": null,
                                "displayStartDate": 1670507648,
                                "displayEndDate": 1673099648,
                                "expirationDate": 1673099648,
                                "firstTimeUser": null,
                                "hideWhenClaimed": true,
                                "displayOrder": null,
                                "rewardEmailSubject": null,
                                "rewardEmailContent": null,
                                "emailRewardCode": false,
                                "emailRewardURL": false
                            },
                            "draw": null,
                            "wallpaper": null,
                            "survey": {
                                "id": 7972,
                                "isAnswerable": "No",
                                "title": {
                                    "en": "Win Free Movie Tickets",
                                    "ar_SA": "اربح تذاكر أفلام مجانية"
                                },
                                "displayStartDate": 1670351400,
                                "displayEndDate": 1674937800,
                                "questions": [
                                    {
                                        "questionId": 1,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "When do you consume snacks",
                                            "ar_SA": "متى تستهلك الوجبات الخفيفة"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Watching Movies ",
                                                "House Parties",
                                                "With Family",
                                                "Evening snacks time"
                                            ],
                                            "ar_SA": [
                                                "مشاهدة الأفلام",
                                                "حفلات البيت",
                                                "مع العائلة",
                                                "وقت الوجبات الخفيفة في المساء"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "Watching Movies ",
                                                "House Parties",
                                                "With Family",
                                                "Evening snacks time"
                                            ],
                                            "ar_SA": [
                                                "مشاهدة الأفلام",
                                                "حفلات البيت",
                                                "مع العائلة",
                                                "وقت الوجبات الخفيفة في المساء"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": {
                                            "en": [
                                                "No",
                                                "No",
                                                "No",
                                                "No"
                                            ],
                                            "ar_SA": [
                                                "No",
                                                "No",
                                                "No",
                                                "No"
                                            ]
                                        }
                                    }
                                ]
                            },
                            "challengeStatus": "incomplete",
                            "challengeAddedDate": null
                        },
                        {
                            "title": {
                                "en": "Answer Movie Survey & Win Movie Ticket",
                                "ar_SA": "أجب عن استبيان الفيلم واربح نقاط الفيلم"
                            },
                            "description": {
                                "en": "<p>Win Movie tickets!!</p>\n",
                                "ar_SA": "<p>أجب عن استطلاع الفيلم هذا واربح أحدث تذاكر الفيلم. أجب بسرعة. العرض ساري حتى نفاد مخزون التذاكر</p>\n"
                            },
                            "detailDescription": {
                                "en": "<p>Answer this movie survey and win latest Movie tickets. Answer fast. Offer valid till tickets stock last</p>\n\n<p>Rewards:</p>\n\n<p>Movie Ticket</p>\n",
                                "ar_SA": "<p>أجب عن استطلاع الفيلم هذا واربح أحدث تذاكر الفيلم. أجب بسرعة. العرض ساري حتى نفاد مخزون التذاكر</p>\n\n<p>المكافآت:</p>\n\n<p>تذكرة الفيلم</p>\n"
                            },
                            "subType": {
                                "en": "Answer Movie Survey & Win Movie Ticket",
                                "ar_SA": "أجب عن استطلاع الفيلم هذا واربح أحدث تذاكر الفيلم. أجب بسرعة. العرض ساري حتى نفاد مخزون التذاكر"
                            },
                            "challengeInfoText": {
                                "en": "Answer Movie Survey & Win Movie Ticket",
                                "ar_SA": "أجب عن استطلاع الفيلم هذا واربح أحدث تذاكر الفيلم. أجب بسرعة. العرض ساري حتى نفاد مخزون التذاكر"
                            },
                            "challengeEndsInText": {
                                "en": "Ends in ",
                                "ar_SA": "ينتهي في"
                            },
                            "termCondition": {
                                "en": null,
                                "ar_SA": "<p>العرض ساري حتى نفاد مخزون التذاكر</p>\n\n<p>&nbsp;</p>\n"
                            },
                            "challengePrimaryText": {
                                "en": "Quick Survey",
                                "ar_SA": null
                            },
                            "challengeSecondaryText": {
                                "en": "Details",
                                "ar_SA": null
                            },
                            "id": 8395,
                            "type": "Survey",
                            "maxUsers": null,
                            "totalParticipants": 0,
                            "displayOrder": null,
                            "rewardType": "Reward",
                            "points": 0,
                            "displayStartDate": 1670307914,
                            "displayEndDate": 1677184200,
                            "expirationDate": 1677184200,
                            "expirationDateFilter": 1677184200.052744,
                            "status": "Active",
                            "challengePrimaryTextColor": "#ffffff",
                            "challengePrimaryBackgroundColor": "#00aff2",
                            "challengeSecondaryTextColor": "#00aff2",
                            "challengeSecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Doritos%20Movies.JPG",
                            "backgroundImage": "",
                            "video": "",
                            "reward": {
                                "id": 8065,
                                "rewardId": 8064,
                                "offerId": "VOX195E86",
                                "title": {
                                    "en": "VOX195E86",
                                    "ar_SA": "VOX195E86"
                                },
                                "rewardType": "Gifting",
                                "redemptionType": "ExternalRedemption",
                                "couponValue": "35",
                                "quantity": 0,
                                "totCoupon": 0,
                                "points": 35,
                                "disclaimer": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "categories": [
                                    {
                                        "id": 7494,
                                        "title": {
                                            "en": "Entertainment",
                                            "ar_SA": "وسائل الترفيه"
                                        }
                                    }
                                ],
                                "partner": {
                                    "partnerId": "VOX534725",
                                    "partnerName": "VOX CINEMA "
                                },
                                "branches": [],
                                "content": {
                                    "en": "FREE Standard Cinema Ticket ",
                                    "ar_SA": "تذكرة سينما مجانية "
                                },
                                "detailDescription": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "termsAndCondtions": {
                                    "en": "• Please visit www.Voxcinemas.com/en-ae for your nearest cinema.\r\nReward Terms and Conditions:\r\nCustomer to present the voucher code at VOX Cinemas Admission counter with standard ticket experience. •Movie rating and age restrictions must be adhered to at the time of voucher/ticket purchase. •Rewards are valid for 30 days after receipt. •Booking need to be made in person and at venue. •The outside food is not permitted. •The offers cannot be used in conjunction with any other special promotions, offers, discounts, employee rewards programs, other special offerings . •All standard terms and conditions for cinema admission apply. •New safety measures www.reelcinemas.com/en-ae",
                                    "ar_SA": "المكافآت صالحة لمدة 30 يوما بعد الاستلام.\r\n• يجب إجراء الحجز شخصيا وفي المكان.\r\n• الطعام الخارجي غير مسموح به.\r\n• لا يمكن استخدام العروض بالتزامن مع أي عروض ترويجية خاصة أخرى أو عروض أو خصومات أو برامج مكافآت الموظفين أو عروض خاصة أخرى.\r\n• تطبق جميع الشروط والأحكام القياسية للقبول في السينما. \r\n• تدابير السلامة الجديدة www.reelcinemas.com/en-ae"
                                },
                                "buttonText": {
                                    "en": "Redeem",
                                    "ar_SA": "Redeem"
                                },
                                "voucherPin": null,
                                "buttonUrl": null,
                                "displayStartDate": 1670507648,
                                "displayEndDate": 1673099648,
                                "expirationDate": 1673099648,
                                "firstTimeUser": null,
                                "hideWhenClaimed": true,
                                "displayOrder": null,
                                "rewardEmailSubject": null,
                                "rewardEmailContent": null,
                                "emailRewardCode": false,
                                "emailRewardURL": false
                            },
                            "draw": null,
                            "wallpaper": null,
                            "survey": {
                                "id": 7562,
                                "isAnswerable": null,
                                "title": {
                                    "en": "QUICK SURVEY",
                                    "ar_SA": "مسح سريع"
                                },
                                "displayStartDate": 1669143600,
                                "displayEndDate": 1672340400,
                                "questions": [
                                    {
                                        "questionId": 1,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "Which one is your favorite Pepsi?",
                                            "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Pepsi Diet",
                                                "Pepsi Wild Cherry",
                                                "Pepsi Max",
                                                "Pepsi Original"
                                            ],
                                            "ar_SA": [
                                                "بيبسي دايت",
                                                "بيبسي اوريجينال",
                                                "بيبسي وايلد شيري",
                                                "بيبسي ماكس"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ],
                                            "ar_SA": [
                                                "pepsi_det",
                                                "pepsi_original",
                                                "pepsi_wild_cherry",
                                                "pepsi_max"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": {
                                            "en": [
                                                "No",
                                                "No",
                                                "No"
                                            ]
                                        }
                                    },
                                    {
                                        "questionId": 2,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "Which one is your favorite Pepsi?",
                                            "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Pepsi Diet",
                                                "Pepsi Wild Cherry",
                                                "Pepsi Max",
                                                "Pepsi Original"
                                            ],
                                            "ar_SA": [
                                                "بيبسي دايت",
                                                "بيبسي وايلد شيري",
                                                "بيبسي ماكس",
                                                "بيبسي اوريجينال"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ],
                                            "ar_SA": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": null
                                    },
                                    {
                                        "questionId": 3,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "Which one is your favorite Pepsi?",
                                            "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Pepsi Diet",
                                                "Pepsi Wild Cherry",
                                                "Pepsi Max",
                                                "Pepsi Original"
                                            ],
                                            "ar_SA": [
                                                "بيبسي دايت",
                                                "بيبسي وايلد شيري",
                                                "بيبسي ماكس",
                                                "بيبسي اوريجينال"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ],
                                            "ar_SA": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": null
                                    },
                                    {
                                        "questionId": 4,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "Which one is your favorite Pepsi?",
                                            "ar_SA": "أيهما بيبسي المفضل لديك؟z"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Pepsi Diet",
                                                "Pepsi Wild Cherry",
                                                "Pepsi Max",
                                                "Pepsi Original"
                                            ],
                                            "ar_SA": [
                                                "بيبسي دايت",
                                                "بيبسي وايلد شيري",
                                                "بيبسي ماكس",
                                                "بيبسي اوريجينال"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ],
                                            "ar_SA": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": null
                                    }
                                ]
                            },
                            "challengeStatus": "incomplete",
                            "challengeAddedDate": null
                        },
                        {
                            "title": {
                                "en": "Answer Movie Survey & Win Movie Ticket",
                                "ar_SA": "أجب عن استبيان الفيلم واربح نقاط الفيلم"
                            },
                            "description": {
                                "en": "<p>Win Movie tickets!!</p>\n",
                                "ar_SA": "<p>أجب عن استطلاع الفيلم هذا واربح أحدث تذاكر الفيلم. أجب بسرعة. العرض ساري حتى نفاد مخزون التذاكر</p>\n"
                            },
                            "detailDescription": {
                                "en": "<p>Answer this movie survey and win latest Movie tickets. Answer fast. Offer valid till tickets stock last</p>\n\n<p>Rewards:</p>\n\n<p>Movie Ticket</p>\n",
                                "ar_SA": "<p>أجب عن استطلاع الفيلم هذا واربح أحدث تذاكر الفيلم. أجب بسرعة. العرض ساري حتى نفاد مخزون التذاكر</p>\n\n<p>المكافآت:</p>\n\n<p>تذكرة الفيلم</p>\n"
                            },
                            "subType": {
                                "en": "Answer Movie Survey & Win Movie Ticket",
                                "ar_SA": "أجب عن استطلاع الفيلم هذا واربح أحدث تذاكر الفيلم. أجب بسرعة. العرض ساري حتى نفاد مخزون التذاكر"
                            },
                            "challengeInfoText": {
                                "en": "Answer Movie Survey & Win Movie Ticket",
                                "ar_SA": "أجب عن استطلاع الفيلم هذا واربح أحدث تذاكر الفيلم. أجب بسرعة. العرض ساري حتى نفاد مخزون التذاكر"
                            },
                            "challengeEndsInText": {
                                "en": "Ends in ",
                                "ar_SA": "ينتهي في"
                            },
                            "termCondition": {
                                "en": null,
                                "ar_SA": "<p>العرض ساري حتى نفاد مخزون التذاكر</p>\n\n<p>&nbsp;</p>\n"
                            },
                            "challengePrimaryText": {
                                "en": "Quick Survey",
                                "ar_SA": null
                            },
                            "challengeSecondaryText": {
                                "en": "Details",
                                "ar_SA": null
                            },
                            "id": 8394,
                            "type": "Survey",
                            "maxUsers": null,
                            "totalParticipants": 0,
                            "displayOrder": null,
                            "rewardType": "Reward",
                            "points": 0,
                            "displayStartDate": 1670307914,
                            "displayEndDate": 1677184200,
                            "expirationDate": 1677184200,
                            "expirationDateFilter": 1677184200.08898,
                            "status": "Active",
                            "challengePrimaryTextColor": "#ffffff",
                            "challengePrimaryBackgroundColor": "#00aff2",
                            "challengeSecondaryTextColor": "#00aff2",
                            "challengeSecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Spiderman%20holidays.JPG",
                            "backgroundImage": "",
                            "video": "",
                            "reward": {
                                "id": 8065,
                                "rewardId": 8064,
                                "offerId": "VOX195E86",
                                "title": {
                                    "en": "VOX195E86",
                                    "ar_SA": "VOX195E86"
                                },
                                "rewardType": "Gifting",
                                "redemptionType": "ExternalRedemption",
                                "couponValue": "35",
                                "quantity": 0,
                                "totCoupon": 0,
                                "points": 35,
                                "disclaimer": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "categories": [
                                    {
                                        "id": 7494,
                                        "title": {
                                            "en": "Entertainment",
                                            "ar_SA": "وسائل الترفيه"
                                        }
                                    }
                                ],
                                "partner": {
                                    "partnerId": "VOX534725",
                                    "partnerName": "VOX CINEMA "
                                },
                                "branches": [],
                                "content": {
                                    "en": "FREE Standard Cinema Ticket ",
                                    "ar_SA": "تذكرة سينما مجانية "
                                },
                                "detailDescription": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "termsAndCondtions": {
                                    "en": "• Please visit www.Voxcinemas.com/en-ae for your nearest cinema.\r\nReward Terms and Conditions:\r\nCustomer to present the voucher code at VOX Cinemas Admission counter with standard ticket experience. •Movie rating and age restrictions must be adhered to at the time of voucher/ticket purchase. •Rewards are valid for 30 days after receipt. •Booking need to be made in person and at venue. •The outside food is not permitted. •The offers cannot be used in conjunction with any other special promotions, offers, discounts, employee rewards programs, other special offerings . •All standard terms and conditions for cinema admission apply. •New safety measures www.reelcinemas.com/en-ae",
                                    "ar_SA": "المكافآت صالحة لمدة 30 يوما بعد الاستلام.\r\n• يجب إجراء الحجز شخصيا وفي المكان.\r\n• الطعام الخارجي غير مسموح به.\r\n• لا يمكن استخدام العروض بالتزامن مع أي عروض ترويجية خاصة أخرى أو عروض أو خصومات أو برامج مكافآت الموظفين أو عروض خاصة أخرى.\r\n• تطبق جميع الشروط والأحكام القياسية للقبول في السينما. \r\n• تدابير السلامة الجديدة www.reelcinemas.com/en-ae"
                                },
                                "buttonText": {
                                    "en": "Redeem",
                                    "ar_SA": "Redeem"
                                },
                                "voucherPin": null,
                                "buttonUrl": null,
                                "displayStartDate": 1670507648,
                                "displayEndDate": 1673099648,
                                "expirationDate": 1673099648,
                                "firstTimeUser": null,
                                "hideWhenClaimed": true,
                                "displayOrder": null,
                                "rewardEmailSubject": null,
                                "rewardEmailContent": null,
                                "emailRewardCode": false,
                                "emailRewardURL": false
                            },
                            "draw": null,
                            "wallpaper": null,
                            "survey": {
                                "id": 7562,
                                "isAnswerable": null,
                                "title": {
                                    "en": "QUICK SURVEY",
                                    "ar_SA": "مسح سريع"
                                },
                                "displayStartDate": 1669143600,
                                "displayEndDate": 1672340400,
                                "questions": [
                                    {
                                        "questionId": 1,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "Which one is your favorite Pepsi?",
                                            "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Pepsi Diet",
                                                "Pepsi Wild Cherry",
                                                "Pepsi Max",
                                                "Pepsi Original"
                                            ],
                                            "ar_SA": [
                                                "بيبسي دايت",
                                                "بيبسي اوريجينال",
                                                "بيبسي وايلد شيري",
                                                "بيبسي ماكس"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ],
                                            "ar_SA": [
                                                "pepsi_det",
                                                "pepsi_original",
                                                "pepsi_wild_cherry",
                                                "pepsi_max"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": {
                                            "en": [
                                                "No",
                                                "No",
                                                "No"
                                            ]
                                        }
                                    },
                                    {
                                        "questionId": 2,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "Which one is your favorite Pepsi?",
                                            "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Pepsi Diet",
                                                "Pepsi Wild Cherry",
                                                "Pepsi Max",
                                                "Pepsi Original"
                                            ],
                                            "ar_SA": [
                                                "بيبسي دايت",
                                                "بيبسي وايلد شيري",
                                                "بيبسي ماكس",
                                                "بيبسي اوريجينال"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ],
                                            "ar_SA": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": null
                                    },
                                    {
                                        "questionId": 3,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "Which one is your favorite Pepsi?",
                                            "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Pepsi Diet",
                                                "Pepsi Wild Cherry",
                                                "Pepsi Max",
                                                "Pepsi Original"
                                            ],
                                            "ar_SA": [
                                                "بيبسي دايت",
                                                "بيبسي وايلد شيري",
                                                "بيبسي ماكس",
                                                "بيبسي اوريجينال"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ],
                                            "ar_SA": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": null
                                    },
                                    {
                                        "questionId": 4,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "Which one is your favorite Pepsi?",
                                            "ar_SA": "أيهما بيبسي المفضل لديك؟z"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Pepsi Diet",
                                                "Pepsi Wild Cherry",
                                                "Pepsi Max",
                                                "Pepsi Original"
                                            ],
                                            "ar_SA": [
                                                "بيبسي دايت",
                                                "بيبسي وايلد شيري",
                                                "بيبسي ماكس",
                                                "بيبسي اوريجينال"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ],
                                            "ar_SA": [
                                                "pepsi_det",
                                                "pepsi_wild_cherry",
                                                "pepsi_max",
                                                "pepsi_original"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": null
                                    }
                                ]
                            },
                            "challengeStatus": "incomplete",
                            "challengeAddedDate": null
                        },
                        {
                            "title": {
                                "en": "Unlock Free Movie Ticket!",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "description": {
                                "en": "<p>Win Movie Tickets! Hurry</p>\n",
                                "ar_SA": "<p>شارك في استبيان Lays واربح تذاكر السينما</p>\n"
                            },
                            "detailDescription": {
                                "en": "<p>Answer this simple survey &amp; get free Movie tickets. Offer valid till Ticket stock lasts. Hurry Up! Claim your ticket now!</p>\n\n<p>&nbsp;</p>\n\n<p>Reward: Movie Ticket</p>\n",
                                "ar_SA": "<p>أجب عن هذا الاستبيان البسيط واحصل على تذاكر أفلام مجانية. العرض ساري حتى نفاذ مخزون التذاكر. عجلوا! اطلب تذكرتك الآن!</p>\n"
                            },
                            "subType": {
                                "en": "Unlock Free Movie Ticket!",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeInfoText": {
                                "en": "Unlock Free Movie Ticket!",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeEndsInText": {
                                "en": "Ends In",
                                "ar_SA": "ينتهي في"
                            },
                            "termCondition": {
                                "en": "<p>Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions</p>\n",
                                "ar_SA": "<p>الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية</p>\n"
                            },
                            "challengePrimaryText": {
                                "en": "Play Now!",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeSecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 8393,
                            "type": "Survey",
                            "maxUsers": null,
                            "totalParticipants": 0,
                            "displayOrder": null,
                            "rewardType": "Reward",
                            "points": 0,
                            "displayStartDate": 1670353200,
                            "displayEndDate": 1678566600,
                            "expirationDate": 1678566600,
                            "expirationDateFilter": 1678566600.089534,
                            "status": "Active",
                            "challengePrimaryTextColor": "#ffffff",
                            "challengePrimaryBackgroundColor": "#00aff2",
                            "challengeSecondaryTextColor": "#00aff2",
                            "challengeSecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Lays%20Movies.JPG",
                            "backgroundImage": "",
                            "video": "",
                            "reward": {
                                "id": 8065,
                                "rewardId": 8064,
                                "offerId": "VOX195E86",
                                "title": {
                                    "en": "VOX195E86",
                                    "ar_SA": "VOX195E86"
                                },
                                "rewardType": "Gifting",
                                "redemptionType": "ExternalRedemption",
                                "couponValue": "35",
                                "quantity": 0,
                                "totCoupon": 0,
                                "points": 35,
                                "disclaimer": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "categories": [
                                    {
                                        "id": 7494,
                                        "title": {
                                            "en": "Entertainment",
                                            "ar_SA": "وسائل الترفيه"
                                        }
                                    }
                                ],
                                "partner": {
                                    "partnerId": "VOX534725",
                                    "partnerName": "VOX CINEMA "
                                },
                                "branches": [],
                                "content": {
                                    "en": "FREE Standard Cinema Ticket ",
                                    "ar_SA": "تذكرة سينما مجانية "
                                },
                                "detailDescription": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "termsAndCondtions": {
                                    "en": "• Please visit www.Voxcinemas.com/en-ae for your nearest cinema.\r\nReward Terms and Conditions:\r\nCustomer to present the voucher code at VOX Cinemas Admission counter with standard ticket experience. •Movie rating and age restrictions must be adhered to at the time of voucher/ticket purchase. •Rewards are valid for 30 days after receipt. •Booking need to be made in person and at venue. •The outside food is not permitted. •The offers cannot be used in conjunction with any other special promotions, offers, discounts, employee rewards programs, other special offerings . •All standard terms and conditions for cinema admission apply. •New safety measures www.reelcinemas.com/en-ae",
                                    "ar_SA": "المكافآت صالحة لمدة 30 يوما بعد الاستلام.\r\n• يجب إجراء الحجز شخصيا وفي المكان.\r\n• الطعام الخارجي غير مسموح به.\r\n• لا يمكن استخدام العروض بالتزامن مع أي عروض ترويجية خاصة أخرى أو عروض أو خصومات أو برامج مكافآت الموظفين أو عروض خاصة أخرى.\r\n• تطبق جميع الشروط والأحكام القياسية للقبول في السينما. \r\n• تدابير السلامة الجديدة www.reelcinemas.com/en-ae"
                                },
                                "buttonText": {
                                    "en": "Redeem",
                                    "ar_SA": "Redeem"
                                },
                                "voucherPin": null,
                                "buttonUrl": null,
                                "displayStartDate": 1670507648,
                                "displayEndDate": 1673099648,
                                "expirationDate": 1673099648,
                                "firstTimeUser": null,
                                "hideWhenClaimed": true,
                                "displayOrder": null,
                                "rewardEmailSubject": null,
                                "rewardEmailContent": null,
                                "emailRewardCode": false,
                                "emailRewardURL": false
                            },
                            "draw": null,
                            "wallpaper": null,
                            "survey": {
                                "id": 7971,
                                "isAnswerable": "No",
                                "title": {
                                    "en": "Win Free Movie Tickets",
                                    "ar_SA": "اربح تذاكر أفلام مجانية"
                                },
                                "displayStartDate": 1670351400,
                                "displayEndDate": 1674937800,
                                "questions": [
                                    {
                                        "questionId": 1,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "When do you consume snacks",
                                            "ar_SA": "متى تستهلك الوجبات الخفيفة"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Watching Movies ",
                                                "House Parties",
                                                "With Family",
                                                "Evening snacks time"
                                            ],
                                            "ar_SA": [
                                                "مشاهدة الأفلام",
                                                "حفلات البيت",
                                                "مع العائلة",
                                                "وقت الوجبات الخفيفة في المساء"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "Watching Movies ",
                                                "House Parties",
                                                "With Family",
                                                "Evening snacks time"
                                            ],
                                            "ar_SA": [
                                                "مشاهدة الأفلام",
                                                "حفلات البيت",
                                                "مع العائلة",
                                                "وقت الوجبات الخفيفة في المساء"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": null
                                    }
                                ]
                            },
                            "challengeStatus": "incomplete",
                            "challengeAddedDate": null
                        },
                        {
                            "title": {
                                "en": "Unlock Free Movie Ticket!",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "description": {
                                "en": "<p>Halloween Deals!!</p>\n",
                                "ar_SA": "<p>شارك في استبيان Lays واربح تذاكر السينما</p>\n"
                            },
                            "detailDescription": {
                                "en": "<p>Answer this simple survey &amp; get free Movie tickets. Offer valid till Ticket stock lasts. Hurry Up! Claim your ticket now!</p>\n\n<p>&nbsp;</p>\n\n<p>Reward: Movie Ticket</p>\n",
                                "ar_SA": "<p>أجب عن هذا الاستبيان البسيط واحصل على تذاكر أفلام مجانية. العرض ساري حتى نفاذ مخزون التذاكر. عجلوا! اطلب تذكرتك الآن!</p>\n"
                            },
                            "subType": {
                                "en": "Unlock Free Movie Ticket!",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeInfoText": {
                                "en": "Unlock Free Movie Ticket!",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeEndsInText": {
                                "en": "Ends In",
                                "ar_SA": "ينتهي في"
                            },
                            "termCondition": {
                                "en": "<p>Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions</p>\n",
                                "ar_SA": "<p>الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية</p>\n"
                            },
                            "challengePrimaryText": {
                                "en": "Play Now!",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeSecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 8392,
                            "type": "Survey",
                            "maxUsers": null,
                            "totalParticipants": 0,
                            "displayOrder": null,
                            "rewardType": "Reward",
                            "points": 0,
                            "displayStartDate": 1670353200,
                            "displayEndDate": 1678566600,
                            "expirationDate": 1678566600,
                            "expirationDateFilter": 1678566600.103988,
                            "status": "Active",
                            "challengePrimaryTextColor": "#ffffff",
                            "challengePrimaryBackgroundColor": "#00aff2",
                            "challengeSecondaryTextColor": "#00aff2",
                            "challengeSecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Multi%20Holidays%201.JPG",
                            "backgroundImage": "",
                            "video": "",
                            "reward": {
                                "id": 8065,
                                "rewardId": 8064,
                                "offerId": "VOX195E86",
                                "title": {
                                    "en": "VOX195E86",
                                    "ar_SA": "VOX195E86"
                                },
                                "rewardType": "Gifting",
                                "redemptionType": "ExternalRedemption",
                                "couponValue": "35",
                                "quantity": 0,
                                "totCoupon": 0,
                                "points": 35,
                                "disclaimer": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "categories": [
                                    {
                                        "id": 7494,
                                        "title": {
                                            "en": "Entertainment",
                                            "ar_SA": "وسائل الترفيه"
                                        }
                                    }
                                ],
                                "partner": {
                                    "partnerId": "VOX534725",
                                    "partnerName": "VOX CINEMA "
                                },
                                "branches": [],
                                "content": {
                                    "en": "FREE Standard Cinema Ticket ",
                                    "ar_SA": "تذكرة سينما مجانية "
                                },
                                "detailDescription": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "termsAndCondtions": {
                                    "en": "• Please visit www.Voxcinemas.com/en-ae for your nearest cinema.\r\nReward Terms and Conditions:\r\nCustomer to present the voucher code at VOX Cinemas Admission counter with standard ticket experience. •Movie rating and age restrictions must be adhered to at the time of voucher/ticket purchase. •Rewards are valid for 30 days after receipt. •Booking need to be made in person and at venue. •The outside food is not permitted. •The offers cannot be used in conjunction with any other special promotions, offers, discounts, employee rewards programs, other special offerings . •All standard terms and conditions for cinema admission apply. •New safety measures www.reelcinemas.com/en-ae",
                                    "ar_SA": "المكافآت صالحة لمدة 30 يوما بعد الاستلام.\r\n• يجب إجراء الحجز شخصيا وفي المكان.\r\n• الطعام الخارجي غير مسموح به.\r\n• لا يمكن استخدام العروض بالتزامن مع أي عروض ترويجية خاصة أخرى أو عروض أو خصومات أو برامج مكافآت الموظفين أو عروض خاصة أخرى.\r\n• تطبق جميع الشروط والأحكام القياسية للقبول في السينما. \r\n• تدابير السلامة الجديدة www.reelcinemas.com/en-ae"
                                },
                                "buttonText": {
                                    "en": "Redeem",
                                    "ar_SA": "Redeem"
                                },
                                "voucherPin": null,
                                "buttonUrl": null,
                                "displayStartDate": 1670507648,
                                "displayEndDate": 1673099648,
                                "expirationDate": 1673099648,
                                "firstTimeUser": null,
                                "hideWhenClaimed": true,
                                "displayOrder": null,
                                "rewardEmailSubject": null,
                                "rewardEmailContent": null,
                                "emailRewardCode": false,
                                "emailRewardURL": false
                            },
                            "draw": null,
                            "wallpaper": null,
                            "survey": {
                                "id": 7971,
                                "isAnswerable": "No",
                                "title": {
                                    "en": "Win Free Movie Tickets",
                                    "ar_SA": "اربح تذاكر أفلام مجانية"
                                },
                                "displayStartDate": 1670351400,
                                "displayEndDate": 1674937800,
                                "questions": [
                                    {
                                        "questionId": 1,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "When do you consume snacks",
                                            "ar_SA": "متى تستهلك الوجبات الخفيفة"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Watching Movies ",
                                                "House Parties",
                                                "With Family",
                                                "Evening snacks time"
                                            ],
                                            "ar_SA": [
                                                "مشاهدة الأفلام",
                                                "حفلات البيت",
                                                "مع العائلة",
                                                "وقت الوجبات الخفيفة في المساء"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "Watching Movies ",
                                                "House Parties",
                                                "With Family",
                                                "Evening snacks time"
                                            ],
                                            "ar_SA": [
                                                "مشاهدة الأفلام",
                                                "حفلات البيت",
                                                "مع العائلة",
                                                "وقت الوجبات الخفيفة في المساء"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": null
                                    }
                                ]
                            },
                            "challengeStatus": "incomplete",
                            "challengeAddedDate": null
                        },
                        {
                            "title": {
                                "en": "Pep Reels",
                                "ar_SA": "بيب ريلز"
                            },
                            "description": {
                                "en": "<p>Halloween Offers</p>\n",
                                "ar_SA": "<p>شاهد Doritos Reel &amp; Win مذهلة العلامة التجارية الجديدة تسلا</p>\n"
                            },
                            "detailDescription": {
                                "en": "<p>Watch Doritos Reel &amp; Win Amazing brand New Tesla&nbsp;</p>\n\n<p>Your rewards:&nbsp;</p>\n\n<p>Partcipate in a draw to win brand new TESLA!!!!</p>\n",
                                "ar_SA": "<p>شاهد Doritos Reel &amp; Win مذهلة العلامة التجارية الجديدة تسلا</p>\n"
                            },
                            "subType": {
                                "en": "Watch now ",
                                "ar_SA": "شاهد Reel & Win Tesla!"
                            },
                            "challengeInfoText": {
                                "en": "Watch now ",
                                "ar_SA": "شاهد Reel & Win Tesla!"
                            },
                            "challengeEndsInText": {
                                "en": "Expires In ",
                                "ar_SA": "ينتهى فى 5 ديسمبر"
                            },
                            "termCondition": {
                                "en": "<p>lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum The end</p>\n",
                                "ar_SA": "<p>الشروط والأحكام الوهمية</p>\n"
                            },
                            "challengePrimaryText": {
                                "en": "Play Now",
                                "ar_SA": "العب الان"
                            },
                            "challengeSecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 8391,
                            "type": "Video",
                            "maxUsers": null,
                            "totalParticipants": 0,
                            "displayOrder": null,
                            "rewardType": "",
                            "points": 0,
                            "displayStartDate": 1670238956,
                            "displayEndDate": 1672431300,
                            "expirationDate": 1672431300,
                            "expirationDateFilter": 1672431300.104362,
                            "status": "Active",
                            "challengePrimaryTextColor": "#ffffff",
                            "challengePrimaryBackgroundColor": "#00aff2",
                            "challengeSecondaryTextColor": "#00aff2",
                            "challengeSecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Doritos%20Holidays1.JPG",
                            "backgroundImage": "",
                            "video": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/Video/welcome-to-arabia-davapps.mp4",
                            "reward": null,
                            "draw": {
                                "id": 7892,
                                "title": {
                                    "en": "Doritos: Win a brand new Tesla!",
                                    "ar_SA": "دوريتوس: اربح سيارة تسلا جديدة!"
                                },
                                "description": {
                                    "en": "<p>You have got a chance to Win Tesla. Stay tuned, we will reach out to registered mobile number and email (if email is provided by you) by 20th March 2023</p>\n",
                                    "ar_SA": "<p>لديك فرصة للفوز بـ Tesla. ابق على اتصال ، وسنتواصل مع رقم الهاتف المحمول المسجل والبريد الإلكتروني (إذا تم توفير البريد الإلكتروني من قبلك) بحلول 20 مارس 2023</p>\n"
                                },
                                "terms": {
                                    "en": "<p>Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum</p>\n",
                                    "ar_SA": "<p>العرض ساري حتى نفاذ الكمية</p>\n"
                                },
                                "endDate": 1670266800,
                                "winnerDeclarationDate": 1680207300
                            },
                            "wallpaper": null,
                            "survey": null,
                            "challengeStatus": "incomplete",
                            "challengeAddedDate": null
                        },
                        {
                            "title": {
                                "en": "Win Free Movie Tickets",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "description": {
                                "en": "<p>Win Free Movie Tickets!</p>\n",
                                "ar_SA": "<p>شارك في استبيان Pepsi واربح تذاكر السينما</p>\n"
                            },
                            "detailDescription": {
                                "en": "<p>Answer this simple survey &amp; get free Movie tickets. Offer valid till Ticket stock lasts. Hurry Up! Claim your ticket now!</p>\n\n<p>&nbsp;</p>\n\n<p>Reward: Movie Ticket</p>\n",
                                "ar_SA": "<p>أجب عن هذا الاستبيان البسيط واحصل على تذاكر أفلام مجانية. العرض ساري حتى نفاذ مخزون التذاكر. عجلوا! اطلب تذكرتك الآن!</p>\n"
                            },
                            "subType": {
                                "en": "Play Now",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeInfoText": {
                                "en": "Play Now",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeEndsInText": {
                                "en": "Ends In",
                                "ar_SA": "ينتهي في"
                            },
                            "termCondition": {
                                "en": "<p>Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions</p>\n",
                                "ar_SA": "<p>الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية</p>\n"
                            },
                            "challengePrimaryText": {
                                "en": "Play Now!",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeSecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 8390,
                            "type": "Survey",
                            "maxUsers": null,
                            "totalParticipants": 0,
                            "displayOrder": null,
                            "rewardType": "Reward",
                            "points": 0,
                            "displayStartDate": 1670353200,
                            "displayEndDate": 1678566600,
                            "expirationDate": 1678566600,
                            "expirationDateFilter": 1678566600.112112,
                            "status": "Active",
                            "challengePrimaryTextColor": "#ffffff",
                            "challengePrimaryBackgroundColor": "#00aff2",
                            "challengeSecondaryTextColor": "#00aff2",
                            "challengeSecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/pepsi%20Holidays%202.JPG",
                            "backgroundImage": "",
                            "video": "",
                            "reward": {
                                "id": 8065,
                                "rewardId": 8064,
                                "offerId": "VOX195E86",
                                "title": {
                                    "en": "VOX195E86",
                                    "ar_SA": "VOX195E86"
                                },
                                "rewardType": "Gifting",
                                "redemptionType": "ExternalRedemption",
                                "couponValue": "35",
                                "quantity": 0,
                                "totCoupon": 0,
                                "points": 35,
                                "disclaimer": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "categories": [
                                    {
                                        "id": 7494,
                                        "title": {
                                            "en": "Entertainment",
                                            "ar_SA": "وسائل الترفيه"
                                        }
                                    }
                                ],
                                "partner": {
                                    "partnerId": "VOX534725",
                                    "partnerName": "VOX CINEMA "
                                },
                                "branches": [],
                                "content": {
                                    "en": "FREE Standard Cinema Ticket ",
                                    "ar_SA": "تذكرة سينما مجانية "
                                },
                                "detailDescription": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "termsAndCondtions": {
                                    "en": "• Please visit www.Voxcinemas.com/en-ae for your nearest cinema.\r\nReward Terms and Conditions:\r\nCustomer to present the voucher code at VOX Cinemas Admission counter with standard ticket experience. •Movie rating and age restrictions must be adhered to at the time of voucher/ticket purchase. •Rewards are valid for 30 days after receipt. •Booking need to be made in person and at venue. •The outside food is not permitted. •The offers cannot be used in conjunction with any other special promotions, offers, discounts, employee rewards programs, other special offerings . •All standard terms and conditions for cinema admission apply. •New safety measures www.reelcinemas.com/en-ae",
                                    "ar_SA": "المكافآت صالحة لمدة 30 يوما بعد الاستلام.\r\n• يجب إجراء الحجز شخصيا وفي المكان.\r\n• الطعام الخارجي غير مسموح به.\r\n• لا يمكن استخدام العروض بالتزامن مع أي عروض ترويجية خاصة أخرى أو عروض أو خصومات أو برامج مكافآت الموظفين أو عروض خاصة أخرى.\r\n• تطبق جميع الشروط والأحكام القياسية للقبول في السينما. \r\n• تدابير السلامة الجديدة www.reelcinemas.com/en-ae"
                                },
                                "buttonText": {
                                    "en": "Redeem",
                                    "ar_SA": "Redeem"
                                },
                                "voucherPin": null,
                                "buttonUrl": null,
                                "displayStartDate": 1670507648,
                                "displayEndDate": 1673099648,
                                "expirationDate": 1673099648,
                                "firstTimeUser": null,
                                "hideWhenClaimed": true,
                                "displayOrder": null,
                                "rewardEmailSubject": null,
                                "rewardEmailContent": null,
                                "emailRewardCode": false,
                                "emailRewardURL": false
                            },
                            "draw": null,
                            "wallpaper": null,
                            "survey": {
                                "id": 7972,
                                "isAnswerable": "No",
                                "title": {
                                    "en": "Win Free Movie Tickets",
                                    "ar_SA": "اربح تذاكر أفلام مجانية"
                                },
                                "displayStartDate": 1670351400,
                                "displayEndDate": 1674937800,
                                "questions": [
                                    {
                                        "questionId": 1,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "When do you consume snacks",
                                            "ar_SA": "متى تستهلك الوجبات الخفيفة"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Watching Movies ",
                                                "House Parties",
                                                "With Family",
                                                "Evening snacks time"
                                            ],
                                            "ar_SA": [
                                                "مشاهدة الأفلام",
                                                "حفلات البيت",
                                                "مع العائلة",
                                                "وقت الوجبات الخفيفة في المساء"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "Watching Movies ",
                                                "House Parties",
                                                "With Family",
                                                "Evening snacks time"
                                            ],
                                            "ar_SA": [
                                                "مشاهدة الأفلام",
                                                "حفلات البيت",
                                                "مع العائلة",
                                                "وقت الوجبات الخفيفة في المساء"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": {
                                            "en": [
                                                "No",
                                                "No",
                                                "No",
                                                "No"
                                            ],
                                            "ar_SA": [
                                                "No",
                                                "No",
                                                "No",
                                                "No"
                                            ]
                                        }
                                    }
                                ]
                            },
                            "challengeStatus": "incomplete",
                            "challengeAddedDate": null
                        },
                        {
                            "title": {
                                "en": "Win Free Movie Tickets",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "description": {
                                "en": "<p>Win Free Movie Tickets!</p>\n",
                                "ar_SA": "<p>شارك في استبيان Pepsi واربح تذاكر السينما</p>\n"
                            },
                            "detailDescription": {
                                "en": "<p>Answer this simple survey &amp; get free Movie tickets. Offer valid till Ticket stock lasts. Hurry Up! Claim your ticket now!</p>\n\n<p>&nbsp;</p>\n\n<p>Reward: Movie Ticket</p>\n",
                                "ar_SA": "<p>أجب عن هذا الاستبيان البسيط واحصل على تذاكر أفلام مجانية. العرض ساري حتى نفاذ مخزون التذاكر. عجلوا! اطلب تذكرتك الآن!</p>\n"
                            },
                            "subType": {
                                "en": "Play Now",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeInfoText": {
                                "en": "Play Now",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeEndsInText": {
                                "en": "Ends In",
                                "ar_SA": "ينتهي في"
                            },
                            "termCondition": {
                                "en": "<p>Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions&nbsp;Dummy Terms and conditions</p>\n",
                                "ar_SA": "<p>الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية&nbsp;الشروط والأحكام الوهمية</p>\n"
                            },
                            "challengePrimaryText": {
                                "en": "Play Now!",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "challengeSecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 8389,
                            "type": "Survey",
                            "maxUsers": null,
                            "totalParticipants": 0,
                            "displayOrder": null,
                            "rewardType": "Reward",
                            "points": 0,
                            "displayStartDate": 1670353200,
                            "displayEndDate": 1678566600,
                            "expirationDate": 1678566600,
                            "expirationDateFilter": 1678566600.112484,
                            "status": "Active",
                            "challengePrimaryTextColor": "#ffffff",
                            "challengePrimaryBackgroundColor": "#00aff2",
                            "challengeSecondaryTextColor": "#00aff2",
                            "challengeSecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Pepsi%20Holidays%201.JPG",
                            "backgroundImage": "",
                            "video": "",
                            "reward": {
                                "id": 8065,
                                "rewardId": 8064,
                                "offerId": "VOX195E86",
                                "title": {
                                    "en": "VOX195E86",
                                    "ar_SA": "VOX195E86"
                                },
                                "rewardType": "Gifting",
                                "redemptionType": "ExternalRedemption",
                                "couponValue": "35",
                                "quantity": 0,
                                "totCoupon": 0,
                                "points": 35,
                                "disclaimer": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "categories": [
                                    {
                                        "id": 7494,
                                        "title": {
                                            "en": "Entertainment",
                                            "ar_SA": "وسائل الترفيه"
                                        }
                                    }
                                ],
                                "partner": {
                                    "partnerId": "VOX534725",
                                    "partnerName": "VOX CINEMA "
                                },
                                "branches": [],
                                "content": {
                                    "en": "FREE Standard Cinema Ticket ",
                                    "ar_SA": "تذكرة سينما مجانية "
                                },
                                "detailDescription": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "termsAndCondtions": {
                                    "en": "• Please visit www.Voxcinemas.com/en-ae for your nearest cinema.\r\nReward Terms and Conditions:\r\nCustomer to present the voucher code at VOX Cinemas Admission counter with standard ticket experience. •Movie rating and age restrictions must be adhered to at the time of voucher/ticket purchase. •Rewards are valid for 30 days after receipt. •Booking need to be made in person and at venue. •The outside food is not permitted. •The offers cannot be used in conjunction with any other special promotions, offers, discounts, employee rewards programs, other special offerings . •All standard terms and conditions for cinema admission apply. •New safety measures www.reelcinemas.com/en-ae",
                                    "ar_SA": "المكافآت صالحة لمدة 30 يوما بعد الاستلام.\r\n• يجب إجراء الحجز شخصيا وفي المكان.\r\n• الطعام الخارجي غير مسموح به.\r\n• لا يمكن استخدام العروض بالتزامن مع أي عروض ترويجية خاصة أخرى أو عروض أو خصومات أو برامج مكافآت الموظفين أو عروض خاصة أخرى.\r\n• تطبق جميع الشروط والأحكام القياسية للقبول في السينما. \r\n• تدابير السلامة الجديدة www.reelcinemas.com/en-ae"
                                },
                                "buttonText": {
                                    "en": "Redeem",
                                    "ar_SA": "Redeem"
                                },
                                "voucherPin": null,
                                "buttonUrl": null,
                                "displayStartDate": 1670507648,
                                "displayEndDate": 1673099648,
                                "expirationDate": 1673099648,
                                "firstTimeUser": null,
                                "hideWhenClaimed": true,
                                "displayOrder": null,
                                "rewardEmailSubject": null,
                                "rewardEmailContent": null,
                                "emailRewardCode": false,
                                "emailRewardURL": false
                            },
                            "draw": null,
                            "wallpaper": null,
                            "survey": {
                                "id": 7972,
                                "isAnswerable": "No",
                                "title": {
                                    "en": "Win Free Movie Tickets",
                                    "ar_SA": "اربح تذاكر أفلام مجانية"
                                },
                                "displayStartDate": 1670351400,
                                "displayEndDate": 1674937800,
                                "questions": [
                                    {
                                        "questionId": 1,
                                        "answerType": "Single Choice",
                                        "question": {
                                            "en": "When do you consume snacks",
                                            "ar_SA": "متى تستهلك الوجبات الخفيفة"
                                        },
                                        "optionLabel": {
                                            "en": [
                                                "Watching Movies ",
                                                "House Parties",
                                                "With Family",
                                                "Evening snacks time"
                                            ],
                                            "ar_SA": [
                                                "مشاهدة الأفلام",
                                                "حفلات البيت",
                                                "مع العائلة",
                                                "وقت الوجبات الخفيفة في المساء"
                                            ]
                                        },
                                        "optionValue": {
                                            "en": [
                                                "Watching Movies ",
                                                "House Parties",
                                                "With Family",
                                                "Evening snacks time"
                                            ],
                                            "ar_SA": [
                                                "مشاهدة الأفلام",
                                                "حفلات البيت",
                                                "مع العائلة",
                                                "وقت الوجبات الخفيفة في المساء"
                                            ]
                                        },
                                        "optionImage": null,
                                        "isCorrectAnswer": {
                                            "en": [
                                                "No",
                                                "No",
                                                "No",
                                                "No"
                                            ],
                                            "ar_SA": [
                                                "No",
                                                "No",
                                                "No",
                                                "No"
                                            ]
                                        }
                                    }
                                ]
                            },
                            "challengeStatus": "incomplete",
                            "challengeAddedDate": null
                        },
                        {
                            "title": {
                                "en": "Pep Reels",
                                "ar_SA": "بيب ريلز"
                            },
                            "description": {
                                "en": "<p>Doritos Christmas Freebies!! Hurry</p>\n",
                                "ar_SA": "<p>شاهد Doritos Reel &amp; Win مذهلة العلامة التجارية الجديدة تسلا</p>\n"
                            },
                            "detailDescription": {
                                "en": "<p>Watch Doritos Reel &amp; Win Amazing brand New Tesla&nbsp;</p>\n\n<p>Your rewards:&nbsp;</p>\n\n<p>Partcipate in a draw to win brand new TESLA!!!!</p>\n",
                                "ar_SA": "<p>شاهد Doritos Reel &amp; Win مذهلة العلامة التجارية الجديدة تسلا</p>\n"
                            },
                            "subType": {
                                "en": "Watch  Reel & get chance to Win Tesla!",
                                "ar_SA": "شاهد Reel & Win Tesla!"
                            },
                            "challengeInfoText": {
                                "en": "Watch  Reel & get chance to Win Tesla!",
                                "ar_SA": "شاهد Reel & Win Tesla!"
                            },
                            "challengeEndsInText": {
                                "en": "Expires In ",
                                "ar_SA": "ينتهى فى 5 ديسمبر"
                            },
                            "termCondition": {
                                "en": "<p>lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum The end</p>\n",
                                "ar_SA": "<p>الشروط والأحكام الوهمية</p>\n"
                            },
                            "challengePrimaryText": {
                                "en": "Play Now",
                                "ar_SA": "العب الان"
                            },
                            "challengeSecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 8194,
                            "type": "Video",
                            "maxUsers": null,
                            "totalParticipants": 0,
                            "displayOrder": null,
                            "rewardType": "",
                            "points": 0,
                            "displayStartDate": 1670238956,
                            "displayEndDate": 1672431300,
                            "expirationDate": 1672431300,
                            "expirationDateFilter": 1672431300.113241,
                            "status": "Active",
                            "challengePrimaryTextColor": "#ffffff",
                            "challengePrimaryBackgroundColor": "#00aff2",
                            "challengeSecondaryTextColor": "#00aff2",
                            "challengeSecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Doritos%20Christmas.JPG",
                            "backgroundImage": "",
                            "video": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/Video/pexels-marina-leonova-9466000.mp4",
                            "reward": {
                                "id": 8065,
                                "rewardId": 8064,
                                "offerId": "VOX195E86",
                                "title": {
                                    "en": "VOX195E86",
                                    "ar_SA": "VOX195E86"
                                },
                                "rewardType": "Gifting",
                                "redemptionType": "ExternalRedemption",
                                "couponValue": "35",
                                "quantity": 0,
                                "totCoupon": 0,
                                "points": 35,
                                "disclaimer": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "categories": [
                                    {
                                        "id": 7494,
                                        "title": {
                                            "en": "Entertainment",
                                            "ar_SA": "وسائل الترفيه"
                                        }
                                    }
                                ],
                                "partner": {
                                    "partnerId": "VOX534725",
                                    "partnerName": "VOX CINEMA "
                                },
                                "branches": [],
                                "content": {
                                    "en": "FREE Standard Cinema Ticket ",
                                    "ar_SA": "تذكرة سينما مجانية "
                                },
                                "detailDescription": {
                                    "en": null,
                                    "ar_SA": null
                                },
                                "termsAndCondtions": {
                                    "en": "• Please visit www.Voxcinemas.com/en-ae for your nearest cinema.\r\nReward Terms and Conditions:\r\nCustomer to present the voucher code at VOX Cinemas Admission counter with standard ticket experience. •Movie rating and age restrictions must be adhered to at the time of voucher/ticket purchase. •Rewards are valid for 30 days after receipt. •Booking need to be made in person and at venue. •The outside food is not permitted. •The offers cannot be used in conjunction with any other special promotions, offers, discounts, employee rewards programs, other special offerings . •All standard terms and conditions for cinema admission apply. •New safety measures www.reelcinemas.com/en-ae",
                                    "ar_SA": "المكافآت صالحة لمدة 30 يوما بعد الاستلام.\r\n• يجب إجراء الحجز شخصيا وفي المكان.\r\n• الطعام الخارجي غير مسموح به.\r\n• لا يمكن استخدام العروض بالتزامن مع أي عروض ترويجية خاصة أخرى أو عروض أو خصومات أو برامج مكافآت الموظفين أو عروض خاصة أخرى.\r\n• تطبق جميع الشروط والأحكام القياسية للقبول في السينما. \r\n• تدابير السلامة الجديدة www.reelcinemas.com/en-ae"
                                },
                                "buttonText": {
                                    "en": "Redeem",
                                    "ar_SA": "Redeem"
                                },
                                "voucherPin": null,
                                "buttonUrl": null,
                                "displayStartDate": 1670507648,
                                "displayEndDate": 1673099648,
                                "expirationDate": 1673099648,
                                "firstTimeUser": null,
                                "hideWhenClaimed": true,
                                "displayOrder": null,
                                "rewardEmailSubject": null,
                                "rewardEmailContent": null,
                                "emailRewardCode": false,
                                "emailRewardURL": false
                            },
                            "draw": {
                                "id": 7892,
                                "title": {
                                    "en": "Doritos: Win a brand new Tesla!",
                                    "ar_SA": "دوريتوس: اربح سيارة تسلا جديدة!"
                                },
                                "description": {
                                    "en": "<p>You have got a chance to Win Tesla. Stay tuned, we will reach out to registered mobile number and email (if email is provided by you) by 20th March 2023</p>\n",
                                    "ar_SA": "<p>لديك فرصة للفوز بـ Tesla. ابق على اتصال ، وسنتواصل مع رقم الهاتف المحمول المسجل والبريد الإلكتروني (إذا تم توفير البريد الإلكتروني من قبلك) بحلول 20 مارس 2023</p>\n"
                                },
                                "terms": {
                                    "en": "<p>Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum&nbsp;Lorem Ipsum</p>\n",
                                    "ar_SA": "<p>العرض ساري حتى نفاذ الكمية</p>\n"
                                },
                                "endDate": 1670266800,
                                "winnerDeclarationDate": 1680207300
                            },
                            "wallpaper": null,
                            "survey": null,
                            "challengeStatus": "incomplete",
                            "challengeAddedDate": null
                        }
                    ],
                    "expiryData": [
                        1678566600,
                        1678566600,
                        1677184200,
                        1677184200,
                        1678566600,
                        1678566600,
                        1672431300,
                        1678566600,
                        1678566600,
                        1672431300
                    ],
                    "expiryDataFilter": [
                        1678566600.008351,
                        1678566600.052258,
                        1677184200.052744,
                        1677184200.08898,
                        1678566600.089534,
                        1678566600.103988,
                        1672431300.104362,
                        1678566600.112112,
                        1678566600.112484,
                        1672431300.113241
                    ],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/challenge/view": {
      "get": {
        "tags": [
          "Challenges"
        ],
        "summary": "Challenge Details",
        "description": "Challenge Details",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "challengeId",
            "in": "query",
            "required": false,
            "description": "ID of Challenge",
            "schema": {
              "type": "number",
              "default": 43
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 1,
                    "data": [
                        {
                            "title": {
                                "en": "Draw",
                                "ar_SA": "ألفت"
                            },
                            "description": {
                                "en": "<p>SAR 50 PlayStation Wallet top-up</p>\n",
                                "ar_SA": "<p>50 ريال سعودي زيادة في محفظة PlayStation Wallet</p>\n"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "subType": {
                                "en": "Just In",
                                "ar_SA": "فقط في"
                            },
                            "challengeInfoText": {
                                "en": "Info",
                                "ar_SA": "معلومات"
                            },
                            "challengeEndsInText": {
                                "en": "Ends In",
                                "ar_SA": "ينتهي بـ"
                            },
                            "termCondition": {
                                "en": "<p>Terms Data</p>\n",
                                "ar_SA": "<p>بيانات الشروط</p>\n"
                            },
                            "challengePrimaryText": {
                                "en": "DRAW",
                                "ar_SA": "سحب"
                            },
                            "challengeSecondaryText": {
                                "en": "Details",
                                "ar_SA": "تفاصيل"
                            },
                            "id": 7460,
                            "type": "Draw",
                            "maxUsers": null,
                            "totalParticipants": 0,
                            "displayOrder": 1,
                            "rewardType": "",
                            "points": 0,
                            "displayStartDate": 1668589740,
                            "displayEndDate": 1671047100,
                            "expirationDate": 1671047100,
                            "expirationDateFilter": 1671047100.500304,
                            "status": "Inactive",
                            "challengePrimaryTextColor": "#ffffff",
                            "challengePrimaryBackgroundColor": "#00aff2",
                            "challengeSecondaryTextColor": "#00aff2",
                            "challengeSecondaryBackgroundColor": "",
                            "backgroundColor": "",
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/pepsi_hand_shadow.png",
                            "backgroundImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/moving_star.png",
                            "video": "",
                            "reward": null,
                            "draw": {
                                "id": 7531,
                                "title": {
                                    "en": "Win XX(tesla model 300)",
                                    "ar_SA": "فوز XX (موديل تسلا 300)"
                                },
                                "description": {
                                    "en": "<p>You have got a spot in the draw to win XX(tesla model 300), watch out this space for more info.</p>\n",
                                    "ar_SA": "<p>لديك مكان في السحب للفوز A (طراز tesla 300) ، احترس من هذه المساحة لمزيد من المعلومات.</p>\n"
                                },
                                "terms": {
                                    "en": "<p>lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum&nbsp;lorem ipsum The end</p>\n",
                                    "ar_SA": "<p>الأحكام والشروط&nbsp;الأحكام والشروط&nbsp;الأحكام والشروط&nbsp;الأحكام والشروط&nbsp;الأحكام والشروط&nbsp;الأحكام والشروط&nbsp;الأحكام والشروط&nbsp;الأحكام والشروط&nbsp;الأحكام والشروط</p>\n"
                                },
                                "endDate": 1671733800,
                                "winnerDeclarationDate": 1672425000,
                                "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/voucher@3x.png"
                            },
                            "wallpaper": null,
                            "survey": null,
                            "challengeStatus": "incomplete",
                            "challengeAddedDate": null
                        }
                    ],
                    "expiryData": [
                        1671047100
                    ],
                    "expiryDataFilter": [
                        1671047100.500304
                    ],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/challenge/complete":{
       "post": {
            "tags": [
                "Challenges"
            ],
            "summary": "Challenges Complete",
            "description": "Challenges Complete",
            "requestBody": {
                "content": {
                    "application/json": {
                        "schema": {
                            "type": "object",
                            "properties": {
                                "id": {
                                    "type": "string",
                                    "format": "int64"
                                }
                            }
                        },
                        "example": {
                            "challengeId" : 80,
                            "challengeType" : "survey",
                            "challengeTypeId" : 79,
                            "points": 0,
                            "sfmcmetadata": {
                              "mobileNumber": "+966954030231"
                            },
                            "surveyData": [
                                {
                                    "questionId": 1,
                                    "answer": "pepsico_real"
                                },
                                {
                                    "questionId": 2,
                                    "answer": "pepsico_dietl"
                                }
                            ]
                        }
                    }
                }
            },
            "parameters": [
                {
                    "name": "SiteId",
                    "in": "header",
                    "required": true,
                    "description": "SiteId",
                    "schema": {
                        "type": "number",
                        "default": 10
                    }
                },
                {
                    "name": "okta-accesstoken",
                    "in": "header",
                  "required": false,
                  "description": "Customer Okta JWT or partner JWT for server-to-server requests.",
                    "schema": {
                        "type": "string",
                        "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
                    }
                },
                {
                  "name": "x-api-key",
                  "in": "header",
                  "required": false,
                  "description": "API key for unauthenticated SFMC requests when a partner JWT is not used.",
                  "schema": {
                    "type": "string"
                  }
                }
            ],
            "responses": {
                "200": {
                    "description": "OK",
                    "content": {
                        "application/json": {
                            "example": {
                                "success": "false",
                                "message": "Challenge already completed!"
                            }
                        }
                    }
                },
                "400": {
                    "description": "Bad Request",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "415": {
                    "description": "Unsupported Media Type",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "500": {
                    "description": "Internal Server Error",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/Problem"
                            }
                        }
                    }
                }
            }
        }
    },
    "/draw-participate":{
       "post": {
            "tags": [
                "Draw"
            ],
            "summary": "Draw Participate",
            "description": "Draw Participate",
            "requestBody": {
                "content": {
                    "application/json": {
                        "schema": {
                            "type": "object",
                            "properties": {
                                "id": {
                                    "type": "string",
                                    "format": "int64"
                                }
                            }
                        },
                        "example": {
                            "drawId" : 80,
                            "drawType" : "spin",
                            "drawTypeId" : 79,
                            "wedgeId": 1
                        }
                    }
                }
            },
            "parameters": [
                {
                    "name": "SiteId",
                    "in": "header",
                    "required": true,
                    "description": "SiteId",
                    "schema": {
                        "type": "number",
                        "default": 10
                    }
                },
                {
                    "name": "okta-accesstoken",
                    "in": "header",
                    "required": true,
                    "description": "okta-accesstoken",
                    "schema": {
                        "type": "string",
                        "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
                    }
                }
            ],
            "responses": {
                "200": {
                    "description": "OK",
                    "content": {
                        "application/json": {
                            "example": {
                                  "success": "false",
                                  "message": "You already participate in the draw!"
                              }
                          }
                    }
                },
                "400": {
                    "description": "Bad Request",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "415": {
                    "description": "Unsupported Media Type",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "500": {
                    "description": "Internal Server Error",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/Problem"
                            }
                        }
                    }
                }
            }
        }
    },
    "/welcomegift": {
      "get": {
        "tags": [
          "Welcome Gift"
        ],
        "summary": "Welcomegift",
        "description": "Welcomegift",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 2,
                    "data": [
                        {
                            "primaryText": {
                                "en": "Welcome to Falla!",
                                "ar_SA": "مرحبا بكم في فالا!"
                            },
                            "secondaryText": {
                                "en": "Here’s your welcome gift:",
                                "ar_SA": "إليك هديتك الترحيبية:"
                            },
                            "id": 7487,
                            "rewardId": 7486,
                            "offerId": "SEB123",
                            "title": {
                                "en": "Offer2",
                                "ar_SA": "عرض 2"
                            },
                            "rewardType": "Reward",
                            "redemptionType": "ExternalRedemption",
                            "couponValue": "50AED",
                            "points": 50,
                            "quantity": 0,
                            "totCoupon": 0,
                            "disclaimer": {
                                "en": null,
                                "ar_SA": null
                            },
                            "categories": [
                                {
                                    "id": 7395,
                                    "title": {
                                        "en": "Activity",
                                        "ar_SA": "نشاط"
                                    }
                                }
                            ],
                            "partner": {
                                "partnerId": "St345vp",
                                "partnerName": "Steers"
                            },
                            "branches": [
                                {
                                    "name": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "address": {
                                        "en": "New York",
                                        "ar_SA": "New York"
                                    },
                                    "longitude": -74.00491476059,
                                    "latitude": 40.712622133006
                                }
                            ],
                            "content": {
                                "en": "<p>SAR 80 Discount on The Secret Room</p>\n",
                                "ar_SA": "<p>خصم&nbsp;٨٠ ريال على الغرفة السرية</p>\n"
                            },
                            "detailDescription": {
                                "en": null,
                                "ar_SA": null
                            },
                            "termsAndCondtions": {
                                "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                            },
                            "buttonText": {
                                "en": "Redeem",
                                "ar_SA": "يسترد"
                            },
                            "buttonUrl": null,
                            "voucherPin": null,
                            "displayStartDate": 1667933100,
                            "displayEndDate": 1670006700,
                            "expirationDate": 1670006700,
                            "firstTimeUser": null,
                            "hideWhenClaimed": false,
                            "displayOrder": null,
                            "expirationAmount": 5,
                            "expirationUnit": "days",
                            "rewardEmailSubject": null,
                            "rewardEmailContent": null,
                            "emailRewardCode": false,
                            "emailRewardURL": false,
                            "availablity": true,
                            "siteId": 10,
                            "maxUser": 50
                        }
                    ],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/welcomegiftcomplete": {
      "get": {
        "tags": [
          "Welcome Gift"
        ],
        "summary": "Get Welcome Gift Complete Details",
        "description": "Get Welcome Gift Complete Details",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "giftId",
            "in": "query",
            "required": false,
            "description": "ID of Gift",
            "schema": {
              "type": "number",
              "default": 7432
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "success": true,
                    "totalCount": 1,
                    "data": [
                        {
                            "id": 7953,
                            "giftType": "reward",
                            "customer": 7439,
                            "reward": 7721,
                            "points": 70,
                            "welcomeGift": 7432
                        }
                    ]
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/welcomegift/complete":{
       "post": {
            "tags": [
                "Welcome Gift"
            ],
            "summary": "Complete Welcome Gift",
            "description": "Complete Welcome Gift",
            "requestBody": {
                "content": {
                    "application/json": {
                        "schema": {
                            "type": "object",
                            "properties": {
                                "id": {
                                    "type": "string",
                                    "format": "int64"
                                }
                            }
                        },
                        "example": {
                            "giftId":7432,
                            "giftType" : "reward",
                            "giftTypeId" : 7721,
                            "points" : 0
                        }
                    }
                }
            },
            "parameters": [
                {
                    "name": "SiteId",
                    "in": "header",
                    "required": true,
                    "description": "SiteId",
                    "schema": {
                        "type": "number",
                        "default": 10
                    }
                },
                {
                    "name": "okta-accesstoken",
                    "in": "header",
                    "required": true,
                    "description": "okta-accesstoken",
                    "schema": {
                        "type": "string",
                        "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
                    }
                }
            ],
            "responses": {
                "200": {
                    "description": "OK",
                    "content": {
                        "application/json": {
                            "example": {
                                "success": "true",
                                "message": "Welcome gift added successfully!"
                            }
                        }
                    }
                },
                "400": {
                    "description": "Bad Request",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "415": {
                    "description": "Unsupported Media Type",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/ErrorMessage"
                            }
                        }
                    }
                },
                "500": {
                    "description": "Internal Server Error",
                    "content": {
                        "*/*": {
                            "schema": {
                                "$ref": "#/components/schemas/Problem"
                            }
                        }
                    }
                }
            }
        }
    },
    "/city": {
      "get": {
        "tags": [
          "City"
        ],
        "summary": "Get Cities",
        "description": "Get Cities",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          },
          {
            "name": "search",
            "in": "query",
            "required": false,
            "description": "search",
            "schema": {
              "type": "string",
              "default": "ahmed"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "success": true,
                    "totalCount": 1,
                    "data": [
                        {
                            "postalCode": "380004",
                            "name": {
                                "en": "Ahmedabad",
                                "ar_SA": "AHD"
                            }
                        }
                    ]
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/spin": {
      "get": {
        "tags": [
          "Spin and Wheel"
        ],
        "summary": "Spin and Wheel",
        "description": "Spin and Wheel",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Not Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example":
                  {
                    "totalCount": 1,
                    "data": [
                        {
                            "title": {
                                "en": "Spin",
                                "ar_SA": "غزل"
                            },
                            "disclaimer": {
                                "en": null,
                                "ar_SA": null
                            },
                            "succesMessage": {
                                "en": null,
                                "ar_SA": null
                            },
                            "errorMessage": {
                                "en": null,
                                "ar_SA": null
                            },
                            "buttonText": {
                                "en": "SPIN & WIN!",
                                "ar_SA": "تدور واربح!"
                            },
                            "bgColor": null,
                            "id": 7522,
                            "promotionImages": [
                                "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/deal_1.jpg",
                                "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/deal_2.jpg",
                                "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/deal_3.jpg",
                                "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/deal_4.jpg",
                                "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/deal_5.jpg"
                            ],
                            "wedges": [
                                {
                                    "id": 8,
                                    "name": "Wedge8",
                                    "displayTitle": {
                                        "en": null,
                                        "ar_SA": null
                                    },
                                    "rewardType": "Wallpaper",
                                    "points": 0,
                                    "reward": null,
                                    "wallpaper": {
                                        "id": 7493,
                                        "title": {
                                            "en": "Phone",
                                            "ar_SA": "هاتف"
                                        },
                                        "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/pepsi_phone_wallpaper_3x.png"
                                    },
                                    "draw": null,
                                    "textColor": "#ffffff",
                                    "bgColor": "#004c97",
                                    "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2068099_3.png",
                                    "opacity": 20,
                                    "awardTimesDaily": 100,
                                    "awardTimesPerUserDaily": 5,
                                    "awardTimesWeekly": 0,
                                    "awardTimesPerUserWeekly": 0,
                                    "awardTimesMonthly": 0,
                                    "awardTimesPerUserMonthly": 0
                                },
                                {
                                    "id": 7,
                                    "name": "Wedge7",
                                    "displayTitle": {
                                        "en": null,
                                        "ar_SA": null
                                    },
                                    "rewardType": "Points",
                                    "points": 10,
                                    "reward": null,
                                    "wallpaper": null,
                                    "draw": null,
                                    "textColor": "#ffffff",
                                    "bgColor": "#e52d37",
                                    "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2067843_2.png",
                                    "opacity": 20,
                                    "awardTimesDaily": 0,
                                    "awardTimesPerUserDaily": 0,
                                    "awardTimesWeekly": 0,
                                    "awardTimesPerUserWeekly": 0,
                                    "awardTimesMonthly": 0,
                                    "awardTimesPerUserMonthly": 0
                                },
                                {
                                    "id": 6,
                                    "name": "Wedge6",
                                    "displayTitle": {
                                        "en": null,
                                        "ar_SA": null
                                    },
                                    "rewardType": "Reward",
                                    "points": 0,
                                    "reward": {
                                        "id": 7536,
                                        "rewardId": 7535,
                                        "offerId": "NA50",
                                        "title": {
                                            "en": "Offer 7",
                                            "ar_SA": "العرض 7"
                                        },
                                        "rewardType": "Reward",
                                        "redemptionType": "ExternalRedemption",
                                        "couponValue": "50",
                                        "quantity": 0,
                                        "totCoupon": 0,
                                        "voucherPin": null,
                                        "points": 50,
                                        "disclaimer": {
                                            "en": null,
                                            "ar_SA": null
                                        },
                                        "categories": [
                                            {
                                                "id": 7494,
                                                "title": {
                                                    "en": "Entertainment",
                                                    "ar_SA": "وسائل الترفيه"
                                                }
                                            }
                                        ],
                                        "partner": {
                                            "partnerId": "De237df",
                                            "partnerName": "Debonairs Pizza"
                                        },
                                        "content": {
                                            "en": "<p>R50 Nando's Voucher</p>\n",
                                            "ar_SA": "<p>قسيمة R50 ناندو</p>\n"
                                        },
                                        "detailDescription": {
                                            "en": null,
                                            "ar_SA": null
                                        },
                                        "termsAndCondtions": {
                                            "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                            "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                                        },
                                        "buttonText": {
                                            "en": "Redeem",
                                            "ar_SA": "Redeem"
                                        },
                                        "buttonUrl": null,
                                        "displayStartDate": 1668539700,
                                        "displayEndDate": 1669749300,
                                        "expirationDate": 1670266800
                                    },
                                    "wallpaper": null,
                                    "draw": null,
                                    "textColor": "#ffffff",
                                    "bgColor": "#00a1d7",
                                    "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2068100_2.png",
                                    "opacity": 20,
                                    "awardTimesDaily": 0,
                                    "awardTimesPerUserDaily": 0,
                                    "awardTimesWeekly": 100,
                                    "awardTimesPerUserWeekly": 100,
                                    "awardTimesMonthly": 0,
                                    "awardTimesPerUserMonthly": 0
                                },
                                {
                                    "id": 5,
                                    "name": "Wedge5",
                                    "displayTitle": {
                                        "en": null,
                                        "ar_SA": null
                                    },
                                    "rewardType": "Wallpaper",
                                    "points": 0,
                                    "reward": null,
                                    "wallpaper": {
                                        "id": 7493,
                                        "title": {
                                            "en": "Phone",
                                            "ar_SA": "هاتف"
                                        },
                                        "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/pepsi_phone_wallpaper_3x.png"
                                    },
                                    "draw": null,
                                    "textColor": "#ffffff",
                                    "bgColor": "#f4903b",
                                    "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2068099_2.png",
                                    "opacity": 20,
                                    "awardTimesDaily": 0,
                                    "awardTimesPerUserDaily": 0,
                                    "awardTimesWeekly": 0,
                                    "awardTimesPerUserWeekly": 0,
                                    "awardTimesMonthly": 100,
                                    "awardTimesPerUserMonthly": 5
                                },
                                {
                                    "id": 4,
                                    "name": "Wedge4",
                                    "displayTitle": {
                                        "en": null,
                                        "ar_SA": null
                                    },
                                    "rewardType": "Reward",
                                    "points": 0,
                                    "reward": {
                                        "id": 7499,
                                        "rewardId": 7498,
                                        "offerId": "Spr4",
                                        "title": {
                                            "en": "Offer 4",
                                            "ar_SA": "العرض 4"
                                        },
                                        "rewardType": "Reward",
                                        "redemptionType": "ExternalRedemption",
                                        "couponValue": "70AED",
                                        "quantity": 0,
                                        "totCoupon": 0,
                                        "voucherPin": null,
                                        "points": 40,
                                        "disclaimer": {
                                            "en": null,
                                            "ar_SA": null
                                        },
                                        "categories": [
                                            {
                                                "id": 7395,
                                                "title": {
                                                    "en": "Activity",
                                                    "ar_SA": "نشاط"
                                                }
                                            }
                                        ],
                                        "partner": {
                                            "partnerId": "St345vp",
                                            "partnerName": "Steers"
                                        },
                                        "content": {
                                            "en": "<p>One-month FREE subscription to Anghami Plus</p>\n",
                                            "ar_SA": "<p>اشتراك مجاني لمدة شهر في أنغامي بلاس</p>\n"
                                        },
                                        "detailDescription": {
                                            "en": null,
                                            "ar_SA": null
                                        },
                                        "termsAndCondtions": {
                                            "en": "<p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                            "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                                        },
                                        "buttonText": {
                                            "en": "Redeem",
                                            "ar_SA": "يسترد"
                                        },
                                        "buttonUrl": null,
                                        "displayStartDate": 1668019500,
                                        "displayEndDate": 1669315500,
                                        "expirationDate": 1669661100
                                    },
                                    "wallpaper": null,
                                    "draw": null,
                                    "textColor": "#ffffff",
                                    "bgColor": "#004c97",
                                    "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2068100_3.png",
                                    "opacity": 20,
                                    "awardTimesDaily": 100,
                                    "awardTimesPerUserDaily": 10,
                                    "awardTimesWeekly": 0,
                                    "awardTimesPerUserWeekly": 0,
                                    "awardTimesMonthly": 0,
                                    "awardTimesPerUserMonthly": 0
                                },
                                {
                                    "id": 3,
                                    "name": "Wedge3",
                                    "displayTitle": {
                                        "en": null,
                                        "ar_SA": null
                                    },
                                    "rewardType": "Points",
                                    "points": 10,
                                    "reward": null,
                                    "wallpaper": null,
                                    "draw": null,
                                    "textColor": "#ffffff",
                                    "bgColor": "#e52d37",
                                    "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2067843_1.png",
                                    "opacity": 20,
                                    "awardTimesDaily": 0,
                                    "awardTimesPerUserDaily": 0,
                                    "awardTimesWeekly": 0,
                                    "awardTimesPerUserWeekly": 0,
                                    "awardTimesMonthly": 0,
                                    "awardTimesPerUserMonthly": 0
                                },
                                {
                                    "id": 2,
                                    "name": "Wedge2",
                                    "displayTitle": {
                                        "en": null,
                                        "ar_SA": null
                                    },
                                    "rewardType": "Reward",
                                    "points": 0,
                                    "reward": {
                                        "id": 7520,
                                        "rewardId": 7519,
                                        "offerId": "SPR5",
                                        "title": {
                                            "en": "Offer 5",
                                            "ar_SA": "العرض 5"
                                        },
                                        "rewardType": "Reward",
                                        "redemptionType": "ExternalRedemption",
                                        "couponValue": "70AED",
                                        "quantity": 0,
                                        "totCoupon": 0,
                                        "voucherPin": null,
                                        "points": 40,
                                        "disclaimer": {
                                            "en": null,
                                            "ar_SA": null
                                        },
                                        "categories": [
                                            {
                                                "id": 7495,
                                                "title": {
                                                    "en": "Shopping & Fashion",
                                                    "ar_SA": "التسوق والموضة"
                                                }
                                            }
                                        ],
                                        "partner": {
                                            "partnerId": "St345vp",
                                            "partnerName": "Steers"
                                        },
                                        "content": {
                                            "en": "<p>One-month FREE subscription to Anghami Plus</p>\n",
                                            "ar_SA": null
                                        },
                                        "detailDescription": {
                                            "en": null,
                                            "ar_SA": null
                                        },
                                        "termsAndCondtions": {
                                            "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                            "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                                        },
                                        "buttonText": {
                                            "en": "REDEEM",
                                            "ar_SA": "Redeem"
                                        },
                                        "buttonUrl": null,
                                        "displayStartDate": 1668019500,
                                        "displayEndDate": 1670006700,
                                        "expirationDate": 1670006700
                                    },
                                    "wallpaper": null,
                                    "draw": null,
                                    "textColor": "#ffffff",
                                    "bgColor": "#f4903b",
                                    "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2068099.png",
                                    "opacity": 20,
                                    "awardTimesDaily": 0,
                                    "awardTimesPerUserDaily": 0,
                                    "awardTimesWeekly": 0,
                                    "awardTimesPerUserWeekly": 0,
                                    "awardTimesMonthly": 100,
                                    "awardTimesPerUserMonthly": 5
                                },
                                {
                                    "id": 1,
                                    "name": "Wedge1",
                                    "displayTitle": {
                                        "en": null,
                                        "ar_SA": null
                                    },
                                    "rewardType": "Points",
                                    "points": 30,
                                    "reward": null,
                                    "wallpaper": null,
                                    "draw": null,
                                    "textColor": "#ffffff",
                                    "bgColor": "#00a1d7",
                                    "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2068157_1.png",
                                    "opacity": 20,
                                    "awardTimesDaily": 0,
                                    "awardTimesPerUserDaily": 0,
                                    "awardTimesWeekly": 0,
                                    "awardTimesPerUserWeekly": 0,
                                    "awardTimesMonthly": 0,
                                    "awardTimesPerUserMonthly": 0
                                }
                            ],
                            "displayStartDate": 1667305680,
                            "displayEndDate": 1704047340,
                            "direction": null,
                            "speed": 20,
                            "opacity": 20
                        }
                    ],
                    "assignedWedgesId": {
                        "2": 6
                    },
                    "isAllWedgeIdAssigned": false,
                    "msg": "",
                    "success": true
                }            
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/generandwedge": {
      "get": {
        "tags": [
          "Spin and Wheel"
        ],
        "summary": "Generand Wedge Number",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "spinId",
            "in": "query",
            "required": true,
            "description": "spinId",
            "schema": {
              "type": "number",
              "default": 7508
            }
          },
          {
            "name": "activeWedgesId",
            "in": "query",
            "required": true,
            "description": "activeWedgesId",
            "schema": {
              "type": "object",
              "default": [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8"
              ]
            }
          },
          {
            "name": "assignedWedgesId",
            "in": "query",
            "required": true,
            "description": "assignedWedgesId",
            "schema": {
              "type": "object",
              "default": []
            }
          },
          {
            "name": "wedgesRwdId",
            "in": "query",
            "required": true,
            "description": "wedgesRwdId",
            "schema": {
              "type": "object",
              "default": [
                {
                  "reward": {
                    "6": "7536",   
                    "4": "7499",
                    "2": "7520"
                  },
                  "wallpaper": {
                     "8": "7493",
                     "5": "7493"
                  } 
                }
              ]
            }
          },
          {
            "name": "wedgesFrequency",
            "in": "query",
            "required": true,
            "description": "wedgesFrequency",
            "schema": {
              "type": "object",
              "default": [{
                  "8": {
                    "awardTimesDaily": 100,   
                    "awardTimesPerUserDaily": 10
                  },
                  "6": {
                    "awardTimesWeekly": 100,   
                    "awardTimesPerUserWeekly": 10
                  },
                  "4": {
                    "awardTimesDaily": 100,   
                    "awardTimesPerUserDaily": 10
                  },
                "2": {
                    "awardTimesMonthly": 100,   
                    "awardTimesPerUserMonthly": 5
                  },
                  "5": {
                    "awardTimesMonthly": 100,   
                    "awardTimesPerUserMonthly": 5
                  }
                }
              ]
            }
          }

        ],
        "description": "Generand Wedge Number",
        
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "success": "true",
                    "randGenWedgeId": 6,
                    "rewardType": "reward",
                    "wedgeRwdId": "7536",
                    "isAllWedgeIdAssigned": false,
                    "msg": ""
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/spin/view": {
      "get": {
        "tags": [
          "Spin and Wheel"
        ],
        "summary": "Spin and Wheel Details",
        "description": "Spin and Wheel Details",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "spinId",
            "in": "query",
            "required": false,
            "description": "spinId",
            "schema": {
              "type": "number",
              "default": 7522
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                  "totalCount": 1,
                  "data": [
                      {
                          "title": {
                              "en": "Spin",
                              "ar_SA": "غزل"
                          },
                          "disclaimer": {
                              "en": null,
                              "ar_SA": null
                          },
                          "succesMessage": {
                              "en": null,
                              "ar_SA": null
                          },
                          "errorMessage": {
                              "en": null,
                              "ar_SA": null
                          },
                          "buttonText": {
                              "en": "SPIN & WIN!",
                              "ar_SA": "تدور واربح!"
                          },
                          "bgColor": null,
                          "id": 7522,
                          "promotionImages": [
                              "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/deal_1.jpg",
                              "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/deal_2.jpg",
                              "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/deal_3.jpg",
                              "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/deal_4.jpg",
                              "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/deal_5.jpg"
                          ],
                          "wedges": [
                              {
                                  "id": 8,
                                  "name": "Wedge8",
                                  "displayTitle": {
                                      "en": null,
                                      "ar_SA": null
                                  },
                                  "rewardType": "Wallpaper",
                                  "points": 0,
                                  "reward": null,
                                  "wallpaper": {
                                      "id": 7493,
                                      "title": {
                                          "en": "Phone",
                                          "ar_SA": "هاتف"
                                      },
                                      "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/pepsi_phone_wallpaper_3x.png"
                                  },
                                  "draw": null,
                                  "textColor": "#ffffff",
                                  "bgColor": "#004c97",
                                  "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2068099_3.png",
                                  "opacity": 20,
                                  "awardTimesDaily": 100,
                                  "awardTimesPerUserDaily": 5,
                                  "awardTimesWeekly": 0,
                                  "awardTimesPerUserWeekly": 0,
                                  "awardTimesMonthly": 0,
                                  "awardTimesPerUserMonthly": 0
                              },
                              {
                                  "id": 7,
                                  "name": "Wedge7",
                                  "displayTitle": {
                                      "en": null,
                                      "ar_SA": null
                                  },
                                  "rewardType": "Points",
                                  "points": 10,
                                  "reward": null,
                                  "wallpaper": null,
                                  "draw": null,
                                  "textColor": "#ffffff",
                                  "bgColor": "#e52d37",
                                  "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2067843_2.png",
                                  "opacity": 20,
                                  "awardTimesDaily": 0,
                                  "awardTimesPerUserDaily": 0,
                                  "awardTimesWeekly": 0,
                                  "awardTimesPerUserWeekly": 0,
                                  "awardTimesMonthly": 0,
                                  "awardTimesPerUserMonthly": 0
                              },
                              {
                                  "id": 6,
                                  "name": "Wedge6",
                                  "displayTitle": {
                                      "en": null,
                                      "ar_SA": null
                                  },
                                  "rewardType": "Reward",
                                  "points": 0,
                                  "reward": {
                                      "id": 7536,
                                      "rewardId": 7535,
                                      "offerId": "NA50",
                                      "title": {
                                          "en": "Offer 7",
                                          "ar_SA": "العرض 7"
                                      },
                                      "rewardType": "Reward",
                                      "redemptionType": "ExternalRedemption",
                                      "couponValue": "50",
                                      "quantity": 0,
                                      "totCoupon": 0,
                                      "voucherPin": null,
                                      "points": 50,
                                      "disclaimer": {
                                          "en": null,
                                          "ar_SA": null
                                      },
                                      "categories": [
                                          {
                                              "id": 7494,
                                              "title": {
                                                  "en": "Entertainment",
                                                  "ar_SA": "وسائل الترفيه"
                                              }
                                          }
                                      ],
                                      "partner": {
                                          "partnerId": "De237df",
                                          "partnerName": "Debonairs Pizza"
                                      },
                                      "content": {
                                          "en": "<p>R50 Nando's Voucher</p>\n",
                                          "ar_SA": "<p>قسيمة R50 ناندو</p>\n"
                                      },
                                      "detailDescription": {
                                          "en": null,
                                          "ar_SA": null
                                      },
                                      "termsAndCondtions": {
                                          "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                          "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                                      },
                                      "buttonText": {
                                          "en": "Redeem",
                                          "ar_SA": "Redeem"
                                      },
                                      "buttonUrl": null,
                                      "displayStartDate": 1668539700,
                                      "displayEndDate": 1669749300,
                                      "expirationDate": 1670266800
                                  },
                                  "wallpaper": null,
                                  "draw": null,
                                  "textColor": "#ffffff",
                                  "bgColor": "#00a1d7",
                                  "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2068100_2.png",
                                  "opacity": 20,
                                  "awardTimesDaily": 0,
                                  "awardTimesPerUserDaily": 0,
                                  "awardTimesWeekly": 100,
                                  "awardTimesPerUserWeekly": 100,
                                  "awardTimesMonthly": 0,
                                  "awardTimesPerUserMonthly": 0
                              },
                              {
                                  "id": 5,
                                  "name": "Wedge5",
                                  "displayTitle": {
                                      "en": null,
                                      "ar_SA": null
                                  },
                                  "rewardType": "Wallpaper",
                                  "points": 0,
                                  "reward": null,
                                  "wallpaper": {
                                      "id": 7493,
                                      "title": {
                                          "en": "Phone",
                                          "ar_SA": "هاتف"
                                      },
                                      "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/pepsi_phone_wallpaper_3x.png"
                                  },
                                  "draw": null,
                                  "textColor": "#ffffff",
                                  "bgColor": "#f4903b",
                                  "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2068099_2.png",
                                  "opacity": 20,
                                  "awardTimesDaily": 0,
                                  "awardTimesPerUserDaily": 0,
                                  "awardTimesWeekly": 0,
                                  "awardTimesPerUserWeekly": 0,
                                  "awardTimesMonthly": 100,
                                  "awardTimesPerUserMonthly": 5
                              },
                              {
                                  "id": 4,
                                  "name": "Wedge4",
                                  "displayTitle": {
                                      "en": null,
                                      "ar_SA": null
                                  },
                                  "rewardType": "Reward",
                                  "points": 0,
                                  "reward": {
                                      "id": 7499,
                                      "rewardId": 7498,
                                      "offerId": "Spr4",
                                      "title": {
                                          "en": "Offer 4",
                                          "ar_SA": "العرض 4"
                                      },
                                      "rewardType": "Reward",
                                      "redemptionType": "ExternalRedemption",
                                      "couponValue": "70AED",
                                      "quantity": 0,
                                      "totCoupon": 0,
                                      "voucherPin": null,
                                      "points": 40,
                                      "disclaimer": {
                                          "en": null,
                                          "ar_SA": null
                                      },
                                      "categories": [
                                          {
                                              "id": 7395,
                                              "title": {
                                                  "en": "Activity",
                                                  "ar_SA": "نشاط"
                                              }
                                          }
                                      ],
                                      "partner": {
                                          "partnerId": "St345vp",
                                          "partnerName": "Steers"
                                      },
                                      "content": {
                                          "en": "<p>One-month FREE subscription to Anghami Plus</p>\n",
                                          "ar_SA": "<p>اشتراك مجاني لمدة شهر في أنغامي بلاس</p>\n"
                                      },
                                      "detailDescription": {
                                          "en": null,
                                          "ar_SA": null
                                      },
                                      "termsAndCondtions": {
                                          "en": "<p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                          "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                                      },
                                      "buttonText": {
                                          "en": "Redeem",
                                          "ar_SA": "يسترد"
                                      },
                                      "buttonUrl": null,
                                      "displayStartDate": 1668019500,
                                      "displayEndDate": 1669315500,
                                      "expirationDate": 1669661100
                                  },
                                  "wallpaper": null,
                                  "draw": null,
                                  "textColor": "#ffffff",
                                  "bgColor": "#004c97",
                                  "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2068100_3.png",
                                  "opacity": 20,
                                  "awardTimesDaily": 100,
                                  "awardTimesPerUserDaily": 10,
                                  "awardTimesWeekly": 0,
                                  "awardTimesPerUserWeekly": 0,
                                  "awardTimesMonthly": 0,
                                  "awardTimesPerUserMonthly": 0
                              },
                              {
                                  "id": 3,
                                  "name": "Wedge3",
                                  "displayTitle": {
                                      "en": null,
                                      "ar_SA": null
                                  },
                                  "rewardType": "Draw",
                                  "points": 0,
                                  "reward": null,
                                  "wallpaper": null,
                                  "draw": {
                                      "id": 7531,
                                      "title": {
                                          "en": "Draw1",
                                          "ar_SA": "ارسم 1"
                                      },
                                      "description": {
                                          "en": "<p>Draw1</p>\n",
                                          "ar_SA": "<p>ارسم 1</p>\n"
                                      },
                                      "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/voucher@3x.png"
                                  },
                                  "textColor": "#ffffff",
                                  "bgColor": "#e52d37",
                                  "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2067843_1.png",
                                  "opacity": 20,
                                  "awardTimesDaily": 0,
                                  "awardTimesPerUserDaily": 0,
                                  "awardTimesWeekly": 0,
                                  "awardTimesPerUserWeekly": 0,
                                  "awardTimesMonthly": 0,
                                  "awardTimesPerUserMonthly": 0
                              },
                              {
                                  "id": 2,
                                  "name": "Wedge2",
                                  "displayTitle": {
                                      "en": null,
                                      "ar_SA": null
                                  },
                                  "rewardType": "Reward",
                                  "points": 0,
                                  "reward": {
                                      "id": 7520,
                                      "rewardId": 7519,
                                      "offerId": "SPR5",
                                      "title": {
                                          "en": "Offer 5",
                                          "ar_SA": "العرض 5"
                                      },
                                      "rewardType": "Reward",
                                      "redemptionType": "ExternalRedemption",
                                      "couponValue": "70AED",
                                      "quantity": 0,
                                      "totCoupon": 0,
                                      "voucherPin": null,
                                      "points": 40,
                                      "disclaimer": {
                                          "en": null,
                                          "ar_SA": null
                                      },
                                      "categories": [
                                          {
                                              "id": 7495,
                                              "title": {
                                                  "en": "Shopping & Fashion",
                                                  "ar_SA": "التسوق والموضة"
                                              }
                                          }
                                      ],
                                      "partner": {
                                          "partnerId": "St345vp",
                                          "partnerName": "Steers"
                                      },
                                      "content": {
                                          "en": "<p>One-month FREE subscription to Anghami Plus</p>\n",
                                          "ar_SA": null
                                      },
                                      "detailDescription": {
                                          "en": null,
                                          "ar_SA": null
                                      },
                                      "termsAndCondtions": {
                                          "en": "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\n",
                                          "ar_SA": "<p>لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي مع إصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.</p>\n"
                                      },
                                      "buttonText": {
                                          "en": "REDEEM",
                                          "ar_SA": "Redeem"
                                      },
                                      "buttonUrl": null,
                                      "displayStartDate": 1668019500,
                                      "displayEndDate": 1670006700,
                                      "expirationDate": 1670006700
                                  },
                                  "wallpaper": null,
                                  "draw": null,
                                  "textColor": "#ffffff",
                                  "bgColor": "#f4903b",
                                  "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2068099.png",
                                  "opacity": 20,
                                  "awardTimesDaily": 0,
                                  "awardTimesPerUserDaily": 0,
                                  "awardTimesWeekly": 0,
                                  "awardTimesPerUserWeekly": 0,
                                  "awardTimesMonthly": 100,
                                  "awardTimesPerUserMonthly": 5
                              },
                              {
                                  "id": 1,
                                  "name": "Wedge1",
                                  "displayTitle": {
                                      "en": null,
                                      "ar_SA": null
                                  },
                                  "rewardType": "Points",
                                  "points": 30,
                                  "reward": null,
                                  "wallpaper": null,
                                  "draw": null,
                                  "textColor": "#ffffff",
                                  "bgColor": "#00a1d7",
                                  "bgImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Group%2068157_1.png",
                                  "opacity": 20,
                                  "awardTimesDaily": 0,
                                  "awardTimesPerUserDaily": 0,
                                  "awardTimesWeekly": 0,
                                  "awardTimesPerUserWeekly": 0,
                                  "awardTimesMonthly": 0,
                                  "awardTimesPerUserMonthly": 0
                              }
                          ],
                          "displayStartDate": 1667305680,
                          "displayEndDate": 1704047340,
                          "direction": null,
                          "speed": 20,
                          "opacity": 20
                      }
                  ],
                  "assignedWedgesId": {
                      "2": 6
                  },
                  "isAllWedgeIdAssigned": false,
                  "msg": "",
                  "success": true
              }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/survey": {
      "get": {
        "tags": [
          "Survey"
        ],
        "summary": "Survey List",
        "description": "Survey List",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          },
          {
            "name": "orderKey",
            "in": "query",
            "required": false,
            "description": "orderKey",
            "schema": {
              "type": "string",
              "default": "title"
            }
          },
          {
            "name": "order",
            "in": "query",
            "required": false,
            "description": "order",
            "schema": {
              "type": "string",
              "default": "asc"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 8,
                    "data": [
                        {
                            "id": 7557,
                            "isAnswerable": null,
                            "title": {
                                "en": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/admin/?_dc=1670320438&perspective=",
                                "ar_SA": "سؤال اليوم"
                            },
                            "displayStartDate": 1669143600,
                            "displayEndDate": 1672340400,
                            "questions": [
                                {
                                    "questionId": 1,
                                    "answerType": "Single Choice",
                                    "question": {
                                        "en": "Which one is your favorite Pepsi?",
                                        "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                    },
                                    "optionLabel": {
                                        "en": [
                                            "Pepsi Diet",
                                            "Pepsi Original",
                                            "Pepsi Wild Cherry",
                                            "Pepsi Max"
                                        ],
                                        "ar_SA": [
                                            "بيبسي دايت",
                                            "بيبسي اوريجينال",
                                            "بيبسي وايلد شيري",
                                            "بيبسي ماكس"
                                        ]
                                    },
                                    "optionValue": {
                                        "en": [
                                            "pepsi_det",
                                            "pepsi_original",
                                            "pepsi_wild_cherry",
                                            "pepsi_max"
                                        ],
                                        "ar_SA": [
                                            "pepsi_det",
                                            "pepsi_original",
                                            "pepsi_wild_cherry",
                                            "pepsi_max"
                                        ]
                                    },
                                    "optionImage": {
                                        "en": [
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052@3x.png",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_1.png",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_2.png",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_3.png"
                                        ],
                                        "ar_SA": [
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_4.png",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_5.png",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_6.png",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_7.png"
                                        ]
                                    },
                                    "isCorrectAnswer": {
                                        "en": [
                                            "No",
                                            "No",
                                            "No",
                                            "No"
                                        ],
                                        "ar_SA": [
                                            "No",
                                            "No",
                                            "No",
                                            "No"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "id": 7562,
                            "isAnswerable": null,
                            "title": {
                                "en": "QUICK SURVEY",
                                "ar_SA": "مسح سريع"
                            },
                            "displayStartDate": 1669143600,
                            "displayEndDate": 1672340400,
                            "questions": [
                                {
                                    "questionId": 1,
                                    "answerType": "Single Choice",
                                    "question": {
                                        "en": "Which one is your favorite Pepsi?",
                                        "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                    },
                                    "optionLabel": {
                                        "en": [
                                            "Pepsi Diet",
                                            "Pepsi Wild Cherry",
                                            "Pepsi Max",
                                            "Pepsi Original"
                                        ],
                                        "ar_SA": [
                                            "بيبسي دايت",
                                            "بيبسي اوريجينال",
                                            "بيبسي وايلد شيري",
                                            "بيبسي ماكس"
                                        ]
                                    },
                                    "optionValue": {
                                        "en": [
                                            "pepsi_det",
                                            "pepsi_wild_cherry",
                                            "pepsi_max",
                                            "pepsi_original"
                                        ],
                                        "ar_SA": [
                                            "pepsi_det",
                                            "pepsi_original",
                                            "pepsi_wild_cherry",
                                            "pepsi_max"
                                        ]
                                    },
                                    "optionImage": null,
                                    "isCorrectAnswer": {
                                        "en": [
                                            "No",
                                            "No",
                                            "No"
                                        ]
                                    }
                                },
                                {
                                    "questionId": 2,
                                    "answerType": "Single Choice",
                                    "question": {
                                        "en": "Which one is your favorite Pepsi?",
                                        "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                    },
                                    "optionLabel": {
                                        "en": [
                                            "Pepsi Diet",
                                            "Pepsi Wild Cherry",
                                            "Pepsi Max",
                                            "Pepsi Original"
                                        ],
                                        "ar_SA": [
                                            "بيبسي دايت",
                                            "بيبسي وايلد شيري",
                                            "بيبسي ماكس",
                                            "بيبسي اوريجينال"
                                        ]
                                    },
                                    "optionValue": {
                                        "en": [
                                            "pepsi_det",
                                            "pepsi_wild_cherry",
                                            "pepsi_max",
                                            "pepsi_original"
                                        ],
                                        "ar_SA": [
                                            "pepsi_det",
                                            "pepsi_wild_cherry",
                                            "pepsi_max",
                                            "pepsi_original"
                                        ]
                                    },
                                    "optionImage": null,
                                    "isCorrectAnswer": null
                                },
                                {
                                    "questionId": 3,
                                    "answerType": "Single Choice",
                                    "question": {
                                        "en": "Which one is your favorite Pepsi?",
                                        "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                    },
                                    "optionLabel": {
                                        "en": [
                                            "Pepsi Diet",
                                            "Pepsi Wild Cherry",
                                            "Pepsi Max",
                                            "Pepsi Original"
                                        ],
                                        "ar_SA": [
                                            "بيبسي دايت",
                                            "بيبسي وايلد شيري",
                                            "بيبسي ماكس",
                                            "بيبسي اوريجينال"
                                        ]
                                    },
                                    "optionValue": {
                                        "en": [
                                            "pepsi_det",
                                            "pepsi_wild_cherry",
                                            "pepsi_max",
                                            "pepsi_original"
                                        ],
                                        "ar_SA": [
                                            "pepsi_det",
                                            "pepsi_wild_cherry",
                                            "pepsi_max",
                                            "pepsi_original"
                                        ]
                                    },
                                    "optionImage": null,
                                    "isCorrectAnswer": null
                                },
                                {
                                    "questionId": 4,
                                    "answerType": "Single Choice",
                                    "question": {
                                        "en": "Which one is your favorite Pepsi?",
                                        "ar_SA": "أيهما بيبسي المفضل لديك؟z"
                                    },
                                    "optionLabel": {
                                        "en": [
                                            "Pepsi Diet",
                                            "Pepsi Wild Cherry",
                                            "Pepsi Max",
                                            "Pepsi Original"
                                        ],
                                        "ar_SA": [
                                            "بيبسي دايت",
                                            "بيبسي وايلد شيري",
                                            "بيبسي ماكس",
                                            "بيبسي اوريجينال"
                                        ]
                                    },
                                    "optionValue": {
                                        "en": [
                                            "pepsi_det",
                                            "pepsi_wild_cherry",
                                            "pepsi_max",
                                            "pepsi_original"
                                        ],
                                        "ar_SA": [
                                            "pepsi_det",
                                            "pepsi_wild_cherry",
                                            "pepsi_max",
                                            "pepsi_original"
                                        ]
                                    },
                                    "optionImage": null,
                                    "isCorrectAnswer": null
                                }
                            ]
                        },
                        {
                            "id": 7581,
                            "isAnswerable": "Yes",
                            "title": {
                                "en": "QUESTION OF THE DAY",
                                "ar_SA": "سؤال اليوم"
                            },
                            "displayStartDate": 1669143600,
                            "displayEndDate": 1672340400,
                            "questions": [
                                {
                                    "questionId": 1,
                                    "answerType": "Single Choice",
                                    "question": {
                                        "en": "Which one is your favorite Pepsi?",
                                        "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                    },
                                    "optionLabel": {
                                        "en": [
                                            "Pepsi Diet",
                                            "Pepsi Original",
                                            "Pepsi Wild Cherry",
                                            "Pepsi Max"
                                        ],
                                        "ar_SA": [
                                            "بيبسي دايت",
                                            "بيبسي اوريجينال",
                                            "بيبسي وايلد شيري",
                                            "بيبسي ماكس"
                                        ]
                                    },
                                    "optionValue": {
                                        "en": [
                                            "pepsi_det",
                                            "pepsi_original",
                                            "pepsi_wild_cherry",
                                            "pepsi_max"
                                        ],
                                        "ar_SA": [
                                            "pepsi_det",
                                            "pepsi_original",
                                            "pepsi_wild_cherry",
                                            "pepsi_max"
                                        ]
                                    },
                                    "optionImage": null,
                                    "isCorrectAnswer": {
                                        "en": [
                                            "No",
                                            "Yes",
                                            "No",
                                            "No"
                                        ],
                                        "ar_SA": [
                                            "No",
                                            "Yes",
                                            "No",
                                            "No"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "id": 7890,
                            "isAnswerable": "No",
                            "title": {
                                "en": "Which is your favorite Movie ",
                                "ar_SA": "ما هو فيلمك المفضل"
                            },
                            "displayStartDate": 1670265000,
                            "displayEndDate": 1674937800,
                            "questions": [
                                {
                                    "questionId": 1,
                                    "answerType": "Single Choice",
                                    "question": {
                                        "en": "Which is your favorite Movie",
                                        "ar_SA": "ما هو فيلمك المفضل"
                                    },
                                    "optionLabel": {
                                        "en": [
                                            "Black Panther",
                                            "Doctor Strange",
                                            "Spider Man",
                                            "Wonder Woman"
                                        ],
                                        "ar_SA": [
                                            "الفهد الأسود",
                                            "دكتور غريب",
                                            "الرجل العنكبوت",
                                            "إمراة رائعة"
                                        ]
                                    },
                                    "optionValue": {
                                        "en": [
                                            "Black Panther",
                                            "Doctor Strange",
                                            "Spider Man",
                                            "Wonder Woman"
                                        ],
                                        "ar_SA": [
                                            "الفهد الأسود",
                                            "دكتور غريب",
                                            "الرجل العنكبوت",
                                            "إمراة رائعة"
                                        ]
                                    },
                                    "optionImage": {
                                        "en": [
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Blackp.JPG",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/strange.JPG",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/spiderman.JPG",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/wonder.JPG"
                                        ],
                                        "ar_SA": [
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Blackp_1.JPG",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/strange_1.JPG",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/spiderman_1.JPG",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/wonder_1.JPG"
                                        ]
                                    },
                                    "isCorrectAnswer": {
                                        "en": [
                                            "No",
                                            "No",
                                            "No",
                                            "No"
                                        ],
                                        "ar_SA": [
                                            "No",
                                            "No",
                                            "No",
                                            "No"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "id": 7893,
                            "isAnswerable": "Yes",
                            "title": {
                                "en": "Doritos Quiz. Answer and Win a chance to get brand new Tesla!",
                                "ar_SA": "مسابقة دوريتوس. أجب واربح فرصة للحصول على تسلا جديدة!"
                            },
                            "displayStartDate": 1670265000,
                            "displayEndDate": 1680201000,
                            "questions": [
                                {
                                    "questionId": 1,
                                    "answerType": "Single Choice",
                                    "question": {
                                        "en": "Who was the Lead Actor in Black Adam",
                                        "ar_SA": null
                                    },
                                    "optionLabel": {
                                        "en": [
                                            "leonadro Di caprio",
                                            "Dwayne Johnson"
                                        ]
                                    },
                                    "optionValue": {
                                        "en": [
                                            "leonadro Di caprio",
                                            "Dwayne Johnson"
                                        ]
                                    },
                                    "optionImage": null,
                                    "isCorrectAnswer": {
                                        "en": [
                                            "Yes"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "id": 7971,
                            "isAnswerable": "No",
                            "title": {
                                "en": "Win Free Movie Tickets",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "displayStartDate": 1670351400,
                            "displayEndDate": 1674937800,
                            "questions": [
                                {
                                    "questionId": 1,
                                    "answerType": "Single Choice",
                                    "question": {
                                        "en": "When do you consume snacks",
                                        "ar_SA": "متى تستهلك الوجبات الخفيفة"
                                    },
                                    "optionLabel": {
                                        "en": [
                                            "Watching Movies ",
                                            "House Parties",
                                            "With Family",
                                            "Evening snacks time"
                                        ],
                                        "ar_SA": [
                                            "مشاهدة الأفلام",
                                            "حفلات البيت",
                                            "مع العائلة",
                                            "وقت الوجبات الخفيفة في المساء"
                                        ]
                                    },
                                    "optionValue": {
                                        "en": [
                                            "Watching Movies ",
                                            "House Parties",
                                            "With Family",
                                            "Evening snacks time"
                                        ],
                                        "ar_SA": [
                                            "مشاهدة الأفلام",
                                            "حفلات البيت",
                                            "مع العائلة",
                                            "وقت الوجبات الخفيفة في المساء"
                                        ]
                                    },
                                    "optionImage": null,
                                    "isCorrectAnswer": null
                                }
                            ]
                        },
                        {
                            "id": 7972,
                            "isAnswerable": "No",
                            "title": {
                                "en": "Win Free Movie Tickets",
                                "ar_SA": "اربح تذاكر أفلام مجانية"
                            },
                            "displayStartDate": 1670351400,
                            "displayEndDate": 1674937800,
                            "questions": [
                                {
                                    "questionId": 1,
                                    "answerType": "Single Choice",
                                    "question": {
                                        "en": "When do you consume snacks",
                                        "ar_SA": "متى تستهلك الوجبات الخفيفة"
                                    },
                                    "optionLabel": {
                                        "en": [
                                            "Watching Movies ",
                                            "House Parties",
                                            "With Family",
                                            "Evening snacks time"
                                        ],
                                        "ar_SA": [
                                            "مشاهدة الأفلام",
                                            "حفلات البيت",
                                            "مع العائلة",
                                            "وقت الوجبات الخفيفة في المساء"
                                        ]
                                    },
                                    "optionValue": {
                                        "en": [
                                            "Watching Movies ",
                                            "House Parties",
                                            "With Family",
                                            "Evening snacks time"
                                        ],
                                        "ar_SA": [
                                            "مشاهدة الأفلام",
                                            "حفلات البيت",
                                            "مع العائلة",
                                            "وقت الوجبات الخفيفة في المساء"
                                        ]
                                    },
                                    "optionImage": null,
                                    "isCorrectAnswer": {
                                        "en": [
                                            "No",
                                            "No",
                                            "No",
                                            "No"
                                        ],
                                        "ar_SA": [
                                            "No",
                                            "No",
                                            "No",
                                            "No"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "id": 8452,
                            "isAnswerable": null,
                            "title": {
                                "en": "QUESTION OF THE DAY",
                                "ar_SA": "سؤال اليوم"
                            },
                            "displayStartDate": 1669143600,
                            "displayEndDate": 1672340400,
                            "questions": [
                                {
                                    "questionId": 1,
                                    "answerType": "Single Choice",
                                    "question": {
                                        "en": "Which one is your favorite Pepsi?",
                                        "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                    },
                                    "optionLabel": {
                                        "en": [
                                            "Pepsi Diet",
                                            "Pepsi Original",
                                            "Pepsi Wild Cherry",
                                            "Pepsi Max"
                                        ],
                                        "ar_SA": [
                                            "بيبسي دايت",
                                            "بيبسي اوريجينال",
                                            "بيبسي وايلد شيري",
                                            "بيبسي ماكس"
                                        ]
                                    },
                                    "optionValue": {
                                        "en": [
                                            "pepsi_det",
                                            "pepsi_original",
                                            "pepsi_wild_cherry",
                                            "pepsi_max"
                                        ],
                                        "ar_SA": [
                                            "pepsi_det",
                                            "pepsi_original",
                                            "pepsi_wild_cherry",
                                            "pepsi_max"
                                        ]
                                    },
                                    "optionImage": null,
                                    "isCorrectAnswer": null
                                }
                            ]
                        }
                    ],
                    "expiryData": [],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/survey/view": {
      "get": {
        "tags": [
          "Survey"
        ],
        "summary": "Survey Details",
        "description": "Survey Details",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "surveyId",
            "in": "query",
            "required": false,
            "description": "surveyId",
            "schema": {
              "type": "number",
              "default": 7557
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 1,
                    "data": [
                        {
                            "id": 7557,
                            "isAnswerable": null,
                            "title": {
                                "en": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/admin/?_dc=1670320438&perspective=",
                                "ar_SA": "سؤال اليوم"
                            },
                            "displayStartDate": 1669143600,
                            "displayEndDate": 1672340400,
                            "questions": [
                                {
                                    "questionId": 1,
                                    "answerType": "Single Choice",
                                    "question": {
                                        "en": "Which one is your favorite Pepsi?",
                                        "ar_SA": "أيهما بيبسي المفضل لديك؟"
                                    },
                                    "optionLabel": {
                                        "en": [
                                            "Pepsi Diet",
                                            "Pepsi Original",
                                            "Pepsi Wild Cherry",
                                            "Pepsi Max"
                                        ],
                                        "ar_SA": [
                                            "بيبسي دايت",
                                            "بيبسي اوريجينال",
                                            "بيبسي وايلد شيري",
                                            "بيبسي ماكس"
                                        ]
                                    },
                                    "optionValue": {
                                        "en": [
                                            "pepsi_det",
                                            "pepsi_original",
                                            "pepsi_wild_cherry",
                                            "pepsi_max"
                                        ],
                                        "ar_SA": [
                                            "pepsi_det",
                                            "pepsi_original",
                                            "pepsi_wild_cherry",
                                            "pepsi_max"
                                        ]
                                    },
                                    "optionImage": {
                                        "en": [
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052@3x.png",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_1.png",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_2.png",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_3.png"
                                        ],
                                        "ar_SA": [
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_4.png",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_5.png",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_6.png",
                                            "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/Mask%20Group%2031052%403x_7.png"
                                        ]
                                    },
                                    "isCorrectAnswer": {
                                        "en": [
                                            "No",
                                            "No",
                                            "No",
                                            "No"
                                        ],
                                        "ar_SA": [
                                            "No",
                                            "No",
                                            "No",
                                            "No"
                                        ]
                                    }
                                }
                            ]
                        }
                    ],
                    "expiryData": [],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/wallpaper": {
      "get": {
        "tags": [
          "Wallpaper"
        ],
        "summary": "Wallpaper List",
        "description": "Wallpaper List",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          },
          {
            "name": "orderKey",
            "in": "query",
            "required": false,
            "description": "orderKey",
            "schema": {
              "type": "string",
              "default": "title"
            }
          },
          {
            "name": "order",
            "in": "query",
            "required": false,
            "description": "order",
            "schema": {
              "type": "string",
              "default": "asc"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 1,
                    "data": [
                        {
                            "id": 7493,
                            "title": {
                                "en": "Phone",
                                "ar_SA": "هاتف"
                            },
                            "wallpaperImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/pepsi_phone_wallpaper_3x.png"
                        }
                    ],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/wallpaper-detail": {
      "get": {
        "tags": [
          "Wallpaper"
        ],
        "summary": "Wallpaper Details",
        "description": "Wallpaper Details",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "id",
            "in": "query",
            "required": false,
            "description": "id",
            "schema": {
              "type": "number",
              "default": 7493
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "data": [
                        {
                            "id": 7493,
                            "title": {
                                "en": "Phone",
                                "ar_SA": "هاتف"
                            },
                            "wallpaperImage": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/pepsi_phone_wallpaper_3x.png"
                        }
                    ],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/draw": {
      "get": {
        "tags": [
          "Draw"
        ],
        "summary": "Draw List",
        "description": "Draw List",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "limit",
            "in": "query",
            "required": false,
            "description": "limit",
            "schema": {
              "type": "number",
              "default": 20,
              "maximum": 100
            }
          },
          {
            "name": "offset",
            "in": "query",
            "required": false,
            "description": "offset",
            "schema": {
              "type": "number",
              "default": 0
            }
          },
          {
            "name": "orderKey",
            "in": "query",
            "required": false,
            "description": "orderKey",
            "schema": {
              "type": "string",
              "default": "title"
            }
          },
          {
            "name": "order",
            "in": "query",
            "required": false,
            "description": "order",
            "schema": {
              "type": "string",
              "default": "asc"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 1,
                    "data": [
                        {
                            "id": 7531,
                            "title": {
                                "en": "Draw1",
                                "ar_SA": "ارسم 1"
                            },
                            "description": {
                                "en": "<p>Draw1</p>\n",
                                "ar_SA": "<p>ارسم 1</p>\n"
                            },
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/voucher@3x.png"
                        }
                    ],
                    "expiryData": [],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/draw/view": {
      "get": {
        "tags": [
          "Draw"
        ],
        "summary": "Draw Details",
        "description": "Draw Details",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          },
          {
            "name": "drawId",
            "in": "query",
            "required": false,
            "description": "drawId",
            "schema": {
              "type": "number",
              "default": 7531
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "totalCount": 1,
                    "data": [
                        {
                            "id": 7531,
                            "title": {
                                "en": "Draw1",
                                "ar_SA": "ارسم 1"
                            },
                            "description": {
                                "en": "<p>Draw1</p>\n",
                                "ar_SA": "<p>ارسم 1</p>\n"
                            },
                            "image": "https://cepsaadmin.spo.nonprod.wspdop.pepsico.com/_default_upload_bucket/voucher@3x.png"
                        }
                    ],
                    "expiryData": [],
                    "success": true
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/challenge/coupon": {
      "post": {
        "tags": ["Challenges"],
        "summary": "Claim Challenge Coupon",
        "description": "Claim a coupon for a challenge.",
        "parameters": [
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}},
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}}
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "type": "object",
                "required": ["couponCode", "challengeId"],
                "properties": {
                  "couponCode": {"type": "string"},
                  "challengeId": {"type": "integer"}
                }
              }
            }
          }
        },
        "responses": {
          "200": {"description": "Coupon claim result", "content": {"application/json": {"example": {"correlationId": "abc123"}}}},
          "500": {"description": "Internal Server Error", "content": {"*/*": {"schema": {"$ref": "#/components/schemas/Problem"}}}}
        }
      }
    },
    "/customer-testimonials": {
      "get": {
        "tags": ["Content"],
        "summary": "Customer Testimonials",
        "description": "Get customer testimonials.",
        "parameters": [
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}},
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}}
        ],
        "responses": {"200": {"description": "OK", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/getpoint": {
      "get": {
        "tags": ["Points"],
        "summary": "Retrieve Points",
        "description": "Retrieve the current user's points.",
        "parameters": [
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}},
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}}
        ],
        "responses": {
          "200": {
            "description": "OK",
            "content": {"application/json": {"schema": {"type": "object", "properties": {"success": {"type": "boolean"}, "points": {"type": "integer"}}}}}
          }
        }
      }
    },
    "/loyalty/reward/offer/view": {
      "get": {
        "tags": ["Rewards"],
        "summary": "Reward/Offer Details",
        "description": "Get reward or offer details.",
        "parameters": [
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}},
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "id", "in": "query", "required": true, "schema": {"type": "integer"}}
        ],
        "responses": {"200": {"description": "OK", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/pepshots": {
      "get": {
        "tags": ["Pepshots"],
        "summary": "Pepshots List",
        "description": "Get the Pepshots video list.",
        "parameters": [
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}},
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "limit", "in": "query", "required": false, "schema": {"type": "integer"}},
          {"name": "offset", "in": "query", "required": false, "schema": {"type": "integer"}}
        ],
        "responses": {"200": {"description": "OK", "content": {"application/json": {"schema": {"type": "object"}}}}}
      },
      "post": {
        "tags": ["Pepshots"],
        "summary": "Record Pepshots Action",
        "description": "Record an action for a Pepshots video.",
        "parameters": [
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}},
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}}
        ],
        "requestBody": {"required": true, "content": {"application/json": {"schema": {"type": "object", "properties": {"videoId": {"type": "integer"}}}}}},
        "responses": {"200": {"description": "OK", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/points-transaction-history": {
      "get": {
        "tags": ["Points"],
        "summary": "Points Transaction History",
        "description": "Get the current user's points transaction history.",
        "parameters": [
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}},
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "language", "in": "query", "required": true, "schema": {"type": "string"}},
          {"name": "days", "in": "query", "required": true, "schema": {"type": "integer"}},
          {"name": "page", "in": "query", "required": true, "schema": {"type": "integer"}}
        ],
        "responses": {"200": {"description": "OK", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/get-points": {
      "get": {
        "tags": [
          "Points"
        ],
        "summary": "Retrieve Points",
        "description": "Retrieve Points",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {                                                                                             
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          }
        ],
        "responses": {
          "200": {
            "description": "OK",        
            "content": {
              "application/json": {
                "example": {
                   "success": "true",
                   "points": "400"
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/updatepoint": {
      "put": {
        "tags": [
          "Points"
        ],
        "summary": "Update Points",
        "description": "Update Points",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "object",
                "properties": {
                  "id": {
                    "type": "object"
                  }
                }
              },
              "example": {
                  "action":"credit",
                  "activityType" : "challenge",
                  "activityTypeId" : 80,
                  "points" : 10
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "success": "true",
                    "type": "challenge",
                    "points": 410,
                    "message": "User points have been updated succesfully."
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    },
    "/challenge/pre-completed": {
      "get": {
        "tags": ["Challenges"],
        "summary": "Start Pre-completed Challenge Processing",
        "description": "Starts background processing for the authenticated user's deferred challenges.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}
        ],
        "responses": {
          "200": {"description": "Processing started or already started", "content": {"application/json": {"schema": {"type": "object"}}}},
          "401": {"description": "Authentication required"}
        }
      }
    },
    "/scan": {
      "post": {
        "tags": ["Scan"],
        "summary": "Submit Receipt Scan",
        "description": "Submit receipt data for scan processing.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}
        ],
        "requestBody": {"required": true, "content": {"application/json": {"schema": {"type": "object"}}}},
        "responses": {"200": {"description": "Scan submitted", "content": {"application/json": {"schema": {"type": "object"}}}}, "400": {"description": "Bad Request"}}
      },
      "put": {
        "tags": ["Scan"],
        "summary": "Update Receipt Scan",
        "description": "Update a submitted receipt scan.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}
        ],
        "requestBody": {"required": true, "content": {"application/json": {"schema": {"type": "object"}}}},
        "responses": {"200": {"description": "Scan updated", "content": {"application/json": {"schema": {"type": "object"}}}}, "400": {"description": "Bad Request"}}
      }
    },
    "/scanlist": {
      "get": {
        "tags": ["Scan"],
        "summary": "Receipt Scan List",
        "description": "Get the authenticated user's receipt scans.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}},
          {"name": "limit", "in": "query", "required": false, "schema": {"type": "integer"}},
          {"name": "offset", "in": "query", "required": false, "schema": {"type": "integer"}}
        ],
        "responses": {"200": {"description": "OK", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/scan-progress": {
      "get": {
        "tags": ["Scan"],
        "summary": "Receipt Scan Progress",
        "description": "Get processing progress for a receipt scan.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}},
          {"name": "scanId", "in": "query", "required": true, "schema": {"type": "integer"}}
        ],
        "responses": {"200": {"description": "OK", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/scan-tutorial-images-list": {
      "get": {
        "tags": ["Scan"],
        "summary": "Scan Tutorial Images",
        "description": "Get receipt scanning tutorial images.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}
        ],
        "responses": {"200": {"description": "OK", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/receipt-challenge-scan": {
      "post": {
        "tags": ["Scan"],
        "summary": "Submit Receipt Challenge Scan",
        "description": "Submit a receipt scan associated with a challenge.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}
        ],
        "requestBody": {"required": true, "content": {"application/json": {"schema": {"type": "object"}}}},
        "responses": {"200": {"description": "Scan submitted", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/receipt-footer-scan": {
      "post": {
        "tags": ["Scan"],
        "summary": "Submit Receipt Footer Scan",
        "description": "Submit receipt footer scan data.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}
        ],
        "requestBody": {"required": true, "content": {"application/json": {"schema": {"type": "object"}}}},
        "responses": {"200": {"description": "Scan submitted", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/update-receipt-ids": {
      "post": {
        "tags": ["Scan"],
        "summary": "Update Receipt IDs",
        "description": "Update receipt identifiers after scanning.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}
        ],
        "requestBody": {"required": true, "content": {"application/json": {"schema": {"type": "object"}}}},
        "responses": {"200": {"description": "Receipt IDs updated", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/update-ispepsico-scan-flag": {
      "post": {
        "tags": ["Scan"],
        "summary": "Update PepsiCo Scan Flag",
        "description": "Update the PepsiCo scan flag for a receipt.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}
        ],
        "requestBody": {"required": true, "content": {"application/json": {"schema": {"type": "object"}}}},
        "responses": {"200": {"description": "Scan flag updated", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/raffle-winners-list": {
      "get": {
        "tags": ["Raffle"],
        "summary": "Raffle Winners List",
        "description": "Get the raffle winners list.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}},
          {"name": "limit", "in": "query", "required": false, "schema": {"type": "integer"}},
          {"name": "offset", "in": "query", "required": false, "schema": {"type": "integer"}}
        ],
        "responses": {"200": {"description": "OK", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/raffle-winners-records": {
      "get": {
        "tags": ["Raffle"],
        "summary": "Raffle Winner Records",
        "description": "Get raffle winner records.",
        "parameters": [
          {"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}},
          {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}
        ],
        "responses": {"200": {"description": "OK", "content": {"application/json": {"schema": {"type": "object"}}}}}
      }
    },
    "/account/storeMapImage": {
      "post": {"tags": ["Account"], "summary": "Store Map Image", "description": "Upload a store map image.", "parameters": [{"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}}, {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}], "requestBody": {"required": true, "content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/account/customerImage": {
      "post": {"tags": ["Account"], "summary": "Customer Image", "description": "Upload a customer profile image.", "parameters": [{"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}}, {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}], "requestBody": {"required": true, "content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/account/employees": {
      "get": {"tags": ["Account"], "summary": "Employee List", "description": "Get employees for the authenticated account.", "parameters": [{"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}}, {"name": "okta-accesstoken", "in": "header", "required": true, "schema": {"type": "string"}}], "responses": {"200": {"description": "OK"}}}
    },
    "/auth/stores": {
      "get": {"tags": ["Authentication"], "summary": "Stores by Tax ID", "description": "Get stores matching a tax ID.", "parameters": [{"name": "SiteId", "in": "header", "required": true, "schema": {"type": "number", "default": 10}}, {"name": "x-api-key", "in": "header", "required": true, "schema": {"type": "string"}}, {"name": "taxId", "in": "query", "required": true, "schema": {"type": "string"}}], "responses": {"200": {"description": "OK"}}}
    },
    "/auth/activate": {
      "post": {"tags": ["Authentication"], "summary": "Activate Account", "description": "Activate an account.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/deactivate": {
      "post": {"tags": ["Authentication"], "summary": "Deactivate Account", "description": "Deactivate an account.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/unSuspend": {
      "post": {"tags": ["Authentication"], "summary": "Unsuspend Account", "description": "Unsuspend an account.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/forgotpwd": {
      "post": {"tags": ["Authentication"], "summary": "Forgot Password", "description": "Start the password recovery flow.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/forgotpwd/verifyRecovery": {
      "post": {"tags": ["Authentication"], "summary": "Verify Password Recovery", "description": "Verify a password recovery code.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/credentials/reset_password": {
      "post": {"tags": ["Authentication"], "summary": "Reset Password", "description": "Reset a password using recovery credentials.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/changepwd": {
      "post": {"tags": ["Authentication"], "summary": "Change Password", "description": "Change the authenticated user's password.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/validateProfile": {
      "post": {"tags": ["Authentication"], "summary": "Validate Profile", "description": "Validate account profile data.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/resendOtp": {
      "post": {"tags": ["Authentication"], "summary": "Resend OTP", "description": "Resend a one-time password.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/verifyCode": {
      "post": {"tags": ["Authentication"], "summary": "Verify Code", "description": "Verify an authentication code.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/employee/register": {
      "post": {"tags": ["Authentication"], "summary": "Register Employee", "description": "Register an employee account.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/validateTaxId": {
      "post": {"tags": ["Authentication"], "summary": "Validate Tax ID", "description": "Validate a tax identifier.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/generateCode": {
      "post": {"tags": ["Authentication"], "summary": "Generate Code", "description": "Generate an authentication code.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/newUserIdOTP": {
      "post": {"tags": ["Authentication"], "summary": "New User ID OTP", "description": "Generate an OTP for changing a user ID.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/changeUserId": {
      "post": {"tags": ["Authentication"], "summary": "Change User ID", "description": "Change the authenticated user's ID.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/checkstaus": {
      "get": {"tags": ["Authentication"], "summary": "Check Account Status", "description": "Check account status.", "responses": {"200": {"description": "OK"}}}
    },
    "/auth/sfmc-register-user": {
      "post": {"tags": ["Authentication"], "summary": "Register SFMC User", "description": "Register a user from SFMC.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/auth/reactivate": {
      "post": {"tags": ["Authentication"], "summary": "Reactivate Account", "description": "Reactivate an account.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/state-codes": {
      "get": {"tags": ["Authentication"], "summary": "State Codes", "description": "Get state and region codes.", "responses": {"200": {"description": "OK"}}}
    },
    "/eausername": {
      "post": {"tags": ["Authentication"], "summary": "Validate EA Username", "description": "Validate an EA username.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/customerstatus": {
      "get": {"tags": ["Account"], "summary": "Customer Status", "description": "Get the authenticated customer's status.", "responses": {"200": {"description": "OK"}}}
    },
    "/updatereason": {
      "put": {"tags": ["Account"], "summary": "Update Customer Reason", "description": "Update the customer's reason/status data.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/guestuser": {
      "get": {"tags": ["Account"], "summary": "Guest User", "description": "Get guest user information.", "responses": {"200": {"description": "OK"}}}
    },
    "/eafullfill": {
      "post": {"tags": ["Rewards"], "summary": "EA Fulfillment", "description": "Fulfill an EA reward request.", "requestBody": {"content": {"application/json": {"schema": {"type": "object"}}}}, "responses": {"200": {"description": "OK"}}}
    },
    "/getConfiguration": {
      "get": {"tags": ["Configuration"], "summary": "Get Configuration", "description": "Get site configuration for the client.", "responses": {"200": {"description": "OK"}}}
    },
    "/content/category": {
      "get": {"tags": ["Content"], "summary": "Content Categories", "description": "Get content categories.", "responses": {"200": {"description": "OK"}}}
    },
    "/content/tag": {
      "get": {"tags": ["Content"], "summary": "Content Tags", "description": "Get content tags.", "responses": {"200": {"description": "OK"}}}
    },
    "/content/{slug}": {
      "get": {"tags": ["Content"], "summary": "Content by Slug", "description": "Get content by slug.", "parameters": [{"name": "slug", "in": "path", "required": true, "schema": {"type": "string"}}], "responses": {"200": {"description": "OK"}}}
    },
    "/navigation": {
      "get": {"tags": ["Content"], "summary": "Navigation", "description": "Get site navigation.", "responses": {"200": {"description": "OK"}}}
    },
    "/verify": {
      "post": {
        "tags": [
          "Scan & Verify"
        ],
        "summary": "Scan & Verify",
        "description": "Scan & Verify",
        "parameters": [
          {
            "name": "okta-accesstoken",
            "in": "header",
            "required": true,
            "description": "okta-accesstoken(Required)",
            "schema": {
              "type": "string",
              "default": "eyJraWQiOiI2ZTdPNHpMdThqckMtZW5aUHhMVS0yZ2lIUW5xY3ZTMTRzQVNrXy1kbXJNIiwiYWxnIjoiUlMyNTYifQ"
            }
          },
          {
            "name": "SiteId",
            "in": "header",
            "required": true,
            "description": "SiteId",
            "schema": {
              "type": "number",
              "default": 10
            }
          }
        ],
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "type": "object",
                "properties": {
                  "id": {
                    "type": "object"
                  }
                }
              },
              "example": {
                    "data": {
                        "account_number": {
                            "bounding_region": [
                            0.8081,
                            0.4177,
                            0.8081,
                            0.4094,
                            0.9004,
                            0.4094,
                            0.9004,
                            0.4177
                            ],
                            "ocr_score": 0.88,
                            "rotation": 0,
                            "score": 0.85,
                            "value": "428331"
                        },
                        "bill_to": {
                            "address": {
                            "score": 0.98,
                            "value": null
                            },
                            "name": {
                            "score": 0.97,
                            "value": null
                            },
                            "parsed_address": null,
                            "vat_number": {
                            "score": 0.95,
                            "value": null
                            }
                        },
                        "cashback": {
                            "score": 1,
                            "value": null
                        },
                        "category": {
                            "score": 0.91,
                            "value": "Meals & Entertainment"
                        },
                        "confidence_details": true,
                        "created_date": "2022-10-31 20:14:35",
                        "currency_code": {
                            "score": 0.6,
                            "value": "AED"
                        },
                        "date": {
                            "bounding_region": [
                            0.8071,
                            0.5044,
                            0.8696,
                            0.5044,
                            0.8696,
                            0.5132,
                            0.8071,
                            0.5132
                            ],
                            "rotation": 0,
                            "score": 0.99,
                            "value": "2022-10-31 12:37:00"
                        },
                        "delivery_date": {
                            "score": 1,
                            "value": null
                        },
                        "discount": {
                            "score": 1,
                            "value": null
                        },
                        "document_reference_number": {
                            "score": 0.83,
                            "value": null
                        },
                        "document_title": {
                            "score": 0.7,
                            "value": null
                        },
                        "document_type": {
                            "score": 0.91,
                            "value": "receipt"
                        },
                        "due_date": {
                            "score": 1,
                            "value": null
                        },
                        "duplicate_of": null,
                        "external_id": null,
                        "guest_count": {
                            "score": 1,
                            "value": null
                        },
                        "id": 99850804,
                        "img_file_name": "99850804.jpg",
                        "img_thumbnail_url": "https://scdn.veryfi.com/receipts/aed4e8a4-0108-4db1-ba3c-6e05eea9c10b/thumbnail.jpg?Expires=1669177643&Signature=GvxCCIixs8pkfB8pzeIOYAVuwdYRhGk0XrM2prkKa-VW20By0mejR10ia0jFg5P4LwTYj~APKBaetkq~sS3~y-Qv7cC~UZC1RrX6RKWC2ZVL5hIIORUTJN-4ALB27qC6nRrFuv6aJnoIjEkzbbkHbnreixBdjAeESIcLYKNXS0mraemb9dNcj7SUR33GyZhiEnlA3qqHlBNMELje6hctlDjmL6HUy16QpoJv~wguK3lQqur7NGKwhfNrpGr9pngDCqYix8CycbWWOZiTrxE1N6ySpfRPjUUTfnqMNLcKvEAn8rVjgsb2dC9l-OA66sdEbG80PImpw8GWp3kVES7Z1Q__&Key-Pair-Id=APKAJCILBXEJFZF4DCHQ",
                        "img_url": "https://scdn.veryfi.com/receipts/aed4e8a4-0108-4db1-ba3c-6e05eea9c10b/aacac531-0386-44c4-a78a-17086315f124.jpg?Expires=1669177643&Signature=Lk1jPgtj3tH7i81a3ypicoovGbxoYJbibSVuwMfSnFPopxo3pv75v3C4N65VkWjZqlWOu53wLJmL-4o7baeoTHs8RVRg5R8O6Bo~2AE4vZD1lFliHpZadBUGPU02d4gKUdgwb839zFO48NcUhxdHgtXuDlEBKMU3ml5G2kIeoVJK~gMVom83IKf9~LDaV7sKH1ZjQUbs7igL9002Hd5ze5F6gEmRRfJUe5Hs7jogtyRUu~NJEtMX3aIpjSryw45iUGV8kfHtJsQ4JU9rFvz9cY4aNIHCJhJkoym4QzoLUS1bOmA9xOSF81hJoRwnjtoEI2bnt6zq7b5ul7~6LrVoAw__&Key-Pair-Id=APKAJCILBXEJFZF4DCHQ",
                        "insurance": {
                            "score": 1,
                            "value": null
                        },
                        "invoice_number": {
                            "score": 0.74,
                            "value": null
                        },
                        "is_duplicate": false,
                        "is_money_in": {
                            "score": 0.93,
                            "value": false
                        },
                        "line_items": [
                            {
                            "date": null,
                            "description": "MOUNTAIN DEW REG C\nCO C\nکر\nاين دايري",
                            "discount": null,
                            "discount_rate": null,
                            "id": 373905552,
                            "order": 0,
                            "price": null,
                            "quantity": 3,
                            "reference": null,
                            "section": null,
                            "sku": null,
                            "tags": ["pepsico"],
                            "tax": null,
                            "tax_rate": null,
                            "text": "MOUNTAIN DEW REG C\t3. CO C\nکر\tاين\tدايري",
                            "total": 50,
                            "type": "food",
                            "unit_of_measure": null,
                            "upc": null
                            },
                            {
                            "date": null,
                            "description": "7 UP/Seven Up C\nCO C\nکر\nاين دايري",
                            "discount": null,
                            "discount_rate": null,
                            "id": 373905552,
                            "order": 0,
                            "price": null,
                            "quantity": 3,
                            "reference": null,
                            "section": null,
                            "sku": null,
                            "tags": ["pepsico"],
                            "tax": null,
                            "tax_rate": null,
                            "text": "7 UP/Seven Up C\t3. CO C\nکر\tاين\tدايري",
                            "total": 100,
                            "type": "food",
                            "unit_of_measure": null,
                            "upc": null
                            },
                            {
                            "date": null,
                            "description": "LXDAIRY VANILLA IX",
                            "discount": null,
                            "discount_rate": null,
                            "id": 373905553,
                            "order": 1,
                            "price": null,
                            "quantity": 1,
                            "reference": null,
                            "section": null,
                            "sku": null,
                            "tags": [],
                            "tax": null,
                            "tax_rate": null,
                            "text": "LXDAIRY VANILLA IX\t8.25 C",
                            "total": 8.25,
                            "type": "food",
                            "unit_of_measure": null,
                            "upc": null
                            }
                        ],
                        "line_items_with_scores": [
                            {
                            "description": {
                                "bounding_box": [
                                0,
                                0.6543,
                                0.3069,
                                0.9487,
                                0.3315
                                ],
                                "bounding_region": [
                                0.6543,
                                0.3069,
                                0.9487,
                                0.3069,
                                0.9487,
                                0.3315,
                                0.6543,
                                0.3315
                                ],
                                "ocr_score": 0.8,
                                "rotation": 0,
                                "score": 0.61,
                                "value": "MOUNTAIN DEW REG C\nCO C\nکر\nاين دايري"
                            },
                            "full_description": {
                                "bounding_box": [
                                0,
                                0.6543,
                                0.3069,
                                0.9487,
                                0.3315
                                ],
                                "bounding_region": [
                                0.6543,
                                0.3069,
                                0.9487,
                                0.3069,
                                0.9487,
                                0.3315,
                                0.6543,
                                0.3315
                                ],
                                "ocr_score": 0.82,
                                "rotation": 0,
                                "score": 0.68,
                                "value": "MOUNTAIN DEW REG C\nCO C کر اين دايري"
                            },
                            "order": 0,
                            "quantity": {
                                "bounding_box": [
                                0,
                                0.9038,
                                0.3086,
                                0.915,
                                0.3171
                                ],
                                "bounding_region": [
                                0.9038,
                                0.3086,
                                0.915,
                                0.3086,
                                0.915,
                                0.3171,
                                0.9038,
                                0.3171
                                ],
                                "ocr_score": 0.59,
                                "rotation": 0,
                                "score": 0.22,
                                "value": "3."
                            },
                            "text": "MOUNTAIN DEW REG C\t3. CO C\nکر\tاين\tدايري",
                            "type": "food"
                            },
                            {
                            "description": {
                                "bounding_box": [
                                0,
                                0.6548,
                                0.3311,
                                0.7935,
                                0.3401
                                ],
                                "bounding_region": [
                                0.6548,
                                0.3311,
                                0.7935,
                                0.3311,
                                0.7935,
                                0.3401,
                                0.6548,
                                0.3401
                                ],
                                "ocr_score": 0.97,
                                "rotation": 0,
                                "score": 0.82,
                                "value": "LXDAIRY VANILLA IX"
                            },
                            "full_description": {
                                "bounding_box": [
                                0,
                                0.6548,
                                0.3311,
                                0.7935,
                                0.3401
                                ],
                                "bounding_region": [
                                0.6548,
                                0.3311,
                                0.7935,
                                0.3311,
                                0.7935,
                                0.3401,
                                0.6548,
                                0.3401
                                ],
                                "ocr_score": 0.97,
                                "rotation": 0,
                                "score": 0.82,
                                "value": "LXDAIRY VANILLA IX"
                            },
                            "order": 1,
                            "text": "LXDAIRY VANILLA IX\t8.25 C",
                            "total": {
                                "bounding_box": [
                                0,
                                0.9038,
                                0.3325,
                                0.9326,
                                0.3408
                                ],
                                "bounding_region": [
                                0.9038,
                                0.3325,
                                0.9326,
                                0.3325,
                                0.9326,
                                0.3408,
                                0.9038,
                                0.3408
                                ],
                                "ocr_score": 0.92,
                                "rotation": 0,
                                "score": 0.9,
                                "value": "8.25"
                            },
                            "type": "food"
                            }
                        ],
                        "meta": {
                            "owner": "pepsico-amesa"
                        },
                        "notes": null,
                        "ocr_text": "Danube\tالدانوب\nDanube Co for Fooc Stuff and Commodities\nدات\tالما\t9\tالغذائية\tللمواد\tالدانوب\tشركة\n-Al\tالسلام\nSalam Mall\tمول\nCustomer Service No: 8002442225\nEmail: danube@danubeco.com\nwww.danubeco.com\nSimplified Tax Invoice\nمبسطة\tضريبية\tفاتورة\n:31002558710003\tID\n(VAT\tالضريب\tالرقم\n:Price\nIncludes VAT\tالضريبه\tشامل\tالسعر\nديو\tديو\tديو\tماونتن\nMOUNTAIN DEW REG C\t3. CO C\nکر\tاين\tدايري\nLXDAIRY VANILLA IX\t8.25 C\nITEMS\t2\nTOTAL\t11.25\nکارد\tسبان\nSPAN CARD\tS3\t11.25\nCARD-NO\t428331******\n\t[ * * * * * *266\nEFT TERM.\t5546354502559871\nAUTH CODE\t001247\n\nNET TOTAL\tGRP C\t9.78\nVAT\t\t15.0%\t1.47\nالوادا\tالدانوب\tشركة\n*8096 0128/017/457 31.10.22 12:37 AC-00\n\nقريبا\tبزيارتنا\tنأمل\tو\tلزيارتك\tشكرا\nالعملاء\tخدمة\tمراجعة\tيرجى\tالإستبدال\tأو\tللإسترجاع\nThank you for ycour visit, corne again!\nFor exchange/return, please contact our customer service\n\n1103101780969",
                        "order_date": {
                            "score": 1,
                            "value": null
                        },
                        "payment": {
                            "card_number": {
                            "score": 0.97,
                            "value": null
                            },
                            "display_name": "Visa",
                            "terms": {
                            "score": 1,
                            "value": null
                            },
                            "type": {
                            "score": 0.54,
                            "value": "visa"
                            }
                        },
                        "pdf_url": "https://scdn.veryfi.com/receipts/aed4e8a4-0108-4db1-ba3c-6e05eea9c10b/60745d76-e7ba-4c2c-ac98-d9bf6a13b78f.pdf?Expires=1669177643&Signature=Jv7Rqc1QjxcZZG1QYB3RWgg~1ITK7lfusS1L5zjlz204UunCxnJeb0MOLwbnjPM53VnTs0p3IFIT6v6aJLc0hoVDB7ThqfObJ9bEfphPF~hntR6X8VsuB0T2ZIPnEib1dSoRZS-qPedKKfBO8UqzeY6DoQXULI3DCedxSLoxDjfWTkNNd78JbYwdI6cVFm1WLX9ltzt4m~sNt5mF8QnlrmYqUOfwAyoRk9uZi-PY5lRmyCNtKQuulVpgghbFoFkA16lMJSzk8AS8OqfpScwvdfUVz1RZv3Lie3WxV7HroebJAZGmtseq4xhCGT4MeB02ILDK09~mVysXAIZlW6mu2w__&Key-Pair-Id=APKAJCILBXEJFZF4DCHQ",
                        "purchase_order_number": {
                            "score": 0.71,
                            "value": null
                        },
                        "reference_number": "VIBIF-0804",
                        "rounding": {
                            "score": 1,
                            "value": null
                        },
                        "server_name": {
                            "score": 1,
                            "value": null
                        },
                        "service_end_date": {
                            "score": 1,
                            "value": null
                        },
                        "service_start_date": {
                            "score": 1,
                            "value": null
                        },
                        "ship_date": {
                            "score": 1,
                            "value": null
                        },
                        "ship_to": {
                            "address": {
                            "score": 0.99,
                            "value": null
                            },
                            "name": {
                            "score": 0.99,
                            "value": null
                            },
                            "parsed_address": null
                        },
                        "shipping": {
                            "score": 1,
                            "value": null
                        },
                        "store_number": {
                            "bounding_region": [
                            0.644,
                            0.5024,
                            0.6826,
                            0.5024,
                            0.6826,
                            0.5117,
                            0.644,
                            0.5117
                            ],
                            "ocr_score": 0.78,
                            "rotation": 0,
                            "score": 0.87,
                            "value": "8096"
                        },
                        "subtotal": {
                            "bounding_region": [
                            0.9312,
                            0.4668,
                            0.9634,
                            0.4668,
                            0.9634,
                            0.4753,
                            0.9312,
                            0.4753
                            ],
                            "ocr_score": 0.98,
                            "rotation": 0,
                            "score": 0.91,
                            "value": 9.78
                        },
                        "tax": {
                            "bounding_region": [
                            0.9326,
                            0.4807,
                            0.9634,
                            0.4807,
                            0.9634,
                            0.49,
                            0.9326,
                            0.49
                            ],
                            "ocr_score": 1,
                            "rotation": 0,
                            "score": 0.96,
                            "value": 1.47
                        },
                        "tax_lines": [
                            {
                            "base": null,
                            "name": "VAT",
                            "order": 0,
                            "rate": 15,
                            "total": 1.47
                            }
                        ],
                        "tip": {
                            "score": 1,
                            "value": null
                        },
                        "total": {
                            "bounding_region": [
                            0.9263,
                            0.3955,
                            0.9634,
                            0.3955,
                            0.9634,
                            0.4041,
                            0.9263,
                            0.4041
                            ],
                            "ocr_score": 0.98,
                            "rotation": 0,
                            "score": 0.96,
                            "value": 11.25
                        },
                        "total_weight": {
                            "score": 1,
                            "value": null
                        },
                        "tracking_number": {
                            "score": 0.99,
                            "value": null
                        },
                        "updated_date": "2022-10-31 20:14:40",
                        "vendor": {
                            "abn_number": {
                            "score": 0.98,
                            "value": null
                            },
                            "account_number": {
                            "score": 1,
                            "value": null
                            },
                            "address": {
                            "score": 0.66,
                            "value": null
                            },
                            "bank_name": {
                            "score": 1,
                            "value": null
                            },
                            "bank_number": {
                            "score": 0.99,
                            "value": null
                            },
                            "bank_swift": {
                            "score": 1,
                            "value": null
                            },
                            "category": {
                            "value": null
                            },
                            "email": {
                            "bounding_region": [
                                0.7646,
                                0.1946,
                                0.9116,
                                0.1946,
                                0.9116,
                                0.2054,
                                0.7646,
                                0.2054
                            ],
                            "ocr_score": 0.97,
                            "rotation": 0,
                            "score": 0.88,
                            "value": "danube@danubeco.com"
                            },
                            "fax_number": {
                            "score": 1,
                            "value": null
                            },
                            "iban": {
                            "score": 0.99,
                            "value": null
                            },
                            "lat": 41.48,
                            "lng": -120.53,
                            "logo": "https://cdn.veryfi.com/logos/tmp/c4ad2c7e-09aa-4fec-9027-1cc9f672702f.png",
                            "name": {
                            "bounding_region": [
                                0.6558,
                                0.1544,
                                0.6558,
                                0.1455,
                                0.7261,
                                0.1455,
                                0.7261,
                                0.1544
                            ],
                            "ocr_score": 0.98,
                            "rotation": 0,
                            "score": 0.65,
                            "value": "Danube Co"
                            },
                            "phone_number": {
                            "bounding_region": [
                                0.6904,
                                0.5029,
                                0.7837,
                                0.5029,
                                0.7837,
                                0.5127,
                                0.6904,
                                0.5127
                            ],
                            "ocr_score": 0.98,
                            "rotation": 0,
                            "score": 0.82,
                            "value": "0128/017/457"
                            },
                            "raw_address": {
                            "score": 0.66,
                            "value": null
                            },
                            "raw_name": {
                            "bounding_region": [
                                0.6558,
                                0.1544,
                                0.6558,
                                0.1455,
                                0.7261,
                                0.1455,
                                0.7261,
                                0.1544
                            ],
                            "ocr_score": 0.98,
                            "rotation": 0,
                            "score": 0.65,
                            "value": "Danube Co"
                            },
                            "reg_number": {
                            "score": 0.98,
                            "value": null
                            },
                            "type": {
                            "value": null
                            },
                            "vat_number": {
                            "bounding_region": [
                                0.6694,
                                0.26,
                                0.8374,
                                0.26,
                                0.8374,
                                0.2734,
                                0.6694,
                                0.2734
                            ],
                            "ocr_score": 0.91,
                            "rotation": 0,
                            "score": 0.62,
                            "value": "31002558710003"
                            },
                            "web": {
                            "bounding_region": [
                                0.748,
                                0.2095,
                                0.873,
                                0.2095,
                                0.873,
                                0.2195,
                                0.748,
                                0.2195
                            ],
                            "ocr_score": 0.98,
                            "rotation": 0,
                            "score": 0.76,
                            "value": "www.danubeco.com"
                            }
                        }
                    }
                }
            }
          }
        },
        "responses": {
          "200": {
            "description": "OK",
            "content": {
              "application/json": {
                "example": {
                    "success": true,
                    "message": "Points added successfully!",
                    "earnPoints": 40
                }
              }
            }
          },
          "400": {
            "description": "Bad Request",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "415": {
            "description": "Unsupported Media Type",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorMessage"
                }
              }
            }
          },
          "500": {
            "description": "Internal Server Error",
            "content": {
              "*/*": {
                "schema": {
                  "$ref": "#/components/schemas/Problem"
                }
              }
            }
          }
        }
      }
    }
  },
  "components": {
    "securitySchemes": {
      "OktaAccessToken": {
        "type": "apiKey",
        "in": "header",
        "name": "okta-accesstoken",
        "description": "Customer Okta JWT or partner JWT. For partner requests, send the token issued for the configured partner client."
      },
      "PartnerApiKey": {
        "type": "apiKey",
        "in": "header",
        "name": "x-api-key",
        "description": "Configured partner API key associated with the SiteId."
      }
    },
    "schemas": {
      "Problem": {
        "type": "object",
        "properties": {
          "logRef": {
            "type": "string"
          },
          "message": {
            "type": "string"
          }
        }
      },
      "ErrorMessage": {
        "type": "object",
        "properties": {
          "errors": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        }
      }
    }
  }
};